 window.webLanguage = ['zh-CN', 'USA', 'JP', 'KO', 'TH','YH'];
 window.commonlanguage={
  'zh-CN':'简体中文 <span class="arrow"></span>',
  'USA':'English <span class="arrow"></span>',
  'JP':'日本語 <span class="arrow"></span>',
  'KO':'한국어 <span class="arrow"></span>',
  'TH':'ภาษาไทย <span class="arrow"></span>',
  'YH':'Tiếng Viê<span class="arrow"></span>',
}
 homePageTitle = {
      'zh-CN': '旅悦集团官网-花筑、蔚徕、索性、柏纳、beu酒店品牌',
      'USA': 'LvYue Group Official Website - HuaZhu, Vyluk, SuoXing, Urba, beu Hotel Brand',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    joinUsTitle = {
      'zh-CN': '酒店加盟优势/政策_热线/电话/流程/咨询-旅悦集团官网',
      'USA': 'Franchise& Cooperation - Floral Travel',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    panoramaListTitle = {
      'zh-CN': '旅悦全景列表-旅悦集团官网',
      'USA': 'LvYue Panorama List - Lvyue Group Official Website',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    panoramaListMeta = {
      'zh-CN': '旅悦全景展示，呈现旅悦集团多地酒店与度假场景的沉浸式视觉合集。',
      'USA': 'LvYue panorama collection presenting immersive hotel and resort scenes.',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    panoramaListKey = {
      'zh-CN': '旅悦全景,旅悦集团,酒店全景,度假场景,旅悦图片',
      'USA': 'LvYue panorama, hotel panorama, resort scenes, LvYue images',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    panoramaDetailTitle = {
      'zh-CN': '旅悦全景详情-旅悦集团官网',
      'USA': 'LvYue Panorama Detail - Lvyue Group Official Website',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    panoramaDetailMeta = {
      'zh-CN': '旅悦全景详情，纵向浏览旅悦集团精选场景与空间影像。',
      'USA': 'LvYue panorama detail page with vertical browsing and horizontal floors.',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    panoramaDetailKey = {
      'zh-CN': '旅悦全景详情,旅悦集团,酒店全景,场景展示,旅悦图片',
      'USA': 'LvYue panorama detail, hotel panorama, scene gallery, LvYue images',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    commonHomePage = {
      'zh-CN': '首页',
      'USA': 'Home Page',
      'JP': 'ホームページ',
      'KO': '홈페이지',
      'TH':'หน้าแรก',
      'YH':'Trang chủ',
    },
    commonPanorama = {
      'zh-CN': '旅悦全景',
      'USA': 'Panorama',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    commonLvyue = {
      'zh-CN': '旅悦集团',
      'USA': 'LvYue Group',
      'JP': '旅悦グループ',
      'KO': '뤼위에 그룹',
      'TH':'กลุ่มบริษัท LvYue',
      'YH':'Tập đoàn LvYue',
    },
    commonLvyue1 = {
      'zh-CN': '旅悦集团 <span class="arrow"></span>',
      'USA': 'LvYue Group <span class="arrow"></span>',
      'JP': '旅悦グループ <span class="arrow"></span>',
      'KO': '뤼위에 그룹 <span class="arrow"></span>',
      'TH':'กลุ่มบริษัท LvYue <span class="arrow"></span>',
      'YH':'Tập đoàn LvYue <span class="arrow"></span>',
    },
    commonAboutLvyue={
      'zh-CN': '关于旅悦',
      'USA': 'About LvYue Group',
      'JP': '旅悦について',
      'KO': 'LvYue에 대하여',
      'TH':'เกี่ยวกับกลุ่มบริษัท LvYue',
      'YH':'Chúng tôi là ai',
    },
    commonlvyueBrand={
      'zh-CN': '旅悦品牌 <span class="arrow"></span>',
      'USA': 'LvYue Brands <span class="arrow"></span>',
      'JP': '旅悦のブランド <span class="arrow"></span>',
      'KO': '뤼위에 브랜드 <span class="arrow"></span>',
      'TH':'แบรนด์ LvYue <span class="arrow"></span>',
      'YH':'Thương hiệu LvYue <span class="arrow"></span>',
    },
    commonFlowerConstruction={
      'zh-CN': '花筑',
      'USA': 'Floral',
      'JP': '花築',
      'KO': '플로라',
      'TH':'Floral',
      'YH':'Floral',
    },
    commonFloralLux={
      'zh-CN': '花筑奢',
      'USA': 'Floral Lux',
      'JP': '花筑奢',
    },
    commonClaim={
      'zh-CN': '索性',
      'USA': 'Suoxing',
      'JP': '索性',
      'KO': 'Suoxing',
      'TH':'Suoxing',
      'YH':'Suoxing',
    },
    commonWeiLai={
      'zh-CN': '蔚徕',
      'USA': 'Vyluk',
      'JP': '蔚徕',
      'KO': 'Vyluk',
      'TH':'Vyluk',
      'YH':'Vyluk',
    },
    commonTanChen={
      'zh-CN': '檀程',
      'USA': 'Arula',
      'JP': '檀程',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    commonClaimChoice={
      'zh-CN': '索性精选',
      'USA': 'Banlan',
      'JP': '般蓝',
      'KO': 'Banlan',
      'TH':'Banlan',
      'YH':'Banlan',
    },
    commonBaina={
      'zh-CN': '柏纳',
      'USA': 'Urba',
      'JP': '柏纳',
      'KO': 'Urba',
      'TH':'Urba',
      'YH':'Urba',
    },
    commonArulas= {
      'USA': 'Arula Hotels & Resorts',
      'JP': '檀程',
      'KO': 'Arula',
      'TH':'Arula',
      'YH':'Arula',
    }
    commonBeu={
      'zh-CN': 'beu',
      'USA': 'beu',
      'JP': 'beu',
      'KO': 'beu',
      'TH':'beu',
      'YH':'beu',
    },
    commonBeuDes={
      'zh-CN': 'India Business Chain Hotel',
      'USA': 'India Business Chain Hotel',
      'JP':'エコノミーホテル',
    },
    commonflowerTravel={
      'zh-CN': '花筑旅行',
      'USA': 'Floral Trip APP',
      'JP': '花築旅行',
      'KO': '플로라 트립 APP',
      'TH':'Floral Trip',
      'YH':'Floral Trip',
    },
    commonJoinInCooperation={
      'zh-CN': '加盟合作',
      'USA': 'Franchise & Cooperation',
      'JP': '加盟連携',
      'KO': '프랜차이즈 가맹',
      'TH':'แฟรนไชส์ & ความร่วมมือ',
      'YH':'Hợp tác cùng phát triển',
    },
    commonPaidInformation={
      'zh-CN': '付费资讯',
      'USA': 'Paid Information',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    commonZh={
      'zh-CN': '简体中文',
      'USA': '简体中文',
      'JP': '简体中文',
      'KO': '简体中文',
      'TH':'简体中文',
      'YH':'简体中文',
    },
    commonUsa={
      'zh-CN': 'English',
      'USA': 'English',
      'JP': 'English',
      'KO': 'English',
      'TH':'English',
      'YH':'English',
    },
    commonJp={
      'zh-CN': '日本語',
      'USA': '日本語',
      'JP': '日本語',
      'KO': '日本語',
      'TH':'日本語',
      'YH':'日本語',
    },
    commonKo={
      'zh-CN': '한국어',
      'USA': '한국어',
      'JP': '한국어',
      'KO': '한국어',
      'TH':'한국어',
      'YH':'한국어',
    },
    commonTh={
      'zh-CN': 'ภาษาไทย',
      'USA': 'ภาษาไทย',
      'JP': 'ภาษาไทย',
      'KO': 'ภาษาไทย',
      'TH':'ภาษาไทย',
      'YH':'ภาษาไทย',
    },
    commonYh={
      'zh-CN': 'Tiếng Viê',
      'USA': 'Tiếng Viê',
      'JP': 'Tiếng Viê',
      'KO': 'Tiếng Viê',
      'TH':'Tiếng Viê',
      'YH':'Tiếng Viê',
    },
    commonReservations={
      'zh-CN': '预订酒店',
      'USA': 'Reservation',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    commonClose={
      'zh-CN': '关闭',
      'USA': 'Close',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    commonFreebooking={
      'zh-CN': '免费订房热线',
      'USA': 'Free Booking Hotline',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    commonDownload={
      'zh-CN': '下载花筑旅行APP预订酒店',
      'USA': 'Download Floral Travel APP for Hotel Reservation',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    commonWechatSubscription={
      'zh-CN': '关注花筑旅行公众账号',
      'USA': 'Follow Floral Travel on Wechat',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    commonHuazhuSubscription={
      'zh-CN': '花筑旅行微信公众号',
      'USA': 'Floral Travel Wechat ID',
      'JP': '花築旅行ウィーチャットID',
      'KO': '플로라 트립 윗채 공식계정',
      'TH':'Wechat ID ของ Floral Travel',
      'YH':'Mã ID Wehcat của Floral Travel',
    },
    commonBrandintroductio={
      'zh-CN': '品牌介绍',
      'USA': 'About the Brand',
      'JP': 'ブランドについて',
      'KO': 'LvYue 브랜드 소개',
      'TH':'เกี่ยวกับแบรนด์',
      'YH':'Về thương hiệu',
    },
    commonWantJoin={
      'zh-CN': '我要加盟',
      'USA': 'Join Us',
      'JP': '業務連絡',
      'KO': '뤼위에 가입하기',
      'TH':'เข้าร่วมกับเรา',
      'YH':'Hãy tham gia với chúng tôi',
    },
    commonConectUs={
      'zh-CN': '联系我们',
      'USA': 'Contact Us',
      'JP': 'お問い合わせ',
      'KO': '회사 연락처',
      'TH':'ติดต่อเรา',
      'YH':'Liên hệ với chúng tôi',
    },
    commonCustomerServiceHotline={
      'zh-CN': '客服热线：',
      'USA': 'Customer Service Hotline：',
      'JP': 'サービス電話',
      'KO': '고객 서비스 전화',
      'TH':'โทรศัพท์',
      'YH':'Đường dây nóng Dịch vụ chăm sóc khách hàng ',
    },
    commonCustomerServiceHotlineChina={
      'zh-CN': '400-898-7118',
      'USA': 'China: 400-898-7118'
    },
    commonCustomerServiceHotlinePhilippines={
      'USA': 'Philippines: 028-3987964'
    },
    commonCustomerServiceHotlineJapan={
      'USA': 'Japan: 06-4256-2628',
      'JP': '06-4256-2628'
    },
    commonCustomerServiceHotlineKorea={
      'USA': 'Korea: 070-4919-7035',
      'KO': '070-4919-7035'
    },
    commonCustomerServiceHotlineThailand={
      'USA': 'Thailand: 66-53-326-214',
      'TH': '66-53-326-214'
    },
    commonCustomerServiceHotlineYh={
      'YH':'400-898-7118'
    },
    commonCompanyInfo={
      'zh-CN': '旅悦旅游信息技术（北京）有限公司 丨 北京市海淀区永定路88号12层B03 丨 邮编：100039 丨 备案号：',
      'USA': 'LvYue Travel Information Technology (Beijing) Co., Ltd. 丨 12th Floor, No. 88, Yongding Road, Haidian District, Beijing，China | Post Code 100039 | Record Number: ',
      'JP': '旅悦旅游信息技术（北京）有限公司 中国北京海淀区永定路88号12层B03  郵便番号：100039  レコード番号：北京ICP番号',
      'KO': '뤼위에트립정보기술(베이징)유한회사  중국 베이징 해정구 서소구길66번 동성과학원 A1빌딩 3층 우편번호 100080 등록번호',
      'TH':'LvYue Travel Information Technology (Beijing) Co., Ltd. 丨ชั้น 3 อาคาร A1, Dongsheng Technology Park, 66 Xixiaokou Road, Haidian District, Beijing 100080, , P.R. China 丨 Registered No.:',
      'YH':'LvYue Travel Information Technology (Beijing) Co., Ltd. 丨 Tầng 3, Tòa nhà A1, Khu công nghệ Dongsheng, 66 Đường Xixiaokou, Quận Haidian, Bắc Kinh 100080, CHND Trung Hoa 丨 Số đăng ký.:',
    },
    commonCompanyBeianInfo={
      'zh-CN': '京ICP备17066056号',
      'USA': 'BJ ICP Reg. No. 17066056',
      'JP': '17066056-1',
      'KO': '17066056-1',
      'TH': 'BJ ICP Reg. No. 17066056',
      'YH': 'BJ ICP Reg. Số Reg. 17066056',
    },
    commonCompanyBeianText={
      'zh-CN': '京公网安备 11010802034175号',
      'USA': '',
      'JP': '',
      'KO': '',
      'TH': '',
      'YH': '',
    }
    commonCompanyLicense={
      'zh-CN': '经营执照',
      'USA': '',
      'JP': '',
      'KO': '',
      'TH': '',
      'YH': '',
    }
    commonCompanyICP={
      'zh-CN': 'ICP证：京B2-20182118',
      'USA': '',
      'JP': '',
      'KO': '',
      'TH': '',
      'YH': '',
    }
    commonCompanyCubmitSuccess={
      'zh-CN': '提交成功',
      'USA': 'Submitted',
      'JP': '提出済み',
      'KO': '제출',
      'TH':'ส่งเรียบร้อยแล้ว',
      'YH':'Gửi thành công',
    },
    commonCompanyCubmitFail={
      'zh-CN': '提交失败',
      'USA': 'Submission Failed',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    homePageSwiperOneTitle={
      'zh-CN': '旅至美 悦于宿',
      'USA': 'Splendid Scenery, Joyful Stay',
      'JP': '素晴らしい景色、楽しい滞在',
      'KO': '화련한 풍경, 즐거운 숙박',
      'TH':'ทิวทัศน์อันงดงาม ที่พักอันแสนสุข',
      'YH':'Phong cảnh tráng lệ, Nghỉ dưỡng vui vẻ',
    },
    homePageSwiperTwoTitle={
      'zh-CN': '我们的环境',
      'USA': 'Our Environment',
      'JP': '環境',
      'KO': '환경',
      'TH':'สภาพแวดล้อมของเรา',
      'YH':'Môi trường của chúng tôi',
    },
    homePageSwiperThreeTitle={
      'zh-CN': '我们的足迹',
      'USA': 'Our Network',
      'JP': '私たちの足跡',
      'KO': '족적',
      'TH':'รอยเท้าของเรา',
      'YH':'Khách sạn của chúng tôi đang ở đâu?',
    },
    homePageSwiperThreeInfo={
      'zh-CN': '旅悦集团已在全球签约、开业超过2000家酒店，遍布包括日本、韩国、泰国、印度、新西兰、澳大利亚等在内的全球10余个国家的200多个目的地',
      'USA': 'The LvYue Group has brought more than 2000 hotels worldwide into its network, covering more than 200 destinations in more than 10 countries including China, Japan, South Korea, Thailand, India, New Zealand and Australia. ',
      'JP': '弊社グループは、既に世界中に2000棟のホテルを開業致しました。日本、韓国、タイ、インド、ニュージーランド、オーストラリアなど10か国以上に200以上の目的地をカバーしており',
      'KO': 'LvYue그룹은 일본,한국,태국,인도,뉴질랜드,호주포함 10여개국,200여개지역에서 2000개호텔을 계약 및 오픈 하였으며, ',
      'TH':'กลุ่มบริษัท LvYue ได้ลงทะเบียนและเปิดโรงแรมมากกว่า 2000 แห่งทั่วโลก ครอบคลุมมากกว่า 200 จุดหมายปลายทางในมากกว่า 10 ประเทศ รวมถึงญี่ปุ่น เกาหลีใต้ ไทย อินเดีย นิวซีแลนด์ ออสเตรเลีย ฯลฯ',
      'YH':'Chúng tôi đang có hơn 2000 khách sạn trên toàn thế giới, với hơn 200 điểm đến ở hơn 10 quốc gia như  nhật bản, hàn quốc, thái lan, ấn độ, new zealand, úc,',
    },
    homePageSwiperThreeOpenedArea={
      'zh-CN': '已开业地区',
      'USA': 'Open',
      'JP': '開業エリア',
      'KO': '오픈 지역',
      'TH':'เขตที่เปิดให้บริการ',
      'YH':'Các khu vực đã mở',
    },
    homePageSwiperTobeOpenedArea={
      'zh-CN': '待开业地区',
      'USA': 'Upcoming ',
      'JP': '今後の開業エリア',
      'KO': '오픈준비 지역',
      'TH':'เขตที่จะเปิดให้บริการ',
      'YH':'Các khu vực sắp mở',
    },
    homePageSwiperThreeKohSamui={
      'zh-CN': '苏梅岛',
      'USA': 'Koh Samui',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    homePageSwiperThreeBeijing={
      'zh-CN': '北京',
      'USA': 'Beijing',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    homePageSwiperThreeNanjing={
      'zh-CN': '南京',
      'USA': 'Nanjing',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    homePageSwiperThreeMoganmountain={
      'zh-CN': '莫干山',
      'USA': 'Mount Mogan',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    homePageSwiperThreeNanxun={
      'zh-CN': '南浔',
      'USA': 'Nanxun',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    homePageSwiperThreeAnji={
      'zh-CN': '安吉',
      'USA': 'Anji',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    homePageSwiperThreeSeoul={
      'zh-CN': '首尔',
      'USA': 'Seoul',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeChiangmai={
      'zh-CN': '清迈',
      'USA': 'Chiangmai',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':'',
    },
    homePageSwiperThreeXishuangbanna={
      'zh-CN': '西双版纳',
      'USA': 'Xishuangbanna',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeDali={
      'zh-CN': '大理',
      'USA': 'Dali',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeLijiang={
      'zh-CN': '丽江',
      'USA': 'Lijiang',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeChongqie={
      'zh-CN': '重庆',
      'USA': 'Chongqing',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeLangzhonge={
      'zh-CN': '阆中',
      'USA': 'Langzhong',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeGuohuang={
      'zh-CN': '敦煌',
      'USA': 'Dunhuang',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeLibo={
      'zh-CN': '荔波',
      'USA': 'Libo',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeZhangjiajie={
      'zh-CN': '张家界',
      'USA': 'Zhangjiajie',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeHuangshan={
      'zh-CN': '黄山',
      'USA': 'Mount Huang',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeHangzhou={
      'zh-CN': '杭州',
      'USA': 'Hangzhou',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeChejudo={
      'zh-CN': '济州岛',
      'USA': 'Jeju',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeFenghuang={
      'zh-CN': '凤凰',
      'USA': 'Fenghuang',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeSemporna={
      'zh-CN': '仙本那',
      'USA': 'Semporna',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeWuzhen={
      'zh-CN': '乌镇',
      'USA': 'Wuzhen',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeSuzhou={
      'zh-CN': '苏州',
      'USA': 'Suzhou',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeGuilin={
      'zh-CN': '桂林',
      'USA': 'Guilin',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeWulong={
      'zh-CN': '武隆',
      'USA': 'Wulong',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeXian={
      'zh-CN': '西安',
      'USA': "Xi'an",
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreePingyao={
      'zh-CN': '平遥',
      'USA': 'Pingyao',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeXiamen={
      'zh-CN': '厦门',
      'USA': 'Xiamen',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeLishui={
      'zh-CN': '丽水',
      'USA': 'Lishui',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeXitang={
      'zh-CN': '西塘',
      'USA': 'Xitang',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeSingapore={
      'zh-CN': '新加坡',
      'USA': 'Singapore',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeKualaLumpur={
      'zh-CN': '吉隆坡',
      'USA': 'Kuala Lumpur',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreePenang={
      'zh-CN': '槟城',
      'USA': 'Penang',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreePhuket={
      'zh-CN': '普吉岛',
      'USA': 'Phuket ',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeLangkawi={
      'zh-CN': '兰卡威',
      'USA': 'Langkawi',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreePhnomPenh={
      'zh-CN': '金边',
      'USA': 'Phnom Penh',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeKotaKinabalu={
      'zh-CN': '哥打京那巴鲁',
      'USA': 'Kota Kinabalu',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreePattaya={
      'zh-CN': '芭提雅',
      'USA': 'Pattaya',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeBangkok={
      'zh-CN': '曼谷',
      'USA': 'Bangkok',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeSiemReap={
      'zh-CN': '暹粒',
      'USA': 'Siem Reap',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeNhaTrang={
      'zh-CN': '芽庄',
      'USA': 'Nha Trang',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeDaNang={
      'zh-CN': '岘港',
      'USA': 'Da Nang',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeCebu={
      'zh-CN': '宿务',
      'USA': 'Cebu',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeBoracayIsland={
      'zh-CN': '长滩岛',
      'USA': 'Boracay Island',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeManila={
      'zh-CN': '马尼拉',
      'USA': 'Manila',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeHanoi={
      'zh-CN': '河内',
      'USA': 'Hanoi',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeHongKong={
      'zh-CN': '香港',
      'USA': 'Hong Kong',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeKaohsiung={
      'zh-CN': '高雄',
      'USA': 'Kaohsiung',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeHualian={
      'zh-CN': '花莲',
      'USA': 'Hualien',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeTaipei={
      'zh-CN': '台北',
      'USA': 'Taipei',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeTengchong={
      'zh-CN': '腾冲',
      'USA': 'Tengchong',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeShangriLa={
      'zh-CN': '香格里拉',
      'USA': 'Shangri-La',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeWuyiMount={
      'zh-CN': '武夷山',
      'USA': 'Mount Wuyi',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeJiaxing={
      'zh-CN': '嘉兴',
      'USA': 'Jiaxing',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeRizhao={
      'zh-CN': '日照',
      'USA': 'Rizhao',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeBusan={
      'zh-CN': '釜山',
      'USA': 'Busan',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeOsaka={
      'zh-CN': '大阪',
      'USA': 'Osaka',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeTokyo={
      'zh-CN': '东京',
      'USA': 'Tokyo',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreekyoto={
      'zh-CN': '京都',
      'USA': 'Kyoto',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperThreeXinzhou={
      'zh-CN': '忻州',
      'USA': 'Xinzhou',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperFourTitle={
      'zh-CN': '我们的品牌',
      'USA': 'Our Brands',
      'JP': 'ブランド',
      'KO': 'LvYue 브랜드',
      'TH':'แบรนด์ของเรา',
      'YH':'Thương hiệu của chúng tôi'
    },
    homePageSwiperFourBrandintroduction={
      'zh-CN': '品牌介绍：',
      'USA': 'About the Brands：',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperBrandintroductionInof1={
      'zh-CN': '花筑是以独特美学、在地体验、用心服务为特色的全球品质民宿酒店领军品牌，比酒店更个性，比民宿更专业。目前已有签约开业门店超过1700家，累计接待超过1000万人入住。\<br>每一处花筑都是独一无二高颜值的作品，融合了在地文化，设计充满地域氛围，或藏于古镇，或坐落在山间及湖边，融合了主人的梦、当地的情、天然的景，是真正适合现代都市旅客，追求返璞归真的理想住所。',
      'USA': 'Floral brand features unique aesthetics,local experience and attentive services.It is more welcoming than traditional chain hotels and more professtional than homestay. At present, Floral has more 1700 hotels wordwide (mainly in China,Japan, Philippines, Korea, Thailand ) and has welcomed more than 10 million guests. <br />Each Floral hotel is a unique and delicately beautiful worl. It integrates local culture and atmosphere. It can be hidden in the ancient towm,or located in the mountains by the lake. It blends the owner’s dream, local feelings, and nature into the guests’ stays, whice is an ideal experience that is truly suitable for modern urban travellers who seeks to return to nature. Caring for guests with our 7 senses’ service philosophy,we immerse our travellers in luxury, including a one-to-one butler service and customised experiences.',
      'JP': '花築ホテルは、世界の隅々まで絶好な景色を探し、旧市街や山奥、湖周辺に隠れているユニークなアドレスを選定し開店。旅行者に満足して頂けるよう、各ホテルは地元の文化、デザインと雰囲気を組み合わせ、温かい特別なサービスを感じさせます。',
      'KO': '플로라호텔은 세계각지에서 경치를 위주로하는 지역을 찾고있다. 어느한 호텔이든 현지 인문환경의 특색들을 본따서 디자인에 융합시키거나 열정,따뜻함,차별화된 서비스를 고객들에게 제공하고 있다.',
      'TH':'Floral Hotel เป็นแบรนด์โรงแรมบูติกแห่งแรกของกลุ่มบริษัท LvYue มุ่งมั่นที่จะสร้างรีสอร์ทที่เต็มไปด้วยอัตลักษณ์ทางวัฒนธรรม ซึ่งให้บริการทั้งเจ็ดสัมผัส โรงแรมFloral แบ่งออกเป็นสี่แบรนด์ย่อย ได้แก่ Floral- City Floral-Joy Floral และ Floral-Lux',
      'YH':'Dưỡng cửa hàng đầu tiên…floralvà floral lux cẩn sửa lại là Floral là thương hiệu khách sạn đầu tiên của chúng tôi. Với mong muốn tạo ra không gian có sự hòa quyện giữa nền văn hóa địa phương với  dịch vụ  7 giác quan, nhằm  mang đến sự trải nghiệm tuyệt vời nhất cho du khách. Khách sạn Floral được chia thành 4 thương hiệu:  Floral - city, Floral – Joy, Floral và Floral – lux.'
    },
    homePageSwiperBrandintroductionInof10={
      'zh-CN': '2017年初，为进军高端度假民宿领域，花筑高阶品牌系列——「花筑奢」应运而生，致力于打造融合地缘文化与奢华体验的理想空间。未至之境，宿之大雅。凭借绝妙风景与精致体验，花筑奢为旅行者创造了理想的度假生活。通过十七个精心设计的服务触点和细化的服务标准，花筑奢最大限度将高端酒店服务与地方人文体验融会贯通，构筑起风景与人情间的温情链接，打造令人神往的美好度假场景。',
      'USA': 'Floral Lux Hotel, established in 2017, is a luxury resort brand dedicated to redefining premium travel experiences. Combining stunning natural landscapes with refined hospitality, Floral Lux Hotel offers travelers an idyllic retreat that seamlessly blends high-end services with authentic local culture. The brand creates a heartfelt connection between breathtaking scenery and the warmth of human interaction, crafting unforgettable vacation moments. With a portfolio of over 100 boutique resorts across 50 cities in China, Floral Lux Hotel celebrates the unique charm of each location. Every Floral Lux Hotel property is a one-of-a-kind masterpiece, every property is deeply rooted in its local culture, transforming traditional architecture into extraordinary spaces that reflect the essence of their surroundings.',
      'JP': '花築ホテルは、世界の隅々まで絶好な景色を探し、旧市街や山奥、湖周辺に隠れているユニークなアドレスを選定し開店。旅行者に満足して頂けるよう、各ホテルは地元の文化、デザインと雰囲気を組み合わせ、温かい特別なサービスを感じさせます。',
      'KO': '플로라호텔은 세계각지에서 경치를 위주로하는 지역을 찾고있다. 어느한 호텔이든 현지 인문환경의 특색들을 본따서 디자인에 융합시키거나 열정,따뜻함,차별화된 서비스를 고객들에게 제공하고 있다.',
      'TH':'Floral Hotel เป็นแบรนด์โรงแรมบูติกแห่งแรกของกลุ่มบริษัท LvYue มุ่งมั่นที่จะสร้างรีสอร์ทที่เต็มไปด้วยอัตลักษณ์ทางวัฒนธรรม ซึ่งให้บริการทั้งเจ็ดสัมผัส โรงแรมFloral แบ่งออกเป็นสี่แบรนด์ย่อย ได้แก่ Floral- City Floral-Joy Floral และ Floral-Lux',
      'YH':'Dưỡng cửa hàng đầu tiên…floralvà floral lux cẩn sửa lại là Floral là thương hiệu khách sạn đầu tiên của chúng tôi. Với mong muốn tạo ra không gian có sự hòa quyện giữa nền văn hóa địa phương với  dịch vụ  7 giác quan, nhằm  mang đến sự trải nghiệm tuyệt vời nhất cho du khách. Khách sạn Floral được chia thành 4 thương hiệu:  Floral - city, Floral – Joy, Floral và Floral – lux.'
    },
    homePageSwiperFourDesignidea={
      'zh-CN': '设计理念：',
      'USA': 'Design Philosophy：',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperFourDesignideaInfo1={
      'zh-CN': '全球品质民宿酒店',
      'USA': 'International Quality Boutique Hotel Brand',
      'JP': 'グローバル品質民泊ホテル',
      'KO': '부티크 호텔 & 리조트',
      'TH':'โรงแรมและรีสอร์ทบูติคฮอลิเดย์',
      'YH':'Các khách sạn & khu nghỉ dưỡng cỡ nhỏ'
    },
    homePageSwiperFourSite={
      'zh-CN': '场',
      'USA': 'Site',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperFourView={
      'zh-CN': '景：',
      'USA': 'View：',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperFourBusinesstrip={
      'zh-CN': '净如索性   随心而居',
      'USA': 'Smart Rates for Smart Travellers.',
      'JP': '清潔＆手頃な価格がお好みの旅行者向けです',
      'KO': '소성처럼 깔끔하고 마음에 따라서 몪는다',
      'TH':'สำหรับนักท่องเที่ยวที่รักความเรียบร้อย & ราคาประหยัด',
      'YH':'Dành cho du khách yêu thích sự gọn gàng & giá rẻ'
    },
    homePageSwiperFourBrandintroductionInof2={
      'zh-CN': '为满足⽤户个性化、品质化、多元化、社交化、共享化等多维度的入住需求，Vyluk蔚徕酒店遴选城市核心地块，塑造城市酒店新风向。\<br>设计上，注重⽣活⽅式的营造与细节的打磨，不仅为客人在客房提供安眠、影⾳及舒适的空间体验，同时酒店公共空间可以实现多功能转换，不仅有效提高空间的利用性，更实现了生活与酒店共享空间的完美集合。<br>链接一切美好，以不凡见未来',
      'USA': 'Based in city hotspots, Vyluk is a new style of urban hotel, welcoming guests who seek more than just a cosy room and restaurant. Innovative and tech-friendly, with multifunctional, convertible spaces designed for a versatile lifestyle, Vyluk Hotels provide practical, clean, comfortable and convivial environments for creative meetings, relaxation and social gatherings. ',
      'JP': '蔚徕とは、ブランド本来のデザイン意図として夢の相互作用をし、人工知能とホテル融合を探求する実践者です。蔚徕は街の中心的なエリアを選択し、デザインはモダニズムスタイルを採用し、多数のスマートなインタラクティブ機器を配置し、ホテルの備品は5つ星ホテルと同じ仕様であり、お客様の旅にはスマート、健康、安全、面白く体験でき、忙しいビジネス旅の中でもリラックスできるお寛ぎ空間を提供しています。',
      'KO': '현시대 고객들이 품질,커뮤니케이션,차별화에 대한 부동한 욕구에 적응하기위하여Vyluk는 도시의 핵심지역을 선택하여 씨티형호텔의 새로운 표준을 만들려고한다.설계단계부터 숙박+커뮤니케이션이라는 주제에 포인트를 두어 고객들이 객실내에서의 편안한 휴식뿐만아니라 호텔 퍼블릭지역에도 휴식뿐만 아닌 기타 기능을 부여하여건축공간의 이용율을 상승시키고 숙박에 라이프라는 새로운 개념을 주입시켰다',
      'TH':'ตั้งอยู่ในจุดฮิตในเมือง Vyluk เป็นเทรนด์ใหม่ของโรงแรมในเมืองที่ต้อนรับแขกที่กำลังมองหาโรงแรมที่สะดวกสบายซึ่งมากกว่าห้องพักและร้านอาหาร วางแผนเพื่อชีวิตที่หลากหลายด้วยนวัตกรรมใหม่ เทคโนโลยีที่เป็นมิตร และพื้นที่อเนกประสงค์ โรงแรม Vyluk สร้างสภาพแวดล้อมที่สะอาด สะดวกสบายและสนุกสนาน สำหรับผู้ที่มองหาที่ประชุมสร้างสรรค์ ที่พักผ่อนหรือที่สังสรรค์ทางสังคม  ',
      'YH':'Chúng tôi có mặt ở  trung tâm của thành phố. Vyluk là 1 xu hướng mới của khách sạn đô thị, với không gian chuyển đổi sáng tạo, thân thiện với công nghệ và đa chức năng được tưởng tượng cho một sống linh hoạt. Khách sạn Vyluk cung cấp một môi trường thiết thực, sạch sẽ, thoải mái và hấp dẫn cho những người tìm kiếm cuộc họp sáng tạo, thư giãn hoặc tụ tập xã hội.'
    },
    homePageSwiperFourDesignideaInfo2={
      'zh-CN': '新一代生活方式中端城市酒店',
      'USA': 'Mid-range City Hotel',
      'JP': '次世代ライフスタイルシティホテル',
      'KO': '미들급 시티호텔',
      'TH':'โรงแรมในเมืองระดับกลาง',
      'YH':'Khách sạn thành phố tầm trung'
    },
    homePageSwiperFourTourismVacationSocialBusiness={
      'zh-CN': '蔚徕酒店·链接一切美好，以不凡见未来',
      'USA': ' Vyluk Hotel - For a New-Generation Lifestyle ',
      'JP': '蔚徕はすべての美しく連接し、並外れた未来を見る',
      'KO': 'Vyluk호텔 - 신세대 생활패턴 호텔',
      'TH':'Vyluk Hotel - สำหรับไลฟ์สไตล์ยุคใหม่',
      'YH':'Khách sạn Vyluk – Khách sạn lối sống của một thời đại mới'
    },

    homePageSwiperFourBrandintroductionInof4={
      'zh-CN': '考虑到当今休闲和商务旅客的需求，我们确保酒店的现代化设施拥有所有的必备条件，为您提供高性价比的住宿体验，带来无与伦比的舒适享受。 \n' +
          '每一家索性精选酒店的设计都各有特色，每一家索性精选酒店的品质与服务都始终如一。\n' +
          '每一天，我们团队的服务都致力于为客人带来不同体验。我们积极的态度、体贴的关注以及发自内心的微笑，是让客人在熙熙攘攘的城市喧嚣中享受愉快住宿体验的关键。 ',
      'USA': "Banlan is committed to subverting people's traditional perception of high-star hotels, building a retrograded space of noisy world in the core area of the city, and creating a different mood between entering and exiting of the world. Banlan deconstructs and integrates oriental cultural elements and the beauty of nature, with indifferent and elegant aesthetic design, dynamic and static space planning, and full-view immersive atmosphere creation, which temporarily pulls people away from the busyness, relaxes their body and mind, and fully feels the stay experience of \"far from the heart\", awakens the senses and mind, and rejuvenates in a different parallel space. Entering is joyful, and exiting is full of prosperity",
      'JP': '般蓝は、伝統的な高級ホテルの認識を覆し、街の中心部に華やかなレトログラードスペースを構築し、出世から入世までの様々なムードを作り出すことに取り組んでいます。般蓝は、東洋の文化的な要素と自然の美しさを統合し、エレガントな美的デザイン、動と静な空間計画、没入型の雰囲気を作成し、忙しい日々を引き離し、体と心をリラックスさせ、「心远地自偏」との宿泊体験し、感覚と心を目覚めさせ、別の平行した空間で活躍させます。',
      'KO': '현재 비지니스나 투어관광객들의 디테일한 수요를 고려해 우리의 호텔이 그욕구들을 만족시킬 모든 현대화시설이 구비되기를 확보하여 고객들에게 고 가성비와 유쾌한 경험을 드릴려고 한다.부동한 인테리어 스타일,변함이 없는것은 우리의 고 퀄리티 서비스이다 .하루같이 변함이 없는 열정과 따뜻함이 넘치는 서비스로 고객들로 하여금 분잡한 도시환경속에서 유쾌한 숙박추억을 느끼게한다.',
      'TH':'เพื่อตอบสนองความต้องการของนักเดินทางเพื่อธุรกิจและการพักผ่อนในปัจจุบัน เราได้จัดสิ่งอำนวยความสะดวกที่ทันสมัย และมั่นใจว่าสามารถตอบโจทย์ทุกความจำเป็น เพื่อการพักอาศัยในราคาที่ไม่แพงและสะดวกสบายพร้อมสัมผัสความสนุกที่ไม่เหมือนใครทัศนคติเชิงบวก การเอาใจใส่อย่างมืออาชีพ และรอยยิ้มจากหัวใจของเราเป็นกุญแจสำคัญที่จะทำให้แขกของเราเพลิดเพลินกับการพักอย่างรื่นรมย์ในเมืองที่วุ่นวาย',
      'YH':'Với yêu cầu ngày càng cao của khách du lịch, chúng tôi  tự hào rằng các cơ sở hiện đại của chúng tôi  sẽ đảm bảo cho bạn có 1 kỳ nghỉ  tuyệt vời, không thể nhầm lẫn với mức giá cả phải chăng. Thái độ tích cực và sự chuyên nghiệp của chúng tôi được làm giàu bằng những nụ cười từ trái tim là chìa khóa thu hút khách với một kỳ nghỉ dễ chịu được bảo vệ khỏi thành phố nhộn nhịp.'
    },
    homePageSwiperFourDesignideaInfo4={
      'zh-CN': '中档商务酒店',
      'USA': 'Seclusion Design Hotel',
      'JP': '隠された世界のホテル',
      'KO': '미들급 비즈니스 호텔',
      'TH':'โรงแรมธุรกิจระดับกลาง',
      'YH':'Khách sạn cho Doanh nhân Tầm trung'
    },
    homePageSwiperFourMotto4={
      'zh-CN': '索性精选，品质之选',
      'USA': '',
      'JP': '入るのは楽しいし、出るのは繁栄に満ちている',
      'KO': '스마트 선택',
      'TH':'สนุกอย่างชาญฉลาด',
      'YH':'Tận hưởng một cách thông minh'
    },
    homePageSwiperFourBrandintroductionInof5={
      'zh-CN': '柏纳酒店聚焦商旅客人对酒店的核心诉求，提供舒适和实用之间的微妙平衡，专注舒适的环境和一流的服务。\<br>每一家柏纳酒店都是独一无二的，所有酒店都致力于为客人提供舒适的环境和一流的服务，以满足客人真正需要的高品质标准。',
      'USA': 'With a subtle balance of comfort and practicality, Urba Hotels welcome their guests with flexible and modern spaces designed to melt away the stress of travel.  Our hotels focus on the most important needs of business travellers, delivering upscale quality facilities and services. While every Urba hotel is unique, all thrive to deliver a cosy environment and first-class service to guests seeking a high standard of quality in the things they really need.',
      'JP': '柏纳ホテルは、ホテルに対するビジネス旅行者のコアな要求を中心し、快適な環境と一流のサービスに焦点を当て、快適さと実用性なバランスを重視します。 すべての柏纳ホテルはユニークであり、お客様に高水準のサービス品質を提供し、快適な環境と一流のサービスをお客様に提供するよう努めています。',
      'KO': 'Urba호텔은 비지니스손님들이 호텔에 대한 핵심적인 요구를 반영하여 실용성과 편안함을 결합시키고 최고의 서비스를 제고해준다.모든 호텔은 독보적이고 고객에게 최상의 환경과 일류의 서비스를 제공해준다',
      'TH':'ด้วยความสมดุลระหว่างความสะดวกสบายและความเหมาะสมแก่การใช้งานจริง  โรงแรม Urba ยินดีต้อนรับแขกทุกท่านด้วยพื้นที่ที่ยืดหยุ่นและทันสมัยเพื่อเติมความละมุนละไมแก่การเดินทางของท่าน โรงแรมของเรามุ่งเน้นที่ความต้องการที่สำคัญที่สุดของนักธุรกิจมอบสิ่งอำนวยความสะดวกและบริการที่มีคุณภาพสูง โรงแรม Urba ทุกแห่งนั้นมีเอกลักษณ์ และโรงแรมทุกแห่งมุ่งมั่นที่จะมอบสภาพแวดล้อมที่สะดวกสบายและบริการชั้นนำเพื่อให้ได้มาตรฐานคุณภาพสูงที่แขกต้องการอย่างแท้จริง',
      'YH':'Với sự cân bằng giữa sự thoải mái và thiết thực, chuỗi khách sạn Urba chào đón khách với không gian linh hoạt và hiện đại để hành trình của họ được suôn sẻ hơn. Khách sạn của chúng tôi  tập trung vào những nhu cầu quan trọng nhất của khách doanh nhân cung cấp các cơ sở và dịch vụ chất lượng cao nhất. Chúng tôi mong muốn cung cấp môi trường ấm cúng và dịch vụ hạng nhất dành cho khách, tìm kiếm tiêu chuẩn chất lượng cao cho những thứ họ thực sự cần.'
    },
    homePageSwiperFourDesignideaInfo5={
      'zh-CN': '中端城市酒店',
      'USA': 'Mid-range Business Hotel',
      'JP': 'ビジネスホテル',
      'KO': '미들급 시티호텔',
      'TH':'โรงแรมในเมืองระดับกลาง',
      'YH':'Khách sạn thành phố tầm trung'
    },
    homePageSwiperFourMotto5={
      'zh-CN': '聚焦你的核心诉求',
      'USA': 'Balance your Essentials',
      'JP': 'Urba柏纳ホテル-あなたの基本的なニーズに中心、シンプルで安心。',
      'KO': '핵심 요구를 균형 맞게 한다',
      'TH':'ปรับสมดุลทุกสิ่งจำเป็นของคุณ',
      'YH':'Cân bằng các yếu tố cần thiết của bạn'
    },
    homePageSwiperFourBrandintroductionInof6={
      'zh-CN': '经济型酒店不等于没有特色！<br>热情的接待，深度的睡眠，解乏的淋浴，可口的早餐与美味的餐食，别具创意的会议……您在我们酒店中的每分每秒都将充满活力。干净便捷的设施，清新怡人的氛围，热情周到的服务，我们为商务和休闲旅客提供不可或缺的高品质舒适体验。\<br>困了？饿了? 放松？娱乐？休闲？学习? 不要压抑你的情绪，做你想做的，成全原本的自己。',
      'USA': 'Economy hotel doesn\'t mean no character!<br>A warm welcome, a deep sleep, a power shower, an energising breakfast and tasty meals, creative meeting spaces… Your stay with us is spirited all along the way. Clean and convenient facilities, a refreshing and inviting atmosphere, enthusiastic and thoughtful attention, beu Hotels focus on the quality of our guests\' indispensables to offer a pleasant experience for both business and leisure travellers.<br/> Sleepy or hungry?  Relaxed or busy? Mellow or playful?<br/> Whatever your mood.',
      'JP': 'エコノミーホテルは特徴がないという意味ではありません！温かいおもてなし、深い眠り、強力なシャワー、春の朝のような朝食、おいしい食事、個性的な会議...ご滞在中は元気が溢れます。清潔で便利な施設、爽やかで居心地の良い雰囲気、熱心で思慮深い声かけ、beuホテルは、ビジネス客と観光客の両方に快適な体験を提供するため、品質に細心の注意を払っています。眠たい？お腹が空いていますか？、リラックス？遊び？勉強ですか？どのようなご要望にもご満足いただけます。あなたの発想は無制限',
      'KO': '경제형호텔이라고 특색이 없는거는 아니다.열정적인 서비스,딥슬립,피곤함을 없애주는 샤워,맛있는 음식 호텔에서의 모든시간을 통해서 에너지를 충전시킨다.깨끗하고 편이적인 시설,심플하고 상쾌한 환경,열정적이고 세심한 서비스로 비지니스/관광 고객에게 최상의 체험을 느끼게 한다.',
      'TH':'ด้วยสิ่งอำนวยความสะดวกที่สะอาดและสะดวกสบายบรรยากาศสดชื่นและน่าดึงดูดใจ ความกระตือรือร้นและความเอาใจใส่ โรงแรม beu มุ่งเน้นไปที่คุณภาพของสิ่งจำเป็นของผู้เข้าพักเพื่อมอบประสบการณ์ที่น่าพึงพอใจสำหรับทั้งนักธุรกิจและนักท่องเที่ยว จะง่วงนอนหรือจะหิว จะผ่อนคลายหรือจะสนุกสนาน จะอบอุ่นใจหรือจะเรียน อย่าควบคุมอารมณ์ของคุณ',
      'YH':'Cơ sở sạch sẽ và thuận tiện, không khí sảng khoái và hấp dẫn, sự quan tâm nhiệt tình và chu đáo, Chuỗi khách sạn beu tập trung vào chất lượng không thể thiếu dành cho quan khách để mang đến trải nghiệm thú vị cho cả khách doanh nhân và khách du lịch. Buồn ngủ hay đói? Thư giãn hay vui đùa? Không gian ấm cúng hay là để học tập? Đừng bao giờ kiềm chế tâm trạng của bạn nhé.'
    },
    homePageSwiperFourDesignideaInfo7={
      'zh-CN': '高端酒店及度假村品牌',
      'USA': 'Premium Hotels and Resorts',
      'JP': '高級ホテルとリゾート',
      'KO': '이코노미 호텔',
      'TH':'โรงแรมราคาประหยัด',
      'YH':'Khách sạn Economy'
    },
    homePageSwiperFourBrandintroductionInof7={
      'zh-CN': '柏纳酒店聚焦商旅客人对酒店的核心诉求，提供舒适和实用之间的微妙平衡，专注舒适的环境和一流的服务。\<br>每一家柏纳酒店都是独一无二的，所有酒店都致力于为客人提供舒适的环境和一流的服务，以满足客人真正需要的高品质标准。',
      'USA': 'Arula is a premium hotels and resorts brand combining international hospitality with a true sense of Chinese welcome. While every Arula hotel is unique, all share the same dedication for high-quality service. Discover excellently located hotels that offer caring attentions, delightful food and drink, and places to relax. Helped by calm and considerate employees, guests find it easy to pursue their own design, whether it is business or pleasure.',
      'JP': '高級ホテル＆リゾート檀程は、中国のおもてなしとインターナショナルなサービスを提供します。それぞれの檀程には独自の特徴があり、究極のサービスの追求し、 絶好のロケーション、おもてなし、おいしい料理など\<br>ビジネスでもレジャーでも、ホテルに足を踏み入れた瞬間は、いつでもあなたのそばにいる思いやりのあるスタッフとくつろげるでしょう。'
    },
    homePageSwiperFourDesignideaInfo6={
      'zh-CN': '印度商务连锁酒店',
      'USA': 'India Business Chain Hotel',
      'JP': 'エコノミーホテル',
      'KO': '이코노미 호텔',
      'TH':'โรงแรมราคาประหยัด',
      'YH':'Khách sạn Economy'
    },
    homePageSwiperFourMotto7={
      'zh-CN': '尽享心意之地',
      'USA': 'Our ambition. Help you follow yours.',
      'JP': '檀程、あなたの心の旅を楽しんでください',
      'KO': '자신만 되기',
      'TH':'แค่เป็นตัวของตัวเอง',
      'YH':'Hãy là chính mình'
    },
    homePageSwiperFourMotto6={
      'zh-CN': '住的干净，住的舒适',
      'USA': 'Live clean and comfortable',
      'JP': 'あなたらしく',
      'KO': '자신만 되기',
      'TH':'แค่เป็นตัวของตัวเอง',
      'YH':'Hãy là chính mình'
    },

    homePageSwiperFiveJointheInformation={
      'zh-CN': '加盟信息',
      'USA': 'Cooperation Enquiry',
      'JP': 'あなたの情報',
      'KO': '가입 정보',
      'TH':'ข้อมูลแฟรนไชส์',
      'YH':'Thông tin chuyển nhượng'
    },
    homePageSwiperFiveInputName={
      'zh-CN': '请输入名字',
      'USA': 'Enter Name ',
      'JP': '連絡先の名前を入力してください。',
      'KO': '연락처 이름 입력 ',
      'TH':'กรุณากรอกชื่อผู้ติดต่อ',
      'YH':'Vui lòng nhập tên liên hệ'
    },

    homePageSwiperFiveInputNameLong={
      'zh-CN': '姓名过长',
      'USA': 'Overlength Name',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },

    homePageSwiperFiveGirl={
      'zh-CN': '女士',
      'USA': 'Ms.',
      'JP': '女性',
      'KO': '양',
      'TH':'นางสาว.',
      'YH':'Bà'
    },
    homePageSwiperFiveBoy={
      'zh-CN': '先生',
      'USA': 'Mr.',
      'JP': '男性 ',
      'KO': '씨',
      'TH':'นาย. ',
      'YH':'Ông'
    },
    homePageSwiperFiveInputPhone={
      'zh-CN': '请正确输入11位手机号码',
      'USA': 'Enter Mobile Phone Number (11 digits)',
      'JP': 'お電話番号',
      'KO': '전화 번호 (11 자리)를 입력하십시오',
      'TH':'กรุณากรอกหมายเลขโทรศัพท์มือถือ (11 หลัก)',
      'YH':'Nhập Số Điện thoại Di động của quý khách (11 chữ số)'
    },
    homePageSwiperFiveInputAddress={
      'zh-CN': '请输入物业所在位置 例：国家、省市、街道、门牌',
      'USA': 'Enter Property Address  ',
      'JP': 'ご住所',
      'KO': '주소를 입력하십시오',
      'TH':'กรุณากรอกที่อยู่',
      'YH':'Nhập địa chỉ cơ sở'
    },
    homePageSwiperFiveInputAddressLong={
      'zh-CN': '物业所在地址过长',
      'USA': 'Overlength Address',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    homePageSwiperFiveInputAddressError={
      'zh-CN': '请输入物业所在地址',
      'USA': 'Please enter the address of the hotel/property.',
      'JP': 'ホテルの不動産の住所を入力してください。',
      'KO': '호텔 부동산 주소 입력',
      'TH':'กรุณากรอกที่อยู่ของโรงแรม',
      'YH':'Vui lòng nhập địa chỉ của khách sạn'
    },
    homePageSwiperFiveInputPhoneError={
      'zh-CN': '请输入正确的电话号码',
      'USA': 'Please enter the contact phone number',
      'JP': '携帯の番号を入力してください',
      'KO': '핸드폰 번호 입력해주세요.',
      'TH':'กรุณากรอกเบอร์โทร.ติดต่อ  ',
      'YH':'Vui lòng nhập số điện thoại liên lạc'
    },
    homePageSwiperFiveInputSpace={
      'zh-CN': '请输入物业建筑面积',
      'USA': 'Size of property (in sq. meters)',
      'JP': '建物延床面積',
      'KO': '지역을 입력하십시오',
      'TH':'กรุณากรอกขนาดพื้นที่',
      'YH':'Nhập khu vực'
    },
    homePageSwiperFiveInputSpaceError={
      'zh-CN': '请输入正确的物业面积',
      'USA': 'Input Correct Area',
      'JP': '建物延床面積',
      'KO': '지역을 입력하십시오',
      'TH':'กรุณากรอกขนาดพื้นที่',
      'YH':'Nhập khu vực'
    },
    homePageSwiperFiveJoin={
      'zh-CN': '加盟',
      'USA': 'Franchise Opportunities ',
      'JP': '委託契約',
      'KO': '가입',
      'TH':'แฟรนไชส์',
      'YH':'Nhượng quyền & Hợp tác'
    },
    homePageSwiperFiveMaterialcooperation={
      'zh-CN': '物料合作',
      'USA': 'Material Cooperation (delete) replace by "email',
      'JP': 'MC契約',
      'KO': '물질 협력',
      'TH':'ความร่วมมือด้านวัสดุ',
      'YH':'Hợp tác về vật chất'
    },
    homePageSwiperFiveJoinLvyue={
      'zh-CN': '加盟旅悦',
      'USA': 'Join The LvYue Group',
      'JP': '旅悦グループに加入',
      'KO': '뤼위에 가맹하기',
      'TH':'เข้าร่วมกลุ่มบริษัท LvYue',
      'YH':'Liên hệ với chúng tôi'
    },
    homePageSwiperFiveJoinInfo={
      'zh-CN': '旅悦集团是携程集团的战略投资公司，以“携手大数据，拥抱互联网”为特色；致力于打造比肩全球的旅游全产业链服务商，现诚邀您筑梦掘金蔚徕，期待您的加盟。',
      'USA': 'Established in 2016 with strategic investment from Ctrip Group and led by the President of Qunar.com, Mr. Zhou Rong, as Group CEO, LvYue is a tourism group which integrates hotel management, information technology and trade market purchasing.Utilising Big Data platforms LvYue is dedicated to becoming a complete industry supply chain provider, applying innovative internet technology to the traditional tourism market, and in turn enriching both partner and guest experience.We sincerely invite you to build this dream together and tap into the future with us.  We look forward to you joining.',
      'JP': 'Ctrip の戦略的投資な旅悦は、ホテル管理、情報技術、ホテル用品貿易を統合した観光グループであり、ビッグ データを活用して、従来の観光産業にインターネットの革新的な技術を通してパートナー とゲストに豊かな体験を与え、業界全体のチェーンサービスプロバイダーの構築に専念しております。私たちは心よりお客様を歓迎致します。一緒に素晴らしい未来を築きましょう。ぜひ私たちへ加入お待ちしております。',
      'KO': 'Ctrip이 전략적 투자로 설립된 호텔매니지먼트,정보기술,무역등 영역을 결합한 종합적여행산업그룹이다.LvYue그룹은 여행산업의 건설과 운영에 집중하고 인터넷 신기술을 전통적인 여행관광산업에 응용하여 전통업계의 지능화,인터넷화의 발전을 도모하고있다.여러분을 미래 여행산업 발전에 참여하는곳으로 요청합니다.',
      'TH':'กลุ่ม Lv Yue เป็นบริษัทที่ได้รับการลงทุนเชิงกลยุทธ์จาก Ctrip LvYue เป็นบริษัทท่องเที่ยวที่รวมการจัดการโรงแรม เทคโนโลยีสารสนเทศ และการจัดซื้อและการค้า ด้วยการใช้ข้อมูลบิ๊กดาต้า LvYue มุ่งมั่นที่จะสร้างบริษัทผู้ให้บริการที่มีห่วงโซ่อุตสาหกรรมแบบครบวงจร ด้วยการนำนวัตกรรมทางอินเทอร์เน็ตมาใช้กับอุตสาหกรรมการท่องเที่ยวแบบดั้งเดิม เพิ่มประสบการณ์ให้แก่พันธมิตรและลูกค้าของเรา เราจริงใจที่จะเชิญคุณมาร่วมสร้างความฝันเพื่อก้าวสู่อนาคตของเรา หวังว่าจะได้รับความร่วมมือจากคุณ',
      'YH':'LvYue group Là 1 tập đoàn công nghiệp du lịch, với sự kết hợp của : công ty quản lý khách sạn (Thiên Tân), công ty công nghệ thông tin (Bắc Kinh), công ty mua bán và thương mại (Thành Đô).<br/>Chúng tôi tập trung vào việc xây dựng và vận hành các đơn vị trong chuỗi ngành công nghiệp du lịch, với mục đích cung cấp giải pháp cho ngành du lịch thông qua công nghệ đổi mới Internet…  Chúng tôi rất mong nhận được sự hợp tác cùng bạn trên phương trâm “Hợp tác cùng phát triển ”'
    },
    joinUsDreamofgoldnuggets={
      'zh-CN': '筑梦掘金未来',
      'USA': 'build dreams and tap into future',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    groupAboutLvyue={
      'zh-CN': '旅悦集团成立于2016年，经去哪儿网内部孵化而成，前携程大住宿首席战略官周荣担任集团CEO。由携程集团战略投资，腾讯、红杉资本中国基金、百度资本、高盛集团、鸥翎投资、中信聚信、元禾原点、凯撒辉耀均为投资方。',
      'USA': "Lvyue Group was established in 2016, after incubating inside Qunar.com. Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group , served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism. <br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services. <br/><br/>Lvyue Group aims to apply innovative Internet technologies to revolutionize the traditional tourism industry with big data, technology, brand and standardization. <br/><br/>Lvyue Groups brands: <br/>Quality Boutique Hotel - Floral<br/>High-end Hotels and Resorts - Arula<br/>Mid-range Hotel - Vyluk & Urba<br/>Budget Hotel - Suoxing <br/>India Economy Hotel - beu<br/>Homestay Alliance Brand-Hotel Alliance",
      'JP': "旅悦グループは2016年に設立され、前身予約サイトQunar.comから生まれました。Ctripの元最高戦略責任者である周荣がグループのCEOを務めました。 Ctrip Group、Tencent、Sequoia Capital China Fund、Baidu Capital、Goldman Sachs Group、Ou Ling Investment、CITIC Juxin、Yuanhe Origin、CaesarRadianceによる戦略的な投資です。 <br/><br/>旅悦グループは、ホテル管理、情報技術サービス、サプライチェーン貿易、および文化観光を統合する観光産業グループです。シニアチームと2つのOTAの大手であるCtripとQunarのデータとフローサポートに依存し、最も信頼できる目的地観光サービスブランドにむ目標し、消費者に「食事、宿泊、旅行、ショッピング、エンターテイメント」を360°サービスを提供することに取り組んでいます。 <br/><br/>旅悦グループは、インターネットのイノベーションテクノロジーを伝統的な観光産業に適用し、伝統的な観光産業のデータベース、技術、ブランドベース、および専門的な開発を実現することを目指しています。<br/><br/>グループは: <br/>グローバル民宿ホテル-花築<br/>高級ホテルとリゾート-檀程<br/>ライフスタイルシティホテル-蔚徕<br/>ビジネスホテル-柏纳<br/>エコノミーホテル-索性<br/>インドのビジネスホテルチェーン-beu<br/>隠された世界のホテル-般蓝",
      'KO': "Lvyue Group was established in 2016, after incubating inside Qunar.com. Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group , served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism. <br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services. <br/><br/>Lvyue Group aims to apply innovative Internet technologies to revolutionize the traditional tourism industry with big data, technology, brand and standardization. <br/><br/>Lvyue Groups brands: <br/>Quality Boutique Hotel - Floral<br/>High-end Hotels and Resorts - Arula<br/>Mid-range Hotel - Vyluk & Urba<br/>Budget Hotel - Suoxing <br/>India Economy Hotel - beu<br/>Homestay Alliance Brand-Hotel Alliance",
      'TH':"Lvyue Group was established in 2016, after incubating inside Qunar.com. Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group , served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism. <br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services. <br/><br/>Lvyue Group aims to apply innovative Internet technologies to revolutionize the traditional tourism industry with big data, technology, brand and standardization. <br/><br/>Lvyue Groups brands: <br/>Quality Boutique Hotel - Floral<br/>High-end Hotels and Resorts - Arula<br/>Mid-range Hotel - Vyluk & Urba<br/>Budget Hotel - Suoxing <br/>India Economy Hotel - beu<br/>Homestay Alliance Brand-Hotel Alliance",
      'YH':"Lvyue Group was established in 2016, after incubating inside Qunar.com. Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group , served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism. <br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services. <br/><br/>Lvyue Group aims to apply innovative Internet technologies to revolutionize the traditional tourism industry with big data, technology, brand and standardization. <br/><br/>Lvyue Groups brands: <br/>Quality Boutique Hotel - Floral<br/>High-end Hotels and Resorts - Arula<br/>Mid-range Hotel - Vyluk & Urba<br/>Budget Hotel - Suoxing <br/>India Economy Hotel - beu<br/>Homestay Alliance Brand-Hotel Alliance",
    },
    groupHope={
      'zh-CN': '我们的愿景',
      'USA': 'Our Vision',
      'JP': 'バージョン',
      'KO': '우리의 비전',
      'TH':'วิสัยทัศน์ของเรา',
      'YH':'Tầm Nhìn'
    },
    groupHopeInfo={
      'zh-CN': '以数据为驱动，打造比肩全球的旅游全产业链服务商。',
      'USA': 'To build the group into a complete supply chain and service provider for the tourism industry, a global leader powered by Big Data',
      'JP': '業界全体のサービスプロバイダーになり、データに駆動されるグローバル競合相手とともに前進。',
      'KO': '빅데이터를 기반으로 글로벌시장을 타겟으로 전체 여행산업에 도움을 제공할수있는 서비스 업체로 될것이다.',
      'TH':'เพื่อสร้างบริษัทผู้ให้บริการที่มีห่วงโซ่อุตสาหกรรมแบบครบวงจรระดับโลกโดยอาศัยข้อมูล',
      'YH':'thành nhà cung cấp dịch vụ số 1  toàn ngành theo chuỗi được xử lý theo dữ liệu.'
    },
    groupOurBusiness={
      'zh-CN': '我们的业务',
      'USA': 'Our Business',
      'JP': '業務',
      'KO': '업무분야',
      'TH':'ธุรกิจของเรา',
      'YH':'Kinh doanh của chúng tôi'
    },
    groupIntegrateType1={
      'zh-CN': '布草及周边 产品零售',
      'USA': 'Hotel linen & amenities sales',
      'JP': 'リネン及びその関連製品',
      'KO': '린넨및주변제품소매',
      'TH':'สินค้าหลัก และสินค้าประกอบ สินค้าปลีก',
      'YH':'Các dòng sản phẩm chính và phụ, sản phẩm bán lẻ'
    },
    groupIntegrateType2={
      'zh-CN': '酒店PMS 管理系统',
      'USA': 'Hotel PMS (Property Management System)',
      'JP': 'ホテルPMSマネジメントシステム',
      'KO': '호텔 PMS관리시스템',
      'TH':'ระบบการจัดการโรงแรม PMS',
      'YH':'Hệ thống Phần mềm Quản lý Khách sạn (PMS)'
    },
    groupIntegrateType3={
      'zh-CN': '酒店管理 培训学校',
      'USA': 'Hotel Management Training School',
      'JP': 'ホテルマネジメントトレーニングスクール',
      'KO': '호텔관리, 직업훈련학원',
      'TH':'การจัดการโรงแรม โรงเรียนฝึกอบรม',
      'YH':'Quản lý Khách sạn, Trường đào tạo'
    },
    groupIntegrateType4={
      'zh-CN': '酒店CRS 管理系统',
      'USA': 'Hotel CRS (Central Reservation System)',
      'JP': 'ホテルCRSマネジメントシステム',
      'KO': '호텔 CRS관리시스템',
      'TH':'ระบบการจัดการโรงแรม CRS',
      'YH':'Hệ thống Quản lý Khách sạn Trách nhiệm xã hội của doanh nghiêp (CRS)'
    },
    groupIntegrateType5={
      'zh-CN': '旅悦致品 线上商城',
      'USA': 'LvYue Selections <br/>e-commerce shop',
      'JP': '旅悦逸品、ネットショップ',
      'KO': 'LvYue 선택, 온라인 쇼핑몰',
      'TH':'สินค้าแนะนำจาก LvYue ห้างออนไลน์',
      'YH':'Các lựa chọn của LvYue, Trung tâm mua sắm trực tuyến'
    },
    groupIntegrateType6={
      'zh-CN': '纺织品',
      'USA': 'Linen Laundry Service',
      'JP': '繊維製品',
      'KO': '린넨세탁',
      'TH':'ซักผ้า ',
      'YH':'Dịch vụ giặt '
    },
    groupIntegrateType7={
      'zh-CN': '洗涤租赁',
      'USA': '',
      'JP': '洗濯とリース',
      'KO': ' 메인리스',
      'TH':'ลีสซิ่ง',
      'YH':'rửa & cho thuê'
    },
    groupCoreCompetitiveness={
      'zh-CN': '我们的核心竞争力',
      'USA': 'Core Advantages',
      'JP': '核心競争力',
      'KO': '핵심 경쟁력',
      'TH':'สมรรถนะหลัก',
      'YH':'Cạnh tranh cốt lõi'
    },
    groupBigData={
      'zh-CN': '携手大数据 — 拥抱互联网',
      'USA': 'Tapping into Big Data and powered by the Internet',
      'JP': 'ビッグデータを活用してインターネットを採用する',
      'KO': '빅데이터에 의거하고 인터넷을 이용',
      'TH':'จับมือกับบิ๊กดาต้า โอบกอดอินเทอร์เน็ต',
      'YH':'Khai thác lượng dữ liệu lớn và nắm bắt mạng Internet'
    },
    groupTeamContant={
      'zh-CN': '旅悦集团基于携程、去哪儿海量用户数据，以用户消费数据判断用户需求、以数据驱动运营管理，以技术驱动系统服务、以需求带动产业链规划建设。同时，配以去哪儿网+海底捞高管团队，线上+线下双引擎驱动酒店业升级，打造智能化、定制化的整体解决方案。',
      'USA': "Based on massive amounts of user data from Ctrip and Qunar, LvYue Group identifies user needs and user consumption data to drive management and operations, advance system services with technology, and enhance industry supply chain planning & construction demands<br/> LvYue benefits from the experience of Qunar\'s core leadership, as well as senior level executives from HaiDiLao. The combination of strong leadership from online and offline service industries drives new smart solutions for hotels.",
      'JP': 'CtripとQunarからの大量なユーザーデータに基づいて、Lvyue　Groupはユーザーのニーズを確定、ユーザー消費データで管理と運用を推進し、テクノロジーでシステムサービスを進歩させ、更に需要に応じて産業チェーンの計画と建設を実施。一方、HaiDiLaoとQunarの上層部チームはリーダーシップを発揮しています。オンライン+オフラインのトップレベルチームは、智能化、カスタマイズ化のコンサルティングを実現できます。',
      'KO': 'LvYue는 Ctrip과 Qunar 의 방대한 빅데이터를 이용하여 고객들의 핵심욕구를 파악한후 데이터를 기반으로 운영을 하고 기술력으로 서비스의 향상을 도모하며 고객을 핵심욕구를 기초로 산업을 구축한다.여행/서비스 업계 최상의 관리진으로 온라인/오프라인 동시에 호텔업계의 업그레이드를 추구한다',
      'TH':'ตามข้อมูลผู้ใช้จำนวนมากจาก Ctrip และ Qubar กลุ่ม LvYue สามารถระบุความต้องการของผู้ใช้และจัดการการดำเนินงานด้วยข้อมูลการใช้ของผู้ใช้ ยกระดับระบบบริการด้วยเทคโนโลยี ซึ่งมีส่วนช่วยในการวางแผนและก่อสร้างห่วงโซ่อุตสาหกรรมตามความต้องการ ในขณะเดียวกัน ประกอบด้วยคณะผู้บริหารแกนกลางจากเครือข่าย Qunar + Haidilao  ผลักดันอุตสาหกรรมโรงแรมด้วยทั้งตัวขับเคลื่อนออนไลน์และออฟไลน์ อัพเกรดและนำเสนอโซลูชันแพ็คเกจอัฉริยะสำหรับโรงแรมเป้าหมาย',
      'YH':'Dựa trên dữ liệu người dùng khổng lồ từ Ctrip và Qubar, Tập đoàn LvYue xác định nhu cầu của người dùng và thúc đẩy quản lý và vận hành dữ liệu tiêu dùng của người dùng, thúc đẩy các dịch vụ hệ thống với công nghệ và lần lượt thúc đẩy lập kế hoạch và xây dựng chuỗi ngành theo yêu cầu. Trong khi đó, Tập đoàn thúc đẩy sự lãnh đạo cốt lõi của Qunar + các giám đốc điều hành cấp cao từ HaiDiLao. Các đội ngũ cấp cao trực tuyến + ngoại tuyến thúc đẩy nâng cấp ngành khách sạn và cung cấp các giải pháp gói thông minh và đáp ứng đủ cho các khách sạn đích.'
    },
    groupSingleDimension={
      'zh-CN': '单维度酒店 多维度发展',
      'USA': '360 degree development - From Hotel Operations to Complete Supply Chain',
      'JP': '単次元ホテルと多次元開発',
      'KO': '단차원 호텔 다차원 발전',
      'TH':'โรงแรมมิติเดียวและการพัฒนาแบบหลายมิติ',
      'YH':'Phát triển các khách sạn đơn chiều và đa chiều'
    },
    groupProgramme={
      'zh-CN': '旅悦集团坚持“链条对链条”的产业链打造方针。在不断完善自身的同时，将酒店衍生产业链如酒店客用品配置与集采、培训学院、用户在线商城等衍生服务做到极致，为酒店业主提供全产业链服务。用户方面，不仅拥有独立运营的在线商城“旅悦致品”，为酒店场景消费提供了“所见即所得”的模式，将线上线下打通，同时还能够为用户提供专属出行定制服务——花筑旅行，360°为客人解决人在旅途中的一切问题。',
      'USA': 'LvYue constantly improves hotels and provides a complete end-to-end hotel management solution through its smart service system named "Butler".<br/>Incubated by LvYue R&D teams, the "Butler" system is a complete set of closed-loop services such as site selection and preparation (Aladdin Hotspot Selection System), group purchasing, hotel operations, cost control,  channel management and customer service (XPMS), talent development and resourcing (LvYue University). <br/> All these systems help to standardise the Group\'s brands and management operations.',
      'JP': '当グループは、産業チェーン構築において「チェーンからチェーンへ」の方針を順守しています。 絶え間ない自己改善と並行して、ホテルの全サプライチェーンサービスを提供するために、ホテルのゲスト用品の構成、グループでの購入、トレーニングスクール、ユーザーのオンラインモールなど、デリバティブサービスの最高品質を目指しています。 ユーザー向けに、独立して運営されるオンラインショッピングモール「LvYue Selections」を設置し、「目で見たものが購入できるもの」を顧客に提供しています。 オンラインサービスとオフラインサービスが接続されているため、ユーザーはFloral Tripを介してカスタマイズされた旅行サービスを利用でき、交通手段のあらゆる問題に対するあらゆるソリューションを提供します。',
      'KO': 'LvYue그룹은 체인 대 체인의 방식으로 지속적으로 자신을 개선시키는 동시에 호텔관련산업-어메니티의 구매,호텔인원 교육학원,고객을 대상으로한 온라인 쇼핑몰 등 발전에도 기려하고 있다.고객을 대상으로한 온라인 쇼핑몰<LvYue Choice>을 통해 호텔만 가능한 쇼핑방식을 고객에게 제공하여 오프라인 호텔과 온라인 쇼핑을 연결시켯다. 동시에 관광고객에게 360도 서비스를 제공해주고 여행중에서 마주칠수있는 문제에 솔루션을 제공해주는 플로라투어APP를 운영중이다.',
      'TH':'กลุ่มบริษัทของเราปฏิบัติตามนโยบาย “chain to chain” ในการสร้างห่วงโซ่อุตสาหกรรม พัฒนาตนเองอย่างไม่หยุดยั้ง มุ่งมั่นสู่ความเป็นเลิศในการบริการอนุพันธ์ เช่น การจัดการและการสั่งซื้ออุปกรณ์โรงแรม โรงเรียนฝึกอบรม ห้างออนไลน์ ฯลฯ เพื่อให้บริการอุตสาหกรรมโรงแรมแบบครบวงจร ในด้านผู้ใช้งาน ได้จัดตั้งห้างออนไลน์แบบพึ่งตนเอง “LvYue Selections”<br/> เพื่อให้มโนทัศน์  “สิ่งที่คุณเห็นคือสิ่งที่คุณได้รับ” กลายเป็นสิ่งที่เป็นไปได้ให้แก่ลูกค้า โดยเชื่อมต่อบริการออนไลน์และออฟไลน์ อีกทั้งให้บริการการเดินทางแบบกำหนดเองได้ผ่าน Floral Travel มุ่งเสนอโซลูชั่นที่ครบวงจรสำหรับทุกปัญหาเกี่ยวกับการเดินทาง',
      'YH':'Tập đoàn tuân thủ chuỗi chính sách trong nền công nghiệp xây dựng chuỗi. Song song với việc tự cải thiện không ngừng, phấn đấu cho sự xuất sắc tối cao trong các dịch vụ phái sinh, chẳng hạn như cấu hình cung cấp khách của khách sạn; mua theo nhóm, trường đào tạo, trung tâm mua sắm trực tuyến cho người dùng, v.v. để cung cấp dịch vụ chuỗi toàn ngành cho khách sạn. Đối với người dùng, Tập đoàn đã thiết lập một trung tâm mua sắm trực tuyến hoạt động độc lập “LvYue Selections”, cung cấp cho khách hàng khả năng của “những gì bạn thấy là những gì bạn nhận được”. Với các dịch vụ trực tuyến và ngoại tuyến được kết nối, đồng thời cung cấp cho người dùng dịch vụ du lịch theo yêu cầu thông qua Floral Travel với đầy đủ các giải pháp cho mọi vấn đề có thể xảy ra trên đường.'
    },
    groupCultureLeads={
      'zh-CN': '企业文化引领发展',
      'USA': 'Corporate Culture Leads Development',
      'JP': '企業文化で市場発展',
      'KO': '기업문화로 발전을 이끈다',
      'TH':'วัฒนธรรมองค์กรนำการพัฒนา',
      'YH':'Văn hóa doanh nghiệp dẫn đầu sự phát triển'
    },
    groupcultureLeadsInfo={
      'zh-CN': '旅悦集团作为中国酒店和旅游行业最年轻的团队之一，注重企业文化的打造，集团将“消费者第一、合作伙伴第二、员工第三、股东第四”作为第一价值观，鼓励员工“大声说话”，打造员工“激情 敬业 诚实 皮实”的职业性格，秉承“努力赚每一块钱，努力省每一块钱”价值理念，用服务者的姿态迎接每一位消费者，用赢家的气质迎接每一个挑战。',
      'USA': "LvYue Group, as one of the youngest teams in China‘s hotel and tourist industries, stresses the building of corporate culture. The Group regards “Consumers First, Partners Second, Employees Third, Shareholder Fourth” as its primary mantra. The Group encourages employees to “speak out”, and shapes the professional character of its employees to be “passionate, dedicated, honest, and diligent”. It promotes a message of “earn more & save more” along with its “bulldozer culture”, as well as receiving each customer warmly, and bravely facing new challenges.",
      'JP': '旅悦グループは、中国のホテル業および観光産業における「最も若いチーム」の1つとして、企業文化の構築を重視している。 弊社の会社方針は「お客様第一；パートナー第二；社員第三；株主が第四」である。社員に「情熱的で、献身的で、誠実で不屈」というプロの意識を成形させ、「一円でも獲得し、一円でも節約する」の理念で前に進む、満点なサービス精神で顧客全体を受け入れ、勝者たる態度で課題にチャレンジする',
      'KO': 'LvYue그룹은 중국호텔 및 여행업계에서 최연소 운영진중의 하나이다.기업문화의 구축을 중시하고 소비자1위,사업파트너2위,직원3위,주주4위가 기업문화이다.직원들에게 적극적으로 의견을 말할수있도록 격려하고 직원들로 하여금 열정,프로정신,성실을 겸비하게금 도와주고 있다.최상의 서비스로 모든 고객들을 맞아주고 승리자의 자태로 모든 난관을 맏이한다.',
      'TH':'กลุ่มบริษัท LvYue เป็นหนึ่งในทีมที่อายุน้อยที่สุดในอุตสาหกรรมการบริการและการท่องเที่ยวของจีนที่ให้ความสำคัญกับการสร้างวัฒนธรรมองค์กร กลุ่มเรามีค่านิยมหลักคือ  ผู้บริโภคเป็นที่หนึ่ง พันธมิตรเป็นที่สอง พนักงานเป็นที่สาม ผู้ถือหุ้นเป็นที่สี่ กระตุ้นให้พนักงาน กล้าพูด เพื่อให้พนักงานมีลักษณะนิสัยการทำงาน “มุ่งมั่น ทุ่มเท ซื่อสัตย์และไม่ย่อท้อ” ด้วยความคิด “พยายามหารายได้ พยายามประหยัดต้นทุน” ต้อนรับลูกค้าทุกคนด้วยใจรักบริการ ต้อนรับทุกความท้าทายจากมุมมองผู้ชนะ',
      'YH':"Tập đoàn LvYue, là một trong những đội ngũ trẻ nhất trong ngành khách sạn và du lịch của Trung Quốc, coi trọng việc xây dựng văn hóa doanh nghiệp. Đội ngũ xem xét 'Người tiêu dùng đầu tiên, Đối tác thứ hai, Nhân viên thứ ba và Cổ đông Thứ tư là giá trị chính của nó, khuyến khích nhân viên 'Hãy cất tiếng' và định hình các đặc điểm chuyên nghiệp của họ là 'đam mê, tận tâm, trung thực và không thể khuất phục'. Tập đoàn đề cao ý tưởng 'nỗ lực kiếm tiền và tiết kiệm từng xu', tiếp nhận mọi khách hàng với tinh thần phục vụ và đứng trước những thách thức với tư duy chiến thắng."
    },
    payNewsPaidInformation={
      'zh-CN': '付费资讯',
      'USA': 'Paid Information',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewsTitle1={
      'zh-CN': '出境游预订酒店应该注意什么？才能少些“囧途”',
      'USA': 'What should I pay attention to about booking a hotel for outbound travel?  How could I reduce "setbacks" on the way？',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewsTitle2={
      'zh-CN': '杭州考研住宿：住宿的几个建议要牢牢记住！',
      'USA': 'Hangzhou Accommodation for Graduate-study admission exam: Several tips for accommodation should be kept in mind!',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewsTitle3={
      'zh-CN': '酒店民宿or别墅？引领出境游住宿新风尚',
      'USA': 'B&B  Hotel or Villa? Leading the new style of outbound travel accommodation',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewsTitle4={
      'zh-CN': '为什么酒店的数据最容易“偷”',
      'USA': "Why a hotel's data is motly inclined to be 'stolen'?",
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewsTitle5={
      'zh-CN': '入乡随俗：外国住酒店，哪些潜规则需注意？',
      'USA': 'As the Romans do: What unspoken rules should be noted when staying at a hotel abroad?',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewsTitle6={
      'zh-CN': '酒店“非典型”场景革命：AI如何引领“造梦空间”？',
      'USA': "Hotel's 'atypical'scene revolution: How does AI lead the 'dream workshop'?",
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewsTitle7={
      'zh-CN': '你的酒店：能保证让客人睡个好觉吗？',
      'USA': 'Could you assure the guest a sound sleep?',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewsTitle8={
      'zh-CN': '传统酒店如何跨界“掘金”，旅悦信息给出了更优解',
      'USA': "How traditional hotels cross the border to 'dig gold'? There is a better solution in LvYue's information.",
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewSTips1={
      'zh-CN': '微信支付二维码有效时长为5分钟，请尽快支付',
      'USA': 'WeChat payment QR code is valid for 5 minutes, please pay ASAP.',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewSTips2={
      'zh-CN': '请使用微信扫一扫 扫描二维码支付',
      'USA': 'Please scan QR codein WeChat to pay.',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingTitle={
      'zh-CN': '花筑酒店、客栈、民宿品牌介绍-旅悦集团官网',
      'USA': 'Floral Hotel-Floral Travel',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    tanchenTitle={
      'zh-CN': '檀程酒店、客栈、民宿品牌介绍-旅悦集团官网',
      'USA': 'Arula Hotel-Floral Travel',
    },
    flowerBuildingDesign={
      'zh-CN': '花筑设计理念',
      'USA': 'Design Philosophy of Floral Hotel',
      'JP': '花築ホテルのデザイン哲学',
      'KO': '플로라 디자인 컨셉',
      'TH':'นโนทัศน์การออกแบบโรงแรม Floral',
      'YH':'Triết lý thiết kế của Khách sạn Floral'
    },
    flowerBuildingDesignType1={
      'zh-CN': '质感',
      'USA': 'Quality',
      'JP': '品質',
      'KO': '질감',
      'TH':'คุณภาพ',
      'YH':'Chất lượng'
    },
    flowerBuildingDesignType2={
      'zh-CN': '关怀',
      'USA': 'Care',
      'JP': 'ケア',
      'KO': '배려',
      'TH':'ความเอาใจใส่',
      'YH':'Bảo dưỡng'
    },
    flowerBuildingDesignType3={
      'zh-CN': '智能',
      'USA': 'Intelligence',
      'JP': '知恵',
      'KO': '지능',
      'TH':'อัจฉริยะ',
      'YH':'Trí tuệ'
    },
    flowerBuildingaboutfb={
      'zh-CN': '花筑·品牌介绍',
      'USA': 'Floral Hotel-Brand Introduction',
      'JP': '花築ホテルとブランド紹介',
      'KO': '플로라호텔-브랜드 소개',
      'TH':'แนะนำแบรนด์ Floral',
      'YH':'Giới thiệu về Thương hiệu Khách sạn Floral'
    },
    flowerBuildingaboutfbType1={
      'zh-CN': '全球品质民宿酒店',
      'USA': 'International Quality Boutique Hotel Brand',
      'JP': '',
      'KO': '부티크 리조트 호텔',
      'TH':'โรงแรมและรีสอร์ทบูติคฮอลิเดย์',
      'YH':'Các khách sạn & khu nghỉ dưỡng cỡ nhỏ'
    },
    flowerBuildingaboutfbType2={
      'zh-CN': '花筑是以独特美学、在地体验、用心服务为特色的全球品质民宿酒店领军品牌，比酒店更个性，比民宿更专业。目前已有签约开业门店超过1700家，累计接待超过1000万人入住。\<br>每一处花筑都是独一无二高颜值的作品，融合了在地文化，设计充满地域氛围，或藏于古镇，或坐落在山间及湖边，融合了主人的梦、当地的情、天然的景，是真正适合现代都市旅客，追求返璞归真的理想住所。',
      'USA': 'Floral brand features unique aesthetics,local experience and attentive services.It is more welcoming than traditional chain hotels and more professtional than homestay. At present, Floral has more 1700 hotels wordwide (mainly in China,Japan, Philippines, Korea, Thailand ) and has welcomed more than 10 million guests. <br />Each Floral hotel is a unique and delicately beautiful worl. It integrates local culture and atmosphere. It can be hidden in the ancient towm,or located in the mountains by the lake. It blends the owner’s dream, local feelings, and nature into the guests’ stays, whice is an ideal experience that is truly suitable for modern urban travellers who seeks to return to nature. Caring for guests with our 7 senses’ service philosophy,we immerse our travellers in luxury, including a one-to-one butler service and customised experiences.',
      'JP': "世界規模で究極の景色を選択します。 \<br>" +
      "山側または湖岸にある旧市街にある花築は、ユニークなアドレスをコレクションしています。各ホテルは、地元の文化、デザイン、雰囲気を組み合わせ、感情と温かい個人的なサービスで旅行者をお迎えします。一つの花、一つの世界、一つの人生。地域の独創性を受け入れる",
      'KO': "플로라호텔은 세계각지에서 경치를 위주로하는 지역을 찾고있다. \<br>" +
      "어느한 호텔이든 현지 인문환경의 특색들을 본따서 디자인에 융합시키거나 열정,따뜻함,차별화된 서비스를 고객들에게 제공하고 있다.",
      'TH':"โรงแรม Floral เลือกทัศนียภาพที่โดดเด่นที่สุดในทุกมุมโลก \<br>" +
      "ซ่อนตัวอยู่ในเมืองเก่า เก็บตัวอยู่ฝั่งภูเขาหรือฝั่งทะเลสาบแบรนด์เราได้รวบรวมที่ตั้งที่มีเอกลักษณ์ต่าง ๆ  โรงแรมแต่ละแห่งผสมผสานวัฒนธรรม ลักษณะการออกแบบและบรรยากาศท้องถิ่นเพื่อต้อนรับนักท่องเที่ยวด้วยอารมณ์สะเทือนใจและบริการที่อบอุ่นเป็นส่วนตัว",
      'YH':'Khách sạn Floral chọn lọc ra những cảnh đẹp lộng lẫy nhất ở mọi nơi trên thế giới.\<br>' +
      'Ẩn mình trong một khu phố cổ, hẻo lánh bên sườn núi hoặc bờ hồ, thương hiệu này tập hợp lại các địa chỉ độc đáo. Mỗi khách sạn kết hợp văn hóa địa phương, thiết kế & bầu không khí nồng nhiệt để chào đón khách du lịch với cảm xúc và dịch vụ cá nhân ấm áp.'
    },
    flowerBuildingaboutfbType3={
      'zh-CN': '景区旅行，就住花筑',
      'USA': "Scenic travel, live in Floral, and contact us now",
      'JP': '地域の独創性を取り入れます。',
      'KO': '지역 독창성을 품다',
      'TH':'โอบอุ้มความคิดริเริ่มสร้างสรรค์จากพื้นถิ่น',
      'YH':'Nắm bắt được nguồn gốc địa phương.'
    },
    flowerBuildingBrand1={
      'zh-CN': '花 筑 · 奢',
      'USA': 'Floral-Lux',
      'JP': '花築.豪華',
      'KO': '플로라-럭스',
      'TH':'Floral-Lux',
      'YH':'Floral-Lux'
    },
    wzJoin={
      'zh-CN': '加盟热线',
      'USA': 'Telephone',
      'JP': 'お問合せ',
      'KO': '가맹문의 ',
      'TH':'แฟรนไชส์ โทร',
      'YH':'Điện thoại '
    },
    wzTelephone={
      'zh-CN': '400-898-7118',
      'USA': '0086-400-898-7118',
      'JP': '06-4256-2628',
      'KO': '0082-70-4919-7032',
   'TH':'0066-83-5238098',
   'YH':'0086-400-898-7118'
     },
    flowerBuildingBrand2={
      'zh-CN': '花 筑',
      'USA': 'Floral',
      'JP': '花築',
      'KO': '플로라',
      'TH':'ฟลอรัล',
      'YH':'Floral'
    },
    flowerBuildingBrandPhilippines={
      'USA': 'BULAKLAKIN'
    },
    flowerBuildingBrandJapan={
      'USA': '花築'
    },
    flowerBuildingBrandKorea={
      'USA': '플로라'
    },
    flowerBuildingBrandThailand={
      'USA': 'ฟลอรัล'
    },
    flowerBuildingBrand3={
      'zh-CN': '花 筑 · 悦',
      'USA': 'Floral-Joy',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingBrand4={
      'zh-CN': '花 筑 · 城市',
      'USA': 'Floral-City',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingBrand1Info={
      'zh-CN': '高端精品酒店',
      'USA': 'High-end Boutique Hotel',
      'JP': '高級ブティックホテル ',
      'KO': '하이엔드 부티크 호텔',
      'TH':'โรงแรมบูติกระดับสูง',
      'YH':'Khách sạn cỡ nhỏ cao cấp'
    },
    flowerBuildingBrand1Introduction={
      'zh-CN': '以7感为核心，为住客提供一对一管家，体验定制化服务',
      'USA': "Caring for guests with our '7 senses' service philosophy, we immerse our travellers in luxury, including a one-to-one butler service and customised experiences",
      'JP': '7つのセンスに基づいて、1対1の執事とカスタマイズされた体験サービスをゲストに提供します。',
      'KO': '사람의 7감을 기반으로 고객에게 1대1 최상 서비스 제공',
      'TH':'โฟกัสใน 7 สัมผัส บริการผู้ช่วยส่วนตัวแบบตัวต่อตัวและสร้างประสบการณ์ตามที่ลูกค้ากำหนดเอง',
      'YH':'Dựa trên 7 giác quan có được, chúng tôi cung cấp cho khách hàng hệ thống quản gia chặt chẽ và nền dịch vụ trải nghiệm theo yêu cầu.'
    },
    flowerBuildingBrand3Info={
      'zh-CN': '经济舒适酒店',
      'USA': 'Economic Comfort Hotel',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingBrand3Introduction={
      'zh-CN': '以经济高品质服务为核心，为住客打造舒适高性价比的入住体验',
      'USA': 'Coring on high quality service, create comfortable and cost-effective stay experience for  guests.',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingBrand2Info={
      'zh-CN': '高端精品酒店',
      'USA': 'High-end Boutique Hotel',
      'JP': '高級ブティックホテル ',
      'KO': '하이엔드 부티크 호텔',
      'TH':'โรงแรมบูติกระดับสูง',
      'YH':''
    },
    flowerBuildingBrand2Introduction={
      'zh-CN': '融入当地文化，传承人文，依托自然，给住客带来一种放慢身心，静享时光流逝的生活方式',
      'USA': 'Embracing local cultures and traditions surrounded the natural beauty of each location creating an unforgetable stay.',
      'JP': '地元の文化と調和し、ヒューマニズムを継承し、自然に寄り添い、ゲストの心身をリラックスさせ、時間の流れを楽しむライフスタイルを提供します。',
      'KO': '플로라호텔은 세계각지에서 경치를 위주로하는 지역을 찾고있다. 어느한 호텔이든 현지 인문환경의 특색들을 본따서 디자인에 융합시키거나 열정,따뜻함,차별화된 서비스를 고객들에게 제공하고 있다.',
      'TH':'ปรับให้เข้ากับวัฒนธรรมท้องถิ่น สืบทอดความเป็นมนุษย์นิยม อาศัยธรรมชาติ นำแขกเข้าสู่ไลฟ์สไตล์แบบผ่อนคลายร่างกายและจิตใจและให้แขกเพลิดเพลินไปกับกาลเวลา',
      'YH':'Hòa nhập vào văn hóa địa phương, kế thừa chủ nghĩa nhân văn, dựa vào thiên nhiên, mang đến cho khách một lối sống để thư giãn cơ thể và tâm trí của họ và tận hưởng thời gian trôi qua'
    },
    flowerBuildingBrand4Info={
      'zh-CN': '高端都市酒店',
      'USA': 'High-end city hotel',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingBrand4Introduction={
      'zh-CN': '以简约富有品质的设计理念，旨在为年轻出行者提供休闲、时尚、精致的住宿体验',
      'USA': 'Designed with simplicity and quality to provide young travelers with a casual, stylish and sophisticated experience.',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingSenseTitle={
      'zh-CN': '打造非标住宿的服务标杆——七感服务',
      'USA': 'The new benchmark for unique accomodation - Seven-sense services',
      'JP': '非標準の宿泊施設のベンチマークを設定するセブンセンスサービス',
      'KO': '비표준화 숙박의 서비스 기준을 정의한다-7감 서비스',
      'TH':'สร้างต้นแบบการบริการที่พักที่มีความเด่นเฉพาะแตกต่างไปจากมาตรฐาน – บริการเซเว่นเซ้นส',
      'YH':'Thiết lập tiêu chuẩn cho chỗ ở không đạt chuẩn - Dịch vụ bảy giác quan'
    },
    flowerBuildingSixFeeling1={
      'zh-CN': '视觉感',
      'USA': 'Sight',
      'JP': 'ビジュアル',
      'KO': '시각',
      'TH':'การมองเห็น',
      'YH':'Thị giác'
    },
    flowerBuildingSixFeeling2={
      'zh-CN': '听觉感',
      'USA': 'Sound ',
      'JP': '聴覚',
      'KO': '청각',
      'TH':'การได้ยิน',
      'YH':'Thính giác'
    },
    flowerBuildingSixFeeling3={
      'zh-CN': '味觉感',
      'USA': 'Taste',
      'JP': '味',
      'KO': '미각',
      'TH':'การรับรส',
      'YH':'Vị giác'
    },
    flowerBuildingSixFeeling4={
      'zh-CN': '触觉感',
      'USA': 'Touch',
      'JP': 'タッチ',
      'KO': '촉감',
      'TH':'การสัมผัส',
      'YH':'Xúc giác'
    },
    flowerBuildingSixFeeling5={
      'zh-CN': '嗅觉感',
      'USA': 'Scent',
      'JP': 'におい',
      'KO': '후각',
      'TH':'การดมกลิ่น',
      'YH':'Khướu giác'
    },
    flowerBuildingSixFeeling6={
      'zh-CN': '参与感',
      'USA': 'Participation',
      'JP': '参加',
      'KO': '참여감',
      'TH':'การมีส่วนร่วม',
      'YH':'Tham gia'
    },
    flowerBuildingSixFeeling7={
      'zh-CN': '回忆感',
      'USA': 'Memory',
      'JP': '記憶',
      'KO': '추억',
      'TH':'ความทรงจำ',
      'YH':'Ghi nhớ'
    },
    flowerBuildingSixFeeling1Info={
      'zh-CN': '硬装设计、软装搭配、品牌月刊、接机着装',
      'USA': 'Fit-out design, soft outfit collocation, brand monthly, pick-up dressing',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingSixFeeling2Info={
      'zh-CN': '背景音乐、智能音箱、隔音处理、暖心服务',
      'USA': 'Background music, Intelligent speakers, sound insulation, heartwarming service',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingSixFeeling3Info={
      'zh-CN': '迎客奉茶、免费小食、晚归膳暖、美食地图、咖啡茶包',
      'USA': 'Welcome tea, free snacks, late meal, food map, coffee/tea bag',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingSixFeeling4Info={
      'zh-CN': '优质布草、物品摆放、星级床垫、优选枕头、热水足浴、品质面膜',
      'USA': 'Quality linen, article arrangement, star-rated mattress, selected pillows, foot bath and quality masks.',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingSixFeeling5Info={
      'zh-CN': '香薰系统、除臭系统、新风系统',
      'USA': 'Fragrance system, Deodorization system and Fresh air system',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingSixFeeling6Info={
      'zh-CN': '影像画廊、自助厨房、产品体验、主题活动',
      'USA': 'Images gallery, self-service kitchen, product experience, theme activities.',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    flowerBuildingSixFeeling7Info={
      'zh-CN': '时光胶囊、点评互动、问候短信、伴手礼物',
      'USA': 'Time capsule, comments& interaction, hello message, gifts',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    simplyTitle={
      'zh-CN': '索性酒店、客栈、民宿品牌介绍-旅悦集团官网',
      'USA': 'SuoXing Hotel –Floral Travel',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    simplyDesign={
      'zh-CN': '索性设计理念',
      'USA': 'Design Philosophy of Suoxing Hotel',
      'JP': 'suoxingホテルのデザイン哲学',
      'KO': 'suoxing 디자인 컨셉',
      'TH':'นโนทัศน์การออกแบบโรงแรม Suoxing',
      'YH':'Triết lý thiết kế của Khách sạn Suoxing'
    },
    simplyDesignType1={
      'zh-CN': '年轻',
      'USA': 'Comfort ',
      'JP': '若さ',
      'KO': '젊음',
      'TH':'ความเป็นหนุ่มสาว',
      'YH':'Tuổi trẻ'
    },
    simplyDesignType2={
      'zh-CN': '创意',
      'USA': 'Enthusiasm',
      'JP': '創造性',
      'KO': '창조성',
      'TH':'ความคิดสร้างสรรค์',
      'YH':'Sự sáng tạo'
    },
    simplyDesignType3={
      'zh-CN': '活力',
      'USA': 'Creativity',
      'JP': '活力',
      'KO': '활력',
      'TH':'ความมีชีวิตชีวา',
      'YH':'Sức sống'
    },
    simplyBrandIntroductionTitle={
      'zh-CN': '索性·品牌介绍',
      'USA': 'Suoxing Hotel-Brand Introduction',
      'JP': 'ドラスティックホテルとブランド紹介',
      'KO': '소성 호텔 - 브랜드 소개',
      'TH':'แนะนำแบรนด์โรงแรม Suoxing',
      'YH':'Giới thiệu về Thương hiệu Khách sạn Suoxing'
    },
    simplyBrandIntroductionInfo={//1111
      'zh-CN': '索性是旅悦集团旗下轻质连锁酒店品牌。索性以“净，如索性”为品牌理念，深度关注用户对于酒店洁净方面的核心诉求，为快节奏的城市客人提供整洁、舒适的住宿体验。索性细分为索性酒店、索性精选两个系列。',
      'USA': 'You are here for a good night\'s sleep. That’s why all our guestrooms combine simplicity, quality and convenience, inviting you into a comfortable, safe and immaculate environment. While each hotel harbours its own unique design, all deliver the same high quality service and polished décor at a great price. Couples or singles, on business or leisure, our teams welcome everybody with enthusiasm and care.',
      'JP': '索性ホテルは、LvYueグループ傘下のホテルブランドです。「アズクリーンアズドラスティックホテル」のブランド哲学を支持し、非常に重要視しています。ホテルの清潔さに対するユーザーの中核的な要求に細心の注意を払い、ペースの速い都市のゲストに清潔で快適な宿泊体験を提供します。ホテルは索性 ホテルと索性 ホテルSに分類されます。',
      'KO': '고객은 여기서 편안히 잠에 빠질수 있다.모든 객실은 심플,퀄리티,편리를 종합하여 오직 여기서 머무는 고객들에게 깨끗하고 안전하고 편안한 환경을 제공해주려고 한다.모든 Suoxing호텔지점마다 서로다른 디자인 컨셉이지만 우리의 고퀄리티 서비스는 변함이 없다.싱글/커플,비지니스/ 투어 서비스팀은 열정으로 모든고객들을 환영한다.',
      'TH':'Suoxing Hotel เป็นโรงแรมเครือข่ายเพื่อชีวิตเบา ๆ ภายใต้กลุ่มบริษัท LvYue ยึดถือปรัชญาแบรนด์ "บริสุทธ์เหมือน Suoxing " ให้ความสำคัญอย่างยิ่งกับความต้องการหลักของลูกค้าในเรื่องความสะอาด และให้ผู้เข้าพักในเมืองอย่างรวดเร็วด้วยประสบการณ์ที่พักที่สะอาดและสะดวกสบาย และมอบประสบการณ์ที่พักที่สะอาดและสะดวกสบายแก่ผู้เข้าพักในเมือง Suoxing Hotel แบ่งออกเป็น Suoxing Hotel และ Suoxing Hotel S',
      'YH':'Khách sạn Suoxing là một thương hiệu khách sạn chuỗi nhẹ thuộc Tập đoàn LvYue. Nó duy trì triết lý thương hiệu "Sạch sẽ như Khách sạn Suoxing", rất coi trọng nhu cầu sạch sẽ của người dùng và cung cấp cho khách đô thị nhịp độ nhanh trải nghiệm chỗ ở sạch sẽ và thoải mái. Khách sạn Suoxing gồm hai loại là Khách sạn Suoxing và Khách sạn Suoxing S.'
    },
    suoxinBuildingaboutfbType1={
      'zh-CN':'轻质连锁酒店品牌',
      'USA':'Economy Hotel',
      'JP':'ミッドレンジシティホテル'
    },
    suoxinBuildingaboutfbType2={
      'zh-CN':'净如索性 随心而居',
      'USA':'Smart Rates for Smart Travellers',
      'JP':'ミッドレンジシティホテル'
    },
    simplyBrand1={
      'zh-CN': '索性精选',
      'USA': 'Suoxing Hotel S',
      'JP': 'suoxingホテルS',
      'KO': 'Suoxing호텔 S',
      'TH':'Suoxing Hotel S',
      'YH':'Khách sạn Suoxing S'
    },
    simplyBrand2={
      'zh-CN': '索性',
      'USA': 'Suoxing',
      'JP': 'Suoxing',
      'KO': 'Suoxing',
      'TH':'Suoxing',
      'YH':'Suoxing'
    },
    simplyBrand1Introduction={
      'zh-CN': '空间升级、视觉升级、服务升级、舒适与品质一样都不能少。',
      'USA': 'Upgraded spaces, visions and services where comfort and quality are essential.',
      'JP': ' サービス、快適性、スペース、ビジョン、品質の向上は不可欠なsuoxingホテルS',
      'KO': '공간의 진화,최적화 서비스,편안하고 퀄리티있는 휴게공간',
      'TH':'อัพเกรดพื้นที่ว่าง วิว บริการ ความสบาย และคุณภาพ เราจัดทุกอย่างที่คุณต้องการ',
      'YH':'Nâng cấp không gian, tầm nhìn và dịch vụ, sự thoải mái và chất lượng là không thể thiếu.'
    },
    simplyBrand2Introduction={
      'zh-CN': '以洁净舒适为中心，为住客提供超高性价比的住宿体验。',
      'USA': 'Concentrating on cleanliness and comfort, we offer our guests a cost effective yet quality experience.',
      'JP': '清潔さと快適さを中心に、私たちはお客様に超高効率かつ低コストの滞在体験を提供します。',
      'KO': '깨끗함,편안함에 집중하고 고객으로 하여금 최고의 숙박경험을 느끼게 한다',
      'TH':'เน้นความสะอาดและความสะดวกสบาย มอบประสบการณ์การเข้าพักที่คุ้มค่าที่สุด',
      'YH':'Tập trung vào sự sạch sẽ và thoải mái, chúng tôi cung cấp cho khách hàng của chúng tôi trải nghiệm lưu trú siêu hiệu quả với chi phí cao.'
    },
    WeiLaiTitle={
      'zh-CN': '蔚徕酒店、客栈、民宿品牌介绍-旅悦集团官网',
      'USA': 'Vyluk Hotel-Floral Travel',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    WeiLaiDesign={
      'zh-CN': '蔚徕设计理念',
      'USA': 'Design Philosophy of Vyluk Hotel ',
      'JP': '蔚徕ホテルのデザイン哲学',
      'KO': 'Vyluk 디자인 이념',
      'TH':'ไอเดียการออกแบบของโรงแรม Vyluk',
      'YH':'Triết lý thiết kế của Khách sạn Vyluk'
    },
    WeiLaiDesignType1={
      'zh-CN': '时尚',
      'USA': 'Fashion',
      'JP': 'ファッション',
      'KO': '패션',
      'TH':'ความทันสมัย',
      'YH':'Thời trang'
    },
    WeiLaiDesignType2={
      'zh-CN': '品质',
      'USA': 'Quality',
      'JP': '品質',
      'KO': '품질',
      'TH':'คุณภาพ',
      'YH':'Chất lượng'
    },
    WeiLaiDesignType3={
      'zh-CN': '共享',
      'USA': 'Sharing',
      'JP': '共有',
      'KO': '공유',
      'TH':'การแบ่งปัน',
      'YH':'Chia sẻ'
    },
    WeiLaiBrandIntroductionTitle={
      'zh-CN': '蔚徕·品牌介绍',
      'USA': 'Vyluk Hotel -Brand Introduction',
      'JP': '蔚徕·ブランド紹介',
      'KO': 'Vyluk 호텔 - 브랜드 소개',
      'TH':'แนะนำแบรนด์ Vyluk',
      'YH':'Giới thiệu về Thương hiệu Khách sạn Vyluk'
    },
    WeiLaiBrandIntroductionInfo={
      'zh-CN': '蔚徕以梦想交互作为品牌的设计初衷，是探索将人工智能与酒店融合的践行者。蔚徕遴选城市核心地段，产品设计采用现代主义风格，并铺设大量智能交互设备，酒店用品均采用五星酒店同等规格，旨在为顾客提供一个科技、健康、安全、有趣的居停空间，可以在忙碌的商务出行之余，拥有一处放松身心的人生间隙之所',
      'USA': 'Based in city hotspots, Vyluk is a new style of urban hotel, welcoming guests who seek more than just a cosy room and restaurant. Innovative and tech-friendly, with multifunctional, convertible spaces designed for a versatile lifestyle, Vyluk Hotels provide practical, clean, comfortable and convivial environments for creative meetings, relaxation and social gatherings. ',
      'JP': '都市のホットスポットに拠点を置く蔚徕は、居心地の良い部屋やレストラン以上のものを求めるゲストを歓迎する都市型ホテルの新しいトレンドです。革新的で優れている技術。多機能なコンバーチブルスペースは、多目的なライフスタイルのために想像されています。 蔚徕ホテルは、実用的で清潔、快適で楽しい環境を提供します。 \n' +
      'スペースの完璧なコレクションをお楽しみください。 未来を見据え、すべてが美しいものをリンクします。 ',
      'KO': '현시대 고객들이 품질,커뮤니케이션,차별화에 대한 부동한 욕구에 적응하기위하여Vyluk는 도시의 핵심지역을 선택하여 씨티형호텔의 새로운 표준을 만들려고한다. \n' +
      '설계단계부터 숙박+커뮤니케이션이라는 주제에 포인트를 두어 고객들이 객실내에서의 편안한 휴식뿐만아니라 호텔 퍼블릭지역에도 휴식뿐만 아닌 기타 기능을 부여하여건축공간의 이용율을 상승시키고 숙박에 라이프라는 새로운 개념을 주입시켰다. ',
      'TH':'ตั้งอยู่ในจุดฮิตในเมือง Vyluk เป็นเทรนด์ใหม่ของโรงแรมในเมืองที่ต้อนรับแขกที่กำลังมองหาโรงแรมที่สะดวกสบายซึ่งมากกว่าห้องพักและร้านอาหาร วางแผนเพื่อชีวิตที่หลากหลายด้วยนวัตกรรมใหม่ เทคโนโลยีที่เป็นมิตร และพื้นที่อเนกประสงค์ โรงแรม Vyluk สร้างสภาพแวดล้อมที่สะอาด สะดวกสบายและสนุกสนาน สำหรับผู้ที่มองหาที่ประชุมสร้างสรรค์ ที่พักผ่อนหรือที่สังสรรค์ทางสังคม \n' +
      ' ',
      'YH':'Để đáp ứng nhu cầu vào ở đa chiều của khách hàng như tính cách hóa, chất lượng hóa, đa dạng hóa, xã hội hóa và chia sẻ, khách sạn Vyluk lựa chọn mảnh đất trung tâm của thành phố để xây dựng phong cách mới của khách sạn thành phố. Về mặt thiết kế, chú trọng việc xây dựng lối sống và đánh bóng chi tiết, không chỉ cung cấp cho khách hàng được trải nghiệm không gian ngủ ngon, nghe nhìn và thoải mái trong phòng trọ, mà cả không gian công cộng của khách sạn có thể thực hiện chuyển đổi đa chức năng, không chỉ nâng cao việc tận dụng không gian có hiệu quả, thực hiện sự kết hợp hoàn hảo giữa cuộc sống và thưởng thức không gian của khách sạn. Liên kết tất cả sự tuyệt vời để thấy được tương lai bất phàm'
    },
    WeiLaiCorevalueTitle={
      'zh-CN': '服务核心价值',
      'USA': 'Core Service values',
      'JP': '核心サービスの価値',
      'KO': '서비스 핵심 가치',
      'TH':'ใจความหลักของการบริการ',
      'YH':'Giá trị dịch vụ cốt lõi'
    },
    WeiLaiCorevalueIntroduction={//1111
      'zh-CN': '以舒适、好客、物超所值为使命，为每一位客人打造友好的服务、整洁的客房、舒适亲切的环境。',
      'USA': 'Our mission is to provide comfort, hospitality and value for money, with tailored friendly service, clean rooms and comfortable environments for every guest ',
      'JP': '快適さ、ホスピタリティをミッションとして、私たちはすべてのお客様のために、価値のあるフレンドリーなサービス、清潔な部屋、快適な環境を提供します。',
      'KO': '모든고객에게 편안한 휴게공간,꺠끗한 객실 ,친근한 서비스를 제공',
      'TH':'มุ่งรักษาหน้าที่ในการมอบความสะดวกสบาย การต้อนรับและความคุ้มค่า<br/> เพื่อให้บริการที่เป็นมิตร ห้องพักสะอาดและสภาพแวดล้อมที่สะดวกสบายสำหรับแขกทุกคน',
      'YH':'Với sự thoải mái, lòng hiếu khách và giá trị tiền tệ như sứ mệnh, chúng tôi cung cấp các dịch vụ thân thiện, phòng sạch sẽ và môi trường thoải mái cho mọi khách hàng.'
    },
    WeiLaiDifference={
      'zh-CN': '思维差异化客房标准',
      'USA': 'Room experience ',
      'JP': '4次元の差別化された部屋の標準',
      'KO': '차별화된 객실 표준',
      'TH':'มาตรฐานห้องพักแบบสี่มิติ',
      'YH':'Tiêu chuẩn phòng bốn chiều khác biệt'
    },
    WeiLaiDifference1={
      'zh-CN': '温馨的客房空间',
      'USA': 'Cozy atmopshere',
      'JP': '居心地の良い部屋',
      'KO': '따뜻한 객실 공간',
      'TH':'ห้องพักที่อบอุ่น',
      'YH':'Không gian phòng ấm cúng'
    },
    WeiLaiDifference2={
      'zh-CN': '极致的影音体验',
      'USA': 'High Speed WiFi      ',
      'JP': '究極の音響体験',
      'KO': '독보적인 시각과 청각의 체험',
      'TH':'สุดยอดประสบการณ์ภาพและเสียง',
      'YH':'Trải nghiệm âm thanh lẫn hình ảnh tuyệt đỉnh'
    },
    WeiLaiDifference3={
      'zh-CN': '高速的无线网络',
      'USA': 'Comfortable bed ',
      'JP': '高速無線ネットワーク',
      'KO': '고속 wifi',
      'TH':'อินเทอร์เน็ต WIFI ความเร็วสูง',
      'YH':'Mạng không dây tốc độ cao'
    },
    WeiLaiDifference4={
      'zh-CN': '舒适的深度睡眠',
      'USA': '',
      'JP': '快適で深い眠り',
      'KO': '편안한 딥슬립',
      'TH':'การหลับสนิทที่สบาย',
      'YH':'Giấc ngủ sâu'
    },
    WeiLaiDifference5={
      'zh-CN': '别致酒店套餐',
      'USA': 'Versatile hotel experience',
      'JP': 'シックなホテルパッケージ',
      'KO': '다양한 호텔패키지',
      'TH':'แพ็คเกจโรงแรมสุดชิค',
      'YH':'Gói ưu đãi của Khách sạn Sang trọng'
    },
    WeiLaiDifference5Info={
      'zh-CN': '精致的多功能复合大厅，涵盖餐厅、工作休闲、小型会议等功能。自助洗衣房方便顾客的洗衣需求。',
      'USA': 'Exquisite multi-purpose hall, restaurants, work and leisure space, small conference rooms; and self-service laundry room.',
      'JP': '利便性が高い多目的ホールレストラン、仕事、会議やその他の機能、ランドリールームも提供致します',
      'KO': 'F&B 및 소규모 회의가능한 종합 비즈니스 센터셀프빨래방으로 고객의 세탁까지 가능',
      'TH':'ห้องโถงอเนกประสงค์ที่สุดสวยหรู ครอบคลุมทั้งร้านอาหาร โซนนั่งเล่น ห้องประชุมขนาดเล็ก และฟังก์ชั่นอื่น ๆ รวมทั้งห้องซักรีดแบบบริการตนเองเพื่อตอบสนองความต้องการด้านซักรีดของแขก',
      'YH':'Hội trường đa năng tinh tế, bao gồm các nhà hàng, công việc và giải trí, hội nghị nhỏ và các chức năng khác; và phòng giặt tự phục vụ để đáp ứng nhu cầu giặt ủi của khách.'
    },
    WeiLaiDifference6={
      'zh-CN': '中央采购系统',
      'USA': 'Central Procurement System ',
      'JP': '中央調達システム',
      'KO': '구매 시스템',
      'TH':'ระบบจัดซื้อจัดจ้างส่วนกลาง',
      'YH':'Hệ thống mua sắm trung ương'
    },
    WeiLaiDifference6Info={
      'zh-CN': '店vi产品、客用品、印刷品、小商品集中采购。',
      'USA': 'Group purchasing of hotel products, guest supplies, leaflets, small commodities etc.',
      'JP': 'ホテルVI製品、ゲスト用品、リーフレット、小物のグループ購入。',
      'KO': 'VI제품,어메니티,인쇄물,소상품 일괄 구매 ',
      'TH':'การสั่งซื้อผลิตภัณฑ์ VI  อุปกรณ์สำหรับแขก แผ่นพับ  สินค้าขนาดเล็ก',
      'YH':'Nhóm mua sản phẩm của Khách sạn VI, đồ dùng cho khách, tờ rơi, hàng hóa nhỏ.'
    },
    homePageSwiperFourVacation={
      'zh-CN': '景区旅行，就住花筑',
      'USA': 'Scenic travel, live in Floral, and contact us now',
      'JP': '地域の独創性を取り入れます。',
      'KO': '지역 독창성을 품다',
      'TH':'Floral Hotel – โอบอุ้มความคิดริเริ่มสร้างสรรค์จากพื้นถิ่น',
      'YH':''
    },
    homePageSwiperFourBrandintroductionInof3={
      'zh-CN': '在这里，您可以安然入睡。我们所有的客房都结合了简约、品质和便利，只为让您走入舒适、安全、洁净无瑕的环境。\n' +
          '虽然每一家索性酒店都有其独特的设计风格，但我们的高品质服务都始终如一，致力于带来高性价比的住宿体验。\n' +
          '无论您是双人还是单人出行，商务或者是休闲旅行，我们的团队将以热情和周到迎接每一位客人。 ',
      'USA': " You are here for a good night's sleep. That’s why all our guestrooms combine simplicity, quality and convenience, inviting you into a comfortable, safe and immaculate environment.<br/>While each hotel harbours its own unique design, all deliver the same high quality service and polished décor at a great price. Couples or singles, on business or leisure, our teams welcome everybody with enthusiasm and care.",
      'JP': '客室はシンプル、品質、便利さを兼ね備え、快適で安全な環境となっております。各ホテルには独自のデザインが備わっており、高品質のサービスと洗練された装飾を提供致します。カップルまたはシングルをご用意しており、ビジネスやレジャーを問わずご満足頂けるよう、熱意と誠意を持って、お待ちしております',
      'KO': '고객은 여기서 편안히 잠에 빠질수 있다.모든 객실은 심플,퀄리티,편리를 종합하여 오직 여기서 머무는 고객들에게 깨끗하고 안전하고 편안한 환경을 제공해주려고 한다.모든 Suoxing호텔지점마다 서로다른 디자인 컨셉이지만 우리의 고퀄리티 서비스는 변함이 없다.싱글/커플,비지니스/ 투어 서비스팀은 열정으로 모든고객들을 환영한다.',
      'TH':'ในที่นี่ คุณจะนอนหลับฝันดี ห้องพักทุกห้องของเราผสมผสานความเรียบง่าย คุณภาพและความสะดวกสบาย เชิญคุณเข้าสู่สภาพแวดล้อมที่สะดวกสบาย ปลอดภัยและบริสุทธิ์  โรงแรมแต่ละแห่งได้รับการออกแบบอย่างมีเอกลักษณ์ เพื่อมอบบริการที่มีคุณภาพสูงด้วยการตกแต่งที่สวยงามในราคาที่สุดคุ้ม ไม่ว่าจะเป็นคู่หรือเดี่ยว เพื่อธุรกิจหรือเพื่อการพักผ่อน ทีมงานของเรายินดีต้อนรับทุกคนด้วยความกระตือรือร้นและความเอาใจใส่ ',
      'YH':'Quý khách sẽ được trải nghiệm 1 giắc ngủ ngon ở đây. Bởi vì tất cả các phòng của chúng tôi là sự kết hợp giữa sự đơn giản, chất lượng và thuận tiện nó sẽ đưa bạn vào một môi trường thoải mái, an toàn và trong sạch. Mỗi khách sạn đều có một thiết kế độc đáo, tất cả đều cung cấp dịch vụ chất lượng cao và trang trí bóng bẩy với mức giá hấp dẫn. Cặp đôi hay là người độc thân, trong công việc hoặc khi giải trí, đội ngũ nhân viên của chúng tôi luôn luôn chào đón tất cả với sự nhiệt tình và quan tâm.'
    },
    homePageSwiperFourDesignideaInfo3={
      'zh-CN': '轻质连锁酒店品牌',
      'USA': 'Economy Hotel',
      'JP': 'エコノミーホテル',
      'KO': '이코노미 호텔',
      'TH':'โรงแรมราคาประหยัด',
      'YH':'Khách sạn Economy'
    },
    homePageSwiperFiveJoinRemarkTips={
      'zh-CN': '备注说明请在这里输入',
      'USA': 'Please write any notes here',
      'JP': 'ご意見',
      'KO': '메모를 입력하십시오',
      'TH':'กรุณากรอกหมายเหตุ',
      'YH':'Vui lòng ghi chú tại đây'
    },
    groupTitle={
      'zh-CN': '关于旅悦-旅悦集团官网',
      'USA': 'About LvYue Group-Floral Travel',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    joinUsInfo={
      'zh-CN': '旅悦集团是携程集团的战略投资公司，以“携手大数据，拥抱互联网”为特色；致力于打造比肩全球的旅游全产业链服务商，现诚邀您筑梦掘金蔚徕，期待您的加盟。',
      'USA': 'WIth strategic investment from Ctrip, LvYue is a tourism group that is integrating hotel management, information technology and trade market purchases.  By tapping into big data, LvYue is devoted to building a whole-industry-chain service provider by applying Internet innovative technologies to the traditional tourism industry to enrich partners and guest experiences. We sincerely invite you to build your career and our dream. Tap into the future with us. We look forward to you joining our team.',
      'JP': 'Ctrip の戦略的投資な旅悦は、ホテル管理、情報技術、ホテル用品貿易を統合した観光グループであり、ビッグ データを活用して、従来の観光産業にインターネットの革新的な技術を通してパートナー とゲストに豊かな体験を与え、業界全体のチェーンサービスプロバイダーの構築に専念しております。私たちは心よりお客様を歓迎致します。一緒に素晴らしい未来を築きましょう。ぜひ私たちへ加入お待ちしております。',
      'KO': 'Ctrip이 전략적 투자로 설립된 호텔매니지먼트,정보기술,무역등 영역을 결합한 종합적여행산업그룹이다.LvYue그룹은 여행산업의 건설과 운영에 집중하고 인터넷 신기술을 전통적인 여행관광산업에 응용하여 전통업계의 지능화,인터넷화의 발전을 도모하고있다.여러분을 미래 여행산업 발전에 참여하는곳으로 요청합니다.',
      'TH':'กลุ่ม Lv Yue เป็นบริษัทที่ได้รับการลงทุนเชิงกลยุทธ์จาก Ctrip LvYue เป็นบริษัทท่องเที่ยวที่รวมการจัดการโรงแรม เทคโนโลยีสารสนเทศ และการจัดซื้อและการค้า ด้วยการใช้ข้อมูลบิ๊กดาต้า LvYue มุ่งมั่นที่จะสร้างบริษัทผู้ให้บริการที่มีห่วงโซ่อุตสาหกรรมแบบครบวงจร ด้วยการนำนวัตกรรมทางอินเทอร์เน็ตมาใช้กับอุตสาหกรรมการท่องเที่ยวแบบดั้งเดิม เพิ่มประสบการณ์ให้แก่พันธมิตรและลูกค้าของเรา เราจริงใจที่จะเชิญคุณมาร่วมสร้างความฝันเพื่อก้าวสู่อนาคตของเรา หวังว่าจะได้รับความร่วมมือจากคุณ',
      'YH':''
    },
    payNewsMoney={
      'zh-CN': '（收费浏览：5元）',
      'USA': '(Charged Browsing: 5 Yuan)',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    payNewsMoney1={
      'zh-CN': '(支付金额：5元)',
      'USA': '(Charged Browsing: 5 Yuan)',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    teamLeaderName1 = {
      'zh-CN': '周荣',
      'USA': 'Zhou Rong',
      'JP': 'Zhou Rong',
      'KO': 'Zhou Rong',
      'TH':'Zhou Rong (โจวหยง)',
      'YH':'Zhou Rong'
    },
    teamLeaderName2 = {
      'zh-CN': '周亚钢',
      'USA': 'Zhou Yagang',
      'JP': '周亚钢（シュウ　アコウ）',
      'KO': '쩌우야강（Zhou Yagang）',
      'TH':'Zhou Yagang (โจว หยากาง)',
      'YH':'Zhou Yagang'
    },
    teamLeaderName3 = {
      'zh-CN': '邹正宸',
      'USA': 'Zou Zhengchen',
      'JP': 'Zou Zhengchen',
      'KO': 'Zou Zhengchen',
      'TH':'Zou Zhengchen',
      'YH':'Zou Zhengchen'
    },
    Leadership = {
      'zh-CN': '集团领导',
      'USA': 'Leadership',
      'JP': 'リーダーシップ',
      'KO': '그룹 임원',
      'TH':'คณะผู้บริหาร',
      'YH':'Lãnh đạo'
    },
    LeadershipIntro = {
      'zh-CN': '集团领导介绍',
      'USA': 'Leadership Introduction',
      'JP': 'リーダーシップ紹介',
      'KO': '그룹 임원',
      'TH':'แนะนำผู้บริหารกลุ่ม',
      'YH':'Lãnh đạo của tập đoàn'
    },
    LeadershipTitle1 = {
      'zh-CN': '集团领导-旅悦集团官网',
      'USA': 'Leadership Hotel-Floral Travel',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    teamLeader1 = {
      'zh-CN': '<p class="executive_title">周荣</p><p class="executive_job">旅悦集团CEO</p>',
      'USA': '<span class="executive_title">Zhou Rong</span><span class="executive_job_usa">CEO of Lvyue Group </span>',
      'JP': '<span class="executive_title">周栄</span><span class="executive_job_usa">旅悦グループCEO</span>',
      'KO': '<span class="executive_title">Zhou Rong</span><span class="executive_job_usa">CEO of Lvyue Group</span>',
      'TH':'<span class="executive_title">Zhou Rong</span><span class="executive_job_usa">CEO of Lvyue Group </span>',
      'YH':'<p class="executive_title">Zhou Rong</p><p class="executive_job">CEO of Lvyue Group</p>'
    },
    teamLeader2 = {
      'zh-CN': '<p class="executive_title">邹正宸</p><p class="executive_job">旅悦集团CSO</p>',
      'USA': '<span class="executive_title">Zou Zhengchen</span><span class="executive_job_usa">CSO of Lvyue Group</span>',
      'JP': '<span class="executive_title">邹正宸</span><span class="executive_job_usa">旅悦グループCSO</span>',
      'KO': '<span class="executive_title">Zou Zhengchen</span><span class="executive_job_usa">CSO of Lvyue Group</span>',
      'TH':'<span class="executive_title">Zou Zhengchen</span><span class="executive_job_usa">CSO of Lvyue Group</span>',
      'YH':'<p class="executive_title">Zou Zhengchen</p><p class="executive_job">CSO of Lvyue Group</p>'
    },
    teamLeaderZhiwei1 = {
      'zh-CN': '旅悦集团CEO',
      'USA': 'President of Qunar.com and CEO of LvYue Group ',
      'JP': 'Qunarの社長　　旅悦グループのCEO',
      'KO': 'Qunar사장 LvYue그룹 CEO',
      'TH':'ประธาน Qunar.com และ CEO ของกลุ่มบริษัท LvYue ',
      'YH':'Chủ tịch Qunar.com và Tổng Giám đốc Điều hành của Tập đoàn LvYue'
    },
    teamLeaderZhiwei2 = {
      'zh-CN': '旅悦集团COO',
      'USA': 'COO of LvYue Group',
      'JP': '旅悦グループCOO',
      'KO': 'LvYue그룹 COO',
      'TH':'COO ของกลุ่มบริษัท LvYue',
      'YH':'Giám đốc Điều hành của Tập đoàn LvYue'
    },
    teamLeaderZhiwei3 = {
      'zh-CN': '旅悦集团CFO',
      'USA': 'CFO of LvYue Group',
      'JP': '旅悦グループCFO',
      'KO': 'LvYue그룹 CFO',
      'TH':'CFO ของกลุ่มบริษัท LvYue',
      'YH':'Giám đốc Tài chính Tập đoàn LvYue'
    },
    teamLeaderDesc1 = {
      'zh-CN': '上海交通大学金融硕士及国际金融学士学位。<br/>2004年加入携程，历任携程审计部、新业务发展部负责人；随公司的扩张，参与了易游网、永安旅游、天海邮轮的收购整合和创立的工作。<br/>2015年7月任艺龙首席运营官。<br/>2018年担任携程大住宿事业群首席商务官（CBO）。<br/>2020年2月出任携程大住宿首席战略官（CSO），负责平台、产品，以及大住宿控股公司的管理工作。<br/>2020年12月，出任旅悦集团CEO。',
      'USA': 'Master of Finance and Bachelor of International Finance from Shanghai Jiao Tong University.<br/>He joined Trip.com Group in the year of 2004, and had performed successively as the head of Auditing Department and New Business Development. With the expansion of the company, he participated in the acquisition, integration and establishment of Elong, Inc., Wing On Travel and SkySea Holding International Ltd.<br/>Chief Operating Officer of Elong, Inc. in July 2015.<br/>In 2018, he served as the Chief Business Officer (CBO) of Accommodation Business Group in Trip.com Group.<br/>In February 2020, he served as the Chief Strategic Officer (CSO) of Accommodation Business Group of Trip.com Group, responsible for the management of platform, products and holding companies of Accommodation Business Group.<br/>CEO of Lvyue Group in December, 2020.',
      'JP': '上海交通大学で財務学の修士と国際金融の学士を取得しています。<br/>2004年にCtripに入社し、Ctripの監査部門と新規事業開発部門の責任者を務めました。会社の拡大に伴い、Easy Travel、Yongan Travel、Tianhai Cruiseの買収、統合、設立に参加しました。<br>2015年7月、eLongの最高執行責任者を務めました。<br>2018年、Ctrip宿泊事業グループ最高商務責任者（CBO）を務めました。<br>2020年2月、Ctrip最高戦略責任者（CSO）に任命されました。<br>2020年12月、旅悦グループCEOに就任しました。',
      'KO': 'Master of Finance and Bachelor of International Finance from Shanghai Jiao Tong University.<br/>He joined Trip.com Group in the year of 2004, and had performed successively as the head of Auditing Department and New Business Development. With the expansion of the company, he participated in the acquisition, integration and establishment of Elong, Inc., Wing On Travel and SkySea Holding International Ltd.<br/>Chief Operating Officer of Elong, Inc. in July 2015.<br/>In 2018, he served as the Chief Business Officer (CBO) of Accommodation Business Group in Trip.com Group.<br/>In February 2020, he served as the Chief Strategic Officer (CSO) of Accommodation Business Group of Trip.com Group, responsible for the management of platform, products and holding companies of Accommodation Business Group.<br/>CEO of Lvyue Group in December, 2020.',
      'TH':'Master of Finance and Bachelor of International Finance from Shanghai Jiao Tong University.<br/>He joined Trip.com Group in the year of 2004, and had performed successively as the head of Auditing Department and New Business Development. With the expansion of the company, he participated in the acquisition, integration and establishment of Elong, Inc., Wing On Travel and SkySea Holding International Ltd.<br/>Chief Operating Officer of Elong, Inc. in July 2015.<br/>In 2018, he served as the Chief Business Officer (CBO) of Accommodation Business Group in Trip.com Group.<br/>In February 2020, he served as the Chief Strategic Officer (CSO) of Accommodation Business Group of Trip.com Group, responsible for the management of platform, products and holding companies of Accommodation Business Group.<br/>CEO of Lvyue Group in December, 2020.',
      'YH':'Master of Finance and Bachelor of International Finance from Shanghai Jiao Tong University.<br/>He joined Trip.com Group in the year of 2004, and had performed successively as the head of Auditing Department and New Business Development. With the expansion of the company, he participated in the acquisition, integration and establishment of Elong, Inc., Wing On Travel and SkySea Holding International Ltd.<br/>Chief Operating Officer of Elong, Inc. in July 2015.<br/>In 2018, he served as the Chief Business Officer (CBO) of Accommodation Business Group in Trip.com Group.<br/>In February 2020, he served as the Chief Strategic Officer (CSO) of Accommodation Business Group of Trip.com Group, responsible for the management of platform, products and holding companies of Accommodation Business Group.<br/>CEO of Lvyue Group in December, 2020.',
    },
    teamLeaderDesc2 = {
      'zh-CN': '邹正宸毕业于北京大学和北京信息工程学院，拥有工商管理硕士和计算机软件学士学位。<br/>加入旅悦之前，先后服务于中科院软件所、艺龙和携程旅行网，历任艺龙产品副总裁、携程大住宿产品和创新副总裁等职务，有丰富的互联网产品研发和旅游行业经验。<br/>2020年12月出任旅悦集团首席战略官（CSO），负责产品研发和平台体系建设。',
      'USA': 'Zou Zhengchen graduated from Peking University with a Master of Business Administration and Beijing Institute of Information Engineering with a bachelor`s degree in Computer Software.<br />Before being associated with Lvyue Group, he successively served in the Institute of software of Chinese Academy of Sciences, Elong, Inc. and Trip.com Group. He has consecutively performed as Vice president of Products in Elong, Inc.  Vice president of Products and Innovation of Accommodation Business Group in Trip.com Group, and he also has rich experience in Internet product development and tourism industry.<br />He has become the Chief Strategic Officer (CSO) of LvYue group in December 2020, responsible for R&D of products and building of platform system.',
      'JP': '北京大学と北京情報工学研究所を卒業し、コンピューターソフトウェア学士号とMBAを取得しています。<br/>旅悦グループに入社する前、中国科学院のソフトウェア研究所、eLongとCtripネッ　　トワーク、eLong旅行副社長、Ctripの大型宿泊施設製品とイノベーションの副社長を務め、インターネット製品開発と観光業界で豊富な経験を持っています。<br/>2020年12月、旅悦グループ最高戦略責任者（CSO）を務め、開発システムの構築を担当しました。',
      'KO': 'Zou Zhengchen graduated from Peking University with a Master of Business Administration and Beijing Institute of Information Engineering with a bachelor`s degree in Computer Software.<br />Before being associated with Lvyue Group, he successively served in the Institute of software of Chinese Academy of Sciences, Elong, Inc. and Trip.com Group. He has consecutively performed as Vice president of Products in Elong, Inc.  Vice president of Products and Innovation of Accommodation Business Group in Trip.com Group, and he also has rich experience in Internet product development and tourism industry.<br />He has become the Chief Strategic Officer (CSO) of LvYue group in December 2020, responsible for R&D of products and building of platform system.',
      'TH':'Zou Zhengchen graduated from Peking University with a Master of Business Administration and Beijing Institute of Information Engineering with a bachelor`s degree in Computer Software.<br />Before being associated with Lvyue Group, he successively served in the Institute of software of Chinese Academy of Sciences, Elong, Inc. and Trip.com Group. He has consecutively performed as Vice president of Products in Elong, Inc.  Vice president of Products and Innovation of Accommodation Business Group in Trip.com Group, and he also has rich experience in Internet product development and tourism industry.<br />He has become the Chief Strategic Officer (CSO) of LvYue group in December 2020, responsible for R&D of products and building of platform system.',
      'YH':'Zou Zhengchen graduated from Peking University with a Master of Business Administration and Beijing Institute of Information Engineering with a bachelor`s degree in Computer Software.<br />Before being associated with Lvyue Group, he successively served in the Institute of software of Chinese Academy of Sciences, Elong, Inc. and Trip.com Group. He has consecutively performed as Vice president of Products in Elong, Inc.  Vice president of Products and Innovation of Accommodation Business Group in Trip.com Group, and he also has rich experience in Internet product development and tourism industry.<br />He has become the Chief Strategic Officer (CSO) of LvYue group in December 2020, responsible for R&D of products and building of platform system.',
    },
    TalentRecruitment={
      'zh-CN': '人才招聘',
      'USA': 'Careers',
      'JP': 'キャリア',
      'KO': '채용',
      'TH':'ร่วมงานกับเรา',
      'YH':'Nghề nghiệp'
    },
    floralAPPIntro = {
      'zh-CN': '旅悦集团旗下酒店官方预订平台，更是涵盖旅游攻略、 旅行定制、旅拍交友等吃、住、行、游、购、娱于一 体的真实旅途互动社区。我们为您的每一段旅程提供 最好的服务！',
      'USA': 'Floral Trip is the official hotel reservations platform and loyalty program of LvYue Group. A vibrant interactive travel community, Floral Trip also covers travel tips, top activities and attractions, socialising, travel, souvenirs, yummy delicacies, shopping and entertainment.<br/>We handpick the best for your next adventure!',
      'JP': 'フローラルトリップは、旅悦グループの公式ホテル予約プラットフォームおよびロイヤルティプログラムです。活気のあるインタラクティブな旅行コミュニティフローラルトリップは、旅行のヒント、トップアクティビティとアトラクション、ソーシャルコンタクト、旅行、お土産とおいしい料理、ショッピング、エンターテイメントもカバーしています。 次の冒険！ ',
      'KO': 'LvYue그룹이 운영하고 있는 예약 플랫폼이다.고객은 플랫폼을 통해 여행중 만날수 있는 모든문제의 솔루션을 찾을수 있다.',
      'TH':'Floral Trip เป็นแพลตฟอร์มจองโรงแรมทางการของกลุ่มบริษัท LvYue<br/> เป็นคอมมูนิตี้การท่องเที่ยวเชิงอินเทอร์แอคทีฟที่มีสีสันสดใส ซึ่งครอบคลุมทิปส์แนะนำการเดินทาง  กิจกรรมและแหล่งท่องเที่ยวสุดฮิต โซเซี่ยวและการคอนเนค การเดินทาง ของที่ระลึกและอาหารอร่อย การช้อปปิ้งและความบันเทิง เราได้คัดสรรสิ่งที่ดีที่สุดสำหรับแอดเวนเชอร์ครั้งต่อไปของคุณ!',
      'YH':'Floral Trip là phương tiện đặt phòng khách sạn chính thức và chương trình khách hàng thân thiết của Tập đoàn LvYue. Cộng đồng du lịch tương tác Floral Trip đầy thú vị cũng bao gồm các mẹo du lịch, các hoạt động và điểm thu hút hàng đầu, liên hệ xã hội, du lịch, quà lưu niệm & mua sắm và giải trí. Chúng tôi rất vui lòng được chọn cuộc phiêu lưu tiếp theo của bạn!'
    },
    floralAPPMaxim = {
      'zh-CN': '花筑旅行，带你看世界！',
      'USA': 'Floral Trip - Let\'s enjoy the world',
      'JP': '花築旅行-世界を楽しもう',
      'KO': '플로라 트립 - 세계 즐깁시다',
      'TH':'Floral Trip - สนุกไปกับโลกใบนี้กัน!',
      'YH':'Floral Trip - Hãy cùng tận hưởng thế giới'
    },
    floralFuncTitle = {
      'zh-CN': '功能介绍',
      'USA': 'Functions of Floral Trip App',
      'JP': '花築旅行アプリの機能紹介',
      'KO': '플로라 트립 공능 소개',
      'TH':'แนะนำฟังก์ชั่นของแอพพลิเคชั่น Floral Trip',
      'YH':'Giới thiệu chức năng của Ứng dụng Floral Trip'
    },
    floralReservation = {
      'zh-CN': '酒店预订',
      'USA': 'Reservation',
      'JP': '予約',
      'KO': '호텔 예약',
      'TH':'การจองโรงแรม',
      'YH':'Đặt chỗ'
    },
    floralReservationDetail1 = {
      'zh-CN': '官网预订折扣',
      'USA': 'Special membership rates<br/>  Best rate guaranteed',
      'JP': '公式ウェブサイト特別料金ベストレート保証',
      'KO': '공식사이트 예약 특별할인',
      'TH':'ส่วนลดพิเศษในเว็บไซต์ทางการ',
      'YH':'Giá đặc biệt trên trang web chính thức'
    },
    floralReservationDetail2 = {
      'zh-CN': '旅游攻略',
      'USA': '',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    floralMembership = {
      'zh-CN': '会员权益',
      'USA': 'Membership',
      'JP': '会員制',
      'KO': '맴버쉽회원 ',
      'TH':'สมาชิก',
      'YH':'Quyền thành viên'
    },
    floralMembershipDetail1 = {
      'zh-CN': '最高18种会员权益',
      'USA': 'Member benefits.',
      'JP': '会員特典。 オンラインモールで',
      'KO': '최고 18가지 혜택',
      'TH':'สิทธิสมาชิก',
      'YH':'Các quyền lợi của thành viên'
    },
    floralMembershipDetail2 = {
      'zh-CN': '会员积分兑换商城',
      'USA': 'Redeem points in online mall',
      'JP': 'ポイントを交換して、滞在して経',
      'KO': '포인트적립으로 상품교환',
      'TH':'แลกคะแนนสะสมในห้างออนไลน์',
      'YH':'Đổi điểm trong trung tâm mua sắm trực tuyến'
    },
    floralMembershipDetail3 = {
      'zh-CN': '会员成长值获取',
      'USA': 'Earn points by staying and sharing experience with us',
      'JP': '験を共有してポイントを獲得',
      'KO': '맴버십 포인트적립으로 회원등급 업그레이드',
      'TH':'รับคะแนนโดยการพักและแบ่งปันประสบการณ์กับเรา',
      'YH':'Tăng điểm bằng cách ở lại và chia sẻ kinh nghiệm với chúng tôi'
    },
    floralGuides = {
      'zh-CN': '旅行攻略',
      'USA': 'Guides',
      'JP': 'ガイド',
      'KO': '여행후기',
      'TH':'คู่มือการเดินทาง',
      'YH':'Hướng dẫn'
    },
    floralGuidesDetail1 = {
      'zh-CN': '热门目的地攻略',
      'USA': 'Travel guides for hot destinations',
      'JP': '人気の旅行先向けの旅行ガイド',
      'KO': '여행목적지에 관한 후기',
      'TH':'คู่มือการเดินทางสำหรับจุดหมายปลายทางสุดฮิต',
      'YH':'Hướng dẫn du lịch cho các điểm đến hấp dẫn'
    },
    floralCommunity = {
      'zh-CN': '旅途社区',
      'USA': 'Community',
      'JP': 'コミュニティ',
      'KO': '여행 카페',
      'TH':'คอมมูนิตี้',
      'YH':'Cộng đồng'
    },
    floralCommunityDetail1 = {
      'zh-CN': '旅途分享',
      'USA': 'Travel Pictures',
      'JP': '旅行写真、旅行メモ、友達を作る特徴的な表現。',
      'KO': '여행길 공유',
      'TH':'รูปภาพการเดินทาง',
      'YH':'Các hình ảnh du lịch'
    },
    floralCommunityDetail2 = {
      'zh-CN': '游记分享',
      'USA': 'Travel notes',
      'JP': '',
      'KO': '후기 공유',
      'TH':'บันทึกการเดินทาง',
      'YH':'Các ghi chú khi du lịch'
    },
    floralCommunityDetail3 = {
      'zh-CN': '交友玩乐',
      'USA': 'Making friends',
      'JP': '',
      'KO': '친구만들기',
      'TH':'หาเพื่อน',
      'YH':'Làm bạn'
    },
    floralCommunityDetail4 = {
      'zh-CN': '个性表达',
      'USA': 'Characteristic expression',
      'JP': '',
      'KO': '객성을 표현하기',
      'TH':'แสดงออกตัวเอ',
      'YH':'Bộc lộ đặc trưng.'
    },
    floralEvents = {
      'zh-CN': '主题活动',
      'USA': 'Events',
      'JP': 'イベント',
      'KO': '테마 활동',
      'TH':'อีเว้นท์',
      'YH':'Các sự kiện'
    },
    floralEventsDetail1 = {
      'zh-CN': '会员主题活动',
      'USA': 'Theme events for members',
      'JP': 'メンバー向けのテーマイベント、',
      'KO': '회원 테마 활동',
      'TH':'ธีมอีเว้นท์สำหรับสมาชิก',
      'YH':'Sự kiện chủ đề cho các thành viên'
    },
    floralEventsDetail2 = {
      'zh-CN': '酒店定制服务',
      'USA': 'Customised Service',
      'JP': 'カスタマイズされたサービスオン',
      'KO': '호텔서비스',
      'TH':'บริการที่ลูกค้าเลือกเองได้',
      'YH':'Dịch vụ theo yêu cầu'
    },
    floralEventsDetail3 = {
      'zh-CN': '线上、线下互动游戏',
      'USA': 'Online and offline interactive games',
      'JP': 'ラインおよびインタラクティブゲームの概要',
      'KO': '온라인/오프라인 오락',
      'TH':'เกมส์อินเทอร์แอคทีฟทั้งออนไลน์และออฟไลน์',
      'YH':'Các trò chơi tương tác trực tuyến và ngoại tuyến'
    },
    floralTickets = {
      'zh-CN': '玩乐门票',
      'USA': 'Tickets',
      'JP': 'チケット売場',
      'KO': '티켓',
      'TH':'ตั๋วและบัตร',
      'YH':'Vé'
    },
    floralTicketsDetail1 = {
      'zh-CN': '景点票务服务',
      'USA': 'Ticket service for scenic spots',
      'JP': '景勝地のチケットサービス、',
      'KO': '티켓예매',
      'TH':'จองตั๋วสถานที่ท่องเที่ยว',
      'YH':'Dịch vụ vé cho các danh lam thắng cảnh'
    },
    floralTicketsDetail2 = {
      'zh-CN': '餐厅预订',
      'USA': 'Restaurant reservation',
      'JP': 'レストラン予約ガイドサービス',
      'KO': '레스토랑 예약',
      'TH':'การจองร้านอาหาร',
      'YH':'Đặt nhà hàng'
    },
    floralTicketsDetail3 = {
      'zh-CN': '导游服务',
      'USA': 'Guide service',
      'JP': '',
      'KO': '가이드 서비스',
      'TH':'บริการมัคคุเทศก์',
      'YH':'Dịch vụ hướng dẫn'
    },
    joinUsTitleH1 = {
      'zh-CN': '携手旅悦<br>用互联网大数据做酒店',
      'USA': 'Be part of LvYue Group<br/>Powered by Internet and Big Data',
      'JP': '手を繋いで旅悦と、ビッグデータを使ってホテルを運営',
      'KO': 'LvYue와 손잡고 빅데이터로 호텔을 운영해 봅시다',
      'TH':'จับมือ LvYue พัฒนากิจการโรงแรมด้วยบิ๊กดาต้า',
      'YH':'Hợp tác cùng phát triển'
    },
    joinUsDescribe = {
      'zh-CN': '做顾客更需要的酒店',
      'USA': 'Be a hotel that customers need more',
      'JP': '顧客がもっと必要とするホテルを開店',
      'KO': '고객이 더 필요한 호텔',
      'TH':'เป็นโรงแรมที่ลูกค้าต้องการ',
      'YH':'Hãy đồng hành cùng chúng tôi, để cùng tạo ra 1 khách sạn thông minh. Đáp ứng đầy đủ nhu cầu của khách hàng và còn hơn thế nữa!'
    },
    joinUsCommonWantUs = {
      'zh-CN': '诚邀加盟',
      'USA': 'Join us',
      'JP': 'お問合せ',
      'KO': '가맹문의 ',
      'TH':'เข้าร่วมกับเรา Mr. Eric Wu',
      'YH':'Liên hệ với chúng tôi tại số ĐT'
    },
    joinUsIntroduce1 = {
      'zh-CN': '旅悦集团是携程集团的战略投资公司，前携程大住宿首席战略官周荣担任集团CEO。去哪儿，携程海量数据支撑，轻松尽览大住宿数据，助力酒店经营！',
      'USA': 'Lvyue Group was established in 2016, after incubating inside Qunar.com.  Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group, served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism.',
      'JP': '旅悦グループは2016年に設立され、前身予約サイトQunar.comから生まれました。Ctripの元最高戦略責任者である周荣がグループのCEOを務めました。 Ctrip Group、Tencent、Sequoia Capital China Fund、Baidu Capital、Goldman Sachs Group、Ou Ling Investment、CITIC Juxin、Yuanhe Origin、CaesarRadianceによる戦略的な投資です。',
      'KO': 'Lvyue Group was established in 2016, after incubating inside Qunar.com.  Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group, served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism.',
      'TH':'Lvyue Group was established in 2016, after incubating inside Qunar.com.  Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group, served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism.',
      'YH':'Lvyue Group was established in 2016, after incubating inside Qunar.com.  Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group, served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism.',
    },
    joinUsIntroduce2 = {
      'zh-CN': '是一家集酒店管理、信息技术服务、供应链采购贸易、文化旅游于一体的综合性旅游产业集团。依托资深的团队及携程、去哪儿两大OTA巨头的大数据和流量支持，致力于成为最值得信赖的目的旅游服务品牌，为消费者提供旅游度假中的「吃住行，游购娱」 360°全方位服务',
      'USA': 'Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services.',
      'JP': '旅悦グループは、ホテル管理、情報技術サービス、サプライチェーン貿易、および文化観光を統合する観光産業グループです。シニアチームと2つのOTAの大手であるCtripとQunarのデータとフローサポートに依存し、最も信頼できる目的地観光サービスブランドにむ目標し、消費者に「食事、宿泊、旅行、ショッピング、エンターテイメント」を360°サービスを提供することに取り組んでいます。<br> 旅悦グループは、インターネットのイノベーションテクノロジーを伝統的な観光産業に適用し、伝統的な観光産業のデータベース、技術、ブランドベース、および専門的な開発を実現することを目指しています。',
      'KO': 'Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services.',
      'TH':'Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services.',
      'YH':'Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services.',
    },
    joinUsIntroduce3 = {
      'zh-CN': '遍布包括日本、韩国、泰国、印度、新西兰、澳大利亚等在内的全球<span>10</span>余个国家，<span>200+</span>目的地；预计到2019年年底，酒店数量将突破<span>2600</span>家。',
      'USA': 'The LvYue Group has brought more than <span>2000</span> hotels worldwide into its network, covering more than 200 destinations in more than 10 countries including China, Japan, South Korea, Thailand, India, New Zealand and Australia. It is expected that by the end of 2019 year, the number of hotels under LvYue Group will exceed<span> 2600</span>.',
      'JP': '日本、韓国、タイ、インド、ニュージーランド、オーストラリアなどを含む世界<span>10</span>カ国以上、<span>200+</span>以上の目的地に至る;2019年末までに、ホテル数は<span>2,600</span>棟を超えると予想されます。',
      'KO': '현재까지 뤼위에 그룹은 한국을 비롯하여 일본,태국,인도,뉴질랜드,호주포함 <span>10</span>여개의 나라에 <span>200+</span>여개의 목적지에서 계약체결 및 오픈한 호텔수가<span> 2000</span>개를 초과하였고 2019년 연말까지 <span>2,600</span>개를 초과할 것으로 예상됩니다.  ',
      'TH':'มายปลายทางในมากกว่า <span>10</span> ประเทศ รวมถึงญี่ปุ่น เกาหลีใต้ ไทย อินเดีย นิวซีแลนด์ ออสเตรเลีย ฯลฯ และคาดว่าภายใสิ้นปีนี้ จำนวนโรงแรมในกลุ่มบริษัท LvYue จะเกิน <span>2,600</span> แห่ง',
      'YH':'Phân bố trên hơn<span> 10</span> quốc gia và hơn <span>200</span> điểm trên thế giới bao gồm Nhật Bản, Hàn Quốc, Thái Lan, Ấn Độ, New Zealand, Úc, v.v…; dự kiến đến cuối năm 2019, số lượng khách sạn sẽ vượt mức<span>2,600</span>khách sạn.'
    },
    joinUsHonorTitle = {
      'zh-CN': '我们的荣誉',
      'USA': 'Awards & Accolades',
      'JP': '旅悦の受賞履歴',
      'KO': '수상경력',
      'TH':'รางวัลที่ได้รับ',
      'YH':'Vinh dự của Tập đoàn'
    },
    joinUsHonor201902 = {
      'zh-CN': '2、旅悦集团荣获2019中国住宿大奖·住宿创新类',
      'USA': '2、 LvYue Group won the 2019 China Accomodation Awards and Accomodation Innovation award',
      'JP': '2. 旅悦グループが2019中国宿泊大会で・クリエーティビティ宿泊分野の賞を獲得しました。',
      'KO': '2.LvYue그룹-2019년 중국숙박업창신상-대상 수상',
      'TH':'',
      'YH':'1. Năm 2019, Tập đoàn LvYue đã giành giải thưởng Nhà ở và Sáng tạo trong Nhà ở Trung Quốc năm 2019'
    },
    joinUsHonor201903= {
      'zh-CN': '3、第12届中国大住宿业金龙奖颁奖典礼中，旅悦集团荣获“最具投资价值品牌”奖',
      'USA': '3、 In the 12th China Grand Residence Golden Dragon Awards Ceremony LvYue Group won the "Most Investment Value Brand" award',
      'JP': '3. 第十二回中国宿泊業金龍賞の授賞式にも、旅悦グループが「投資価値のあるブランド第一位」と受賞しました。',
      'KO': '3.제12계중국숙박업금룡상시상식에서 중국 최대투자가치소유상 수상',
      'TH':'2.ในพิธีมอบรางวัล China Grand Residence Golden Dragon Awards ครั้งที่ 12  กลุ่มบริษัท LvYue ได้รับรางวัล “แบรนด์การลงทุนที่คุ้มค่าที่สุด”',
      'YH':'2..Trong Lễ trao giải Rồng vàng Grand Residence Trung Quốc lần thứ 12, Tập đoàn LvYue đã giành được giải thưởng "Thương hiệu Giá trị Đầu tư lớn nhất".'
    },
    joinUsHonor201901 = {
      'zh-CN': '1、2019年，旅悦集团荣获“中国极具发展潜力管理公司” – 2019中国酒店品牌高峰论坛“高参奖”',
      'USA': '1、 LvYue was recently awarded "2019 Extreme Progressive Hotel Management Company of China" @ 2019 China Hotel Brand Conference-HOTELN Awards ',
      'JP': '1. 旅悦グループが2019中国宿泊大会で・クリエーティビティ宿泊分野の賞を獲得しました。',
      'KO': '1.뤼위에 그룹(LvYue Group)은 “China development potential management company – 2019 중국 호텔 브랜드 정상회담 포럼 “최우수 참가상”를 수상했습니다.',
      'TH':'1.ที่ฟอรัมการประชุมสุดยอดบูติกอุตสาหกรรมการท่องเที่ยวระดับนานาชาติ Zhang Qiang ประธานกรรมการ Qunar.com และ CEO  กลุ่มบริษัท LvYue ได้รับ 2 รางวัล ได้แก่ “50บุคคลมีอิทธิพลที่สุดของจีน | Meisu ·เศรษฐกิจใหม่" และ "ผู้นำการท่องเที่ยวและที่พักของจีน"',
      'YH':''
    },
    joinUsHonor201801 = {
      'zh-CN': '1、旅悦集团荣获德勤“中国明日之星”称号',
      'USA': '1、LvYue Group won the title of "China\'s Star of Tomorrow" from Deloitte',
      'JP': '1．旅悦グループがDeloitteで「明日の星」の賞を獲得しました。',
      'KO': '1. Deloitte 중국 미래의 스타 칭호 수상',
      'TH':'1.กลุ่มบริษัท LvYue ได้รับรางวัล "China’s Star of Tomorrow" ของ Deloitte',
      'YH':'1 、Tập đoàn LvYue giành danh hiệu "Ngôi sao của Ngày mai của Trung Quốc" tại Deloitte'
    },
    joinUsHonor201802 = {
      'zh-CN': '2、旅悦集团荣获2018年度智慧旅游劲旅奖',
      'USA': '2、LvYue Group won the 2018 Smart Tourism Award',
      'JP': '2. 旅悦グループが「2018年度智慧旅行」の賞を獲得しました。',
      'KO': '2. 2018년 스마트 여행 어워드상 수상',
      'TH':'2. กลุ่มบริษัท LvYue ได้รางวัลการท่องเที่ยวอัจฉริยะ2018',
      'YH':'2 、Tập đoàn LvYue đã giành giải thưởng Du lịch thông minh năm 2018'
    },
    joinUsHonor201701 = {
      'zh-CN': '旅悦集团入围“2017年中国旅游业最具影响力匠心企业”',
      'USA': 'LvYue Group was selected as "The Most Influential Enterprise in 2017 China\'s Tourism Industry"',
      'JP': '旅悦グループが「2017年中国旅行業で一番影響力を持つ匠な企業」にノミネートされました。',
      'KO': '2017년 중국여행업 최고 장심그룹 후보',
      'TH':'ในปี 2017 กลุ่ม LvYue ได้เข้าชิงรางวัล “องค์กรที่มีอิทธิพลมากที่สุดในอุตสาหกรรมการท่องเที่ยวของจีน ปี2017”',
      'YH':'Năm 2017, Tập đoàn LvYue được chọn là “doanh nghiệp có ảnh hưởng nhất ngành du lịch Trung Quốc trong năm 2017”'
    },
     joinUsHonor2019Title = {
         'zh-CN': '2019年',
         'USA': 'In 2019',
         'JP': '2019年',
         'KO': '2019년 9월',
      'TH':'ปี 2019',
      'YH':'Năm 2019'
     },
     joinUsHonor2018Title = {
         'zh-CN': '2018年',
         'USA': 'In 2018',
         'JP': '2018年',
         'KO': '2018년',
      'TH':'ปี 2018',
      'YH':'Năm 2018'
     },
     joinUsHonor2017Title = {
         'zh-CN': '2017年',
         'USA': 'In 2017',
         'JP': '2017年',
         'KO': '2017년',
      'TH':'ปี 2017',
      'YH':'Năm 2017'
     },
     joinUsTel = {
      'zh-CN': '400-898-7118',
      'USA': '0086-400-898-7118',
      'JP': '06-4256-2628',
      'KO': '0082-70-4919-7032',
   'TH':'0066-83-5238098',
   'YH':'0086-400-898-7118'
     },
     freePhone= {
      'zh-CN': '400-898-7118',
      'USA': '0086-400-898-7118',
      'JP': '06-4256-2628',
      'KO': '0082-70-4919-7032',
   'TH':'0066-83-5238098',
   'YH':'0086-400-898-7118'
     },
     joinrz={
      'zh-CN': '加盟留言',
      'USA': 'Leave your <br/> phone number',
      'JP': '電話を残す',
      'KO': '연락처 남기기',
   'TH':'แฟรนไชส์ โทร',
   'YH':'Đểlạiđiện thoại'
     },
     subhtml={
      'zh-CN': '提交信息',
      'USA': 'Submit',
      'JP': '提出する',
      'KO': '제출',
   'TH':'ยื่นข้อมูล',
   'YH':'Gửi đi'
     },
     joinTitle={
      'zh-CN': '',
      'USA': '1.Communication and Negotiation. ',
      'JP': '1.コミュニケーションと商談',
      'KO': '1.의향확인',
   'TH':'1.การติดต่อและการเจรจาหารือ',
   'YH':'1.Truyền thông và đàm phán.'
     },
     joinContent={
      'zh-CN': '',
      'USA': 'Discuss investor requirements. LvYue consultants provide expertise and guidance ',
      'JP': '投資者は投資出願を提出し、投資コンサルタントを選出、コンサルタントが丁寧に指導します',
      'KO': ' 투자자문의-투자자문',
   'TH':'ผู้ลงทุนแสดงความประสงค์ในการลงทุน ที่ปรึกษาการลงทุนให้คำปรึกษาและแนะแนว',
   'YH':'Nhà đầu tư thực hiện mong muốn, tư vấn đầu tư cung cấp dịch vụ tư vấn và hướng dẫn'
     },
     joinTitle22={
      'zh-CN': '',
      'USA': '2.Field Survey ',
      'JP': '2.現地調査',
      'KO': '2.현장실사를',
   'TH':'2.การสำรวจภาคสนาม',
   'YH':'2.Khảo sát thực địa'
     },
     joinContent22={
      'zh-CN': '',
      'USA': 'On site survey and evaluation. Project feasibility review',
      'JP': 'オフラインでプロジェクトのエスティメートを実行します',
      'KO': ' 통한 사업계획 제출',
   'TH':'ติดต่อออฟไลน์ ประเมินโครงการ',
   'YH':'liên lạc ngoại tuyến, đánh giá và đánh giá dự án'
     },
     joinTitle33={
      'zh-CN': '',
      'USA': '3.Agreement Finalisation   ',
      'JP': '3.契約の締結',
      'KO': '3.계약 및 오픈준비',
   'TH':'3.เซ็นสัญญาเพื่อเปิด',
   'YH':'3.Đăng ký khai trương.'
     },
     joinContent33={
      'zh-CN': '',
      'USA': 'Sign contract and work with pre-opening team ',
      'JP': '専門家の指導の下にコントラクトの締結と検査を行います',
      'KO': ' 계약서 전문 상담 지도 와 검사 를 체결 하다',
   'TH':'เซ็นสัญญา ที่ปรึกษามืออาชีพให้คำปรึกษาและตรวจสอบ',
   'YH':'Ký hợp đồng, tư vấn và kiểm tra chuyên gia'
     },
     joinTitle44={
      'zh-CN': '',
      'USA': '4.Decor and operations inspection ',
      'JP': '4.デコレーションの確認　',
      'KO': '4.인테리어검수 및 확인',
   'TH':'4.การส่งมอบการตกแต่งโรงแรม',
   'YH':'4.Nghiệm thu trang trí.'
     },
     joinContent44={
      'zh-CN': '',
      'USA': 'Ensure renovations and upgrades meet contract requirements ',
      'JP': 'ホテルの内外装を仕上げたあと、プロジェクトの確認手続きが完了します',
      'KO': '호텔 인테리어 완료 프로젝트 검수 통과',
   'TH':'โรงแรมตกแต่งแล้วเสร็จ และผ่านการส่งมอบ',
   'YH':'Cải tạo khách sạn, nghiệm thu dự án'
     },
     joinTitle55={
      'zh-CN': '',
      'USA': '5.Hotel Launch  ',
      'JP': ' 5.営業開始',
      'KO': '5.그랜드오픈',
   'TH':'5.การเปิดโรงแรมต้อนรับลูกค้า',
   'YH':'5.Khai trương đón khách.'
     },
     joinContent55={
      'zh-CN': '',
      'USA': 'Grand opening and platform listing across all channels',
      'JP': '　ホテルへの様々なニーズを通じて顧客を集め、オープニングします',
      'KO': '채널별 동시오픈',
   'TH':'การเปิดโรงแรมต้อนรับลูกค้าจากทุกช่องทาง ',
   'YH':'Khai trương khách sạn, đưa lên kênh truyền thông, tiếp khách'
     },
    joinUsStep = {
      'zh-CN': '加盟流程',
      'USA': 'It\'s Easy to Join LvYue',
      'JP': '加盟の流れ',
      'KO': '가맹절차',
      'TH':'ขั้นตอนการเข้าร่วม',
      'YH':'Quá trình tham gia.'
    },
    joinUsConsultation = {
      'zh-CN': '加盟咨询',
      'USA': 'Cooperation<br>consultation',
      'JP': '加盟コンサルタント',
      'KO': '가맹 상담',
      'TH':'สอบถามการแฟรนไชส์',
      'YH':'Tư vấn nhượng quyền'
    },
    joinUsConsultationWrap = {
      'zh-CN': '如想了解更多酒店加盟信息（加盟政策，回报投资率等），可拨打加盟热线或留下联系方式，将会有专属加盟顾问为您解答',
      'USA': 'If you want to know more about hotel franchise information (franchise policy, return investment rate etc.), you can call the franchise hotline or leave your contact information, an exclusive franchise consultant will contact you.',
      'JP': 'ホテル加盟について、もっと詳しく（チェーン店政策、投資利益率など）知りたい方は、直接お電話いただくか、メールフォームへご連絡先を入力してください。一対一で加盟コンサルタントがご質問にお答え致します',
      'KO': '더많은 가맹 정보를 아시고 싶으시면 (가맹 방안,투자수익등)가맹문의로 전화하시거나 연락처를 남겨주시면 전담직원이 답변을 드릴겁니다',
      'TH':'หากต้องการทราบข้อมูลเพิ่มเติมเกี่ยวกับแฟรนไชส์ของโรงแรม (เช่น นโยบายแฟรนไชส์ อัตราผลตอบแทนการลงทุน ฯลฯ) สามารถโทรหาสายด่วนแฟรนไชส์หรือให้ข้อมูลการติดต่อของคุณ ที่ปรึกษาแฟรนไชส์ของเราจะตอบทุกคำถามของคุณ',
      'YH':'Nếu bạn muốn biết thêm về thông tin nhượng quyền khách sạn (chính sách nhượng quyền, tỷ lệ đầu tư hoàn trả, v.v.), bạn có thể gọi đường dây nóng nhượng quyền hoặc để lại thông tin liên hệ, sẽ có tư vấn nhượng quyền độc quyền để trả lời cho bạn.'
    },
    joinUsJoinTelephone = {
      'zh-CN': '加盟热线',
      'USA': 'Franchise Telephone',
      'JP': 'お問合せ',
      'KO': '가맹문의 ',
      'TH':'แฟรนไชส',
      'YH':'Telephone'
    },
    intenails = {
      'zh-CN': '',
      'USA': 'Email',
      'JP': 'Eメール ',
      'KO': '이메일  ',
      'TH':'อีเมล',
      'YH':'E-mail'
    },
    dobuemai = {
      'zh-CN': '',
      'USA': 'development@lvyuetravel.com',
      'JP': 'development@lvyuetravel.com',
      'KO': 'development@lvyuetravel.com ',
      'TH':'development@lvyuetravel.com',
      'YH':'development@lvyuetravel.com'
    }
    joinUsInputName={
      'zh-CN': '请输入联系人姓名',
      'USA': 'Please enter your name',
      'JP': '連絡先の名前を入力してください',
      'KO': '성함 입력',
      'TH':'กรุณากรอกชื่อผู้ติดต่อ',
      'YH':'Vui lòng nhập tên liên hệ'
    },

    joinUsInputPhone={
      'zh-CN': '请输入手机号',
      'USA': 'Please enter your phone number',
      'JP': '携帯の番号を入力してください',
      'KO': '핸드폰 번호 입력해주세요.',
      'TH':'กรุณากรอกเบอร์โทร.ติดต่อ ',
      'YH':'Vui lòng nhập số điện thoại liên lạc'
    },
    joinUsInputAddress={
      'zh-CN': '请输入酒店物业所在地址',
      'USA': 'Please enter the address of proposed property',
      'JP': 'ホテルの不動産の住所を入力してください。',
      'KO': '호텔 부동산 주소 입력',
      'TH':'กรุณากรอกที่อยู่ของโรงแรม',
      'YH':'Vui lòng nhập địa chỉ của khách sạn'
    },
    joinUsInputRemarkTip={
      'zh-CN': '请填写您想咨询的问题',
      'USA': 'Please fill in the questions you want to consult',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    joinUsInputNameTitle={
      'zh-CN': '联系人',
      'USA': 'Name',
      'JP': '連絡先',
      'KO': '성함',
      'TH':'ชื่อ - นามสกุล',
      'YH':'Tên'
    },
    joinUsInputPhoneTitle={
      'zh-CN': '手机号',
      'USA': 'Number',
      'JP': '携帯の番号',
      'KO': '핸드폰 번호',
      'TH':'เบอร์โทร. ',
      'YH':'Số ĐT'
    },
    joinUsInputAddressTitle={
      'zh-CN': '地址',
      'USA': 'Address',
      'JP': 'ホテルの住所',
      'KO': '호텔 주소',
      'TH':'ที่อยู่',
      'YH':'Địa điểm'
    },
    joinUsInputRemarkTipTitle={
      'zh-CN': '留言',
      'USA': 'Message',
      'JP': '',
      'KO': '',
      'TH':'',
      'YH':''
    },
    joinUsInputJoinMsg={
         'zh-CN': '留下您的联系方式',
         'USA': 'Leave your contact information',
         'JP': '連絡先情報',
         'KO': '연락처 남겨주세요.',
      'TH':'ข้อมูลการติดต่อของคุณ',
      'YH':''
     },
     commonVyluk={
         'zh-CN': '蔚徕',
         'USA': 'Vyluk',
         'JP': '蔚徕',
         'KO': 'Vyluk',
      'TH':'Vyluk',
      'YH':'Vyluk'
     },
     commonVylukDes={
         'zh-CN': '新一代生活方式中档酒店',
         'USA': 'Mid-range city hotel',
         'JP': '次世代ライフスタイルシティホテル',
         'KO': '',
      'TH':'',
      'YH':''
     },
     commonSuoxingDes={
         'zh-CN': '轻质连锁酒店品牌',
         'USA': 'Light chain hotel brand',
         'JP': 'カジュアルホテルチェーンブランド',
         'KO': '가성비 프랜차이즈',
      'TH':'แบรนด์โรงแรมเครือข่ายสำหรับชีวิตเบา ๆ',
      'YH':''
     },
     commonRealShot={
         'zh-CN': '酒店实拍',
         'USA': 'Hotel Gallery',
         'JP': 'ホテル実際写真',
         'KO': '현장사진',
      'TH':'รูปถ่ายจริงของโรงแรม',
      'YH':'Chuỗi khách sạn mang tính thiết thực'
     },
     franchiseAdvantage={
         'zh-CN': '加盟优势',
         'USA': 'Franchise & Cooperation Advantages',
         'JP': '加盟の優位性',
         'KO': '가맹의 우세',
      'TH':'ข้อได้เปรียบของแฟรนไชส์',
      'YH':'Lợi ích từ nhượng quyền'
     },
     joinUs_brandTitle={
         'zh-CN': '旗下品牌',
         'USA': 'Brand Portfolio',
         'JP': '旅悦のブランド',
         'KO': '소유 브랜드',
      'TH':'แบรนด์ในเครือ',
      'YH':'Thương hiệu'
         },
     joinUs_ad1Title={
         'zh-CN': '品牌流量加持',
         'USA': 'Brand Generated Traffic Support',
         'JP': 'ブランドのフロー増強',
         'KO': '브랜드 데이터 지원',
      'TH':'สนับสนุนโดยกระแสแบรนด์ดัง',
      'YH':'Dòng chảy thương hiệu'
     },
    joinUs_ad1Des={
      'zh-CN': '携程战略控股，去哪儿携程海量数据支持，轻松尽览大住宿数据，助力酒店经营',
      'USA': 'Ctrip strategic holding, where to go, Ctrip massive data support, easy access to big accommodation data, help hotel management',
      'JP': 'シートリップ戦略ホールディングスは、どこにシートリップ海量のデータをサポートしますか？',
      'KO': '전략 적 지주, 어디 에 대량의 데 이 터 를 가지 고 지원 하 는 지, 숙박 데 이 터 를 쉽게 볼 수 있 고 호텔 경영 에 도움 을 줄 수 있 습 니 다.',
      'TH':'แบกเฉิงกลยุทธ์การควบคุมที่พกเฉิงสนับสนุนข้อมูลขนาดใหญ่ได้อย่างง่ายดายดูข้อมูลที่พักใหญ่ช่วยให้โรงแรมวิ่ง',
      'YH':'Tổ chức chiến lược Ctrip, hỗ trợ dữ liệu khổng lồ, dễ truy cập vào dữ liệu cung cấp thông tin lớn, trợ quản lý khách sạn'
     },
    joinUs_ad2Title={
      'zh-CN': '更多客源支持',
      'USA': 'More customer support',
      'JP': 'より多くの顧客サポート',
      'KO': '더 많은 고객 지원',
      'TH':'สนับสนุนแหล่งข้อมูลเพิ่มเติม',
      'YH':'Thêm hỗ trợ khách'
     },
    joinUs_ad2Des={
      'zh-CN': '专业运营团队，数千家旅行社单位/企业客户资源',
      'USA': 'Professional operation team, thousands of travel agency units / enterprise customer resources',
      'JP': '専門の運営チーム、数千の旅行会社の単位/企業の取引先の資源',
      'KO': '전문 운영 팀, 수천 개 여행사 단위 / 기업 고객 자원',
      'TH':'ทีมปฏิบัติการมืออาชีพหลายพันหน่วยงานการท่องเที่ยวและทรัพยากรของลูกค้าองค์กร',
      'YH':'Nhóm dịch vụ chuyên nghiệp, hàng ngàn đơn vị dịch vụ'
     },
    joinUs_ad3Title={
      'zh-CN': '经营状态改善',
      'USA': 'Business improvement',
      'JP': '経営状態の改善',
      'KO': '경영 상태 개선',
      'TH':'การปรับปรุงสภาพธุรกิจ',
      'YH':'Phát triển kinh doanh'
     },
   joinUs_ad3Des={
      'zh-CN': '入住率提升',
      'USA': 'Increased occupancy',
      'JP': 'チェックイン率が上がる',
      'KO': '입주 율 증가',
      'TH':'เพิ่มอัตราการเข้าพัก',
      'YH':'Tăng cường tác dụng'
     },
     joinUs_ad4Title={
      'zh-CN': '强大的技术支持',
      'USA': 'Strong technical support',
      'JP': '強力な技術サポート',
      'KO': '강력 한 기술 지원',
      'TH':'การสนับสนุนทางเทคนิคที่แข็งแกร่ง',
      'YH':'Hỗ trợ kỹ thuật mạnh'
     },
     joinUs_ad4Des={
      'zh-CN': '提供专业选址系统及XPMS门店管理系统',
      'USA': 'Provide professional location system and XPMS store management system',
      'JP': '専門サイト選択システムとXMS店舗管理システムを提供します。',
      'KO': '전문 입지 선정 시스템 및 XPMS 매장 관리 시스템 제공',
      'TH':'ให้บริการระบบการเลือกเว็บไซต์มืออาชีพและระบบการจัดการร้าน xpms',
      'YH':'Hệ thống định vị chuyên nghiệp và hệ thống quản lý kho XPMS'
     },
     joinUs_ad5Title={
         'zh-CN': '全方位会员体系',
         'USA': 'Fast Developing Loyalty Program',
         'JP': '完備な会員システム',
         'KO': '맴버쉽회원 시스템',
      'TH':'ระบบสมาชิกภาพรอบทิศทาง',
      'YH':'Hệ thống thành viên đa hướng.'
     },
     joinUs_ad5Des={
      'zh-CN': '共享花筑全球会员体系，精准营销，个性化服务',
      'USA': 'Sharing Huazhu global membership system, precision marketing and personalized service',
      'JP': '共有花は全世界の会員システムを構築し、正確な営業、個人化サービスを提供します。',
      'KO': '공유 꽃 은 글로벌 회원 시스템 구축, 정확 한 마 케 팅, 맞 춤 형 서비스 구축',
      'TH':'แบ่งปันดอกไม้สร้างระบบสมาชิกทั่วโลกการตลาดที่ถูกต้องและบริการส่วนบุคคล',
      'YH':'Chia sẻ hệ thống thành viên quốc tế Hoài, thị trường chính xác và dịch vụ cá nhân'
     },
     joinUs_ad6Title={
         'zh-CN': '酒店人才输出',
         'USA': 'Hotel Talents Pool  ',
         'JP': 'ホテル人材育成',
         'KO': '호텔 전문인력 지원',
      'TH':'การส่งออกบุคลากรเชียวชาญด้านการโรงแรม',
      'YH':'Khách sạn tài năng xuất khẩu.'
     },
     commonJtc={
      'zh-CN': '檀程',
      'USA': 'Arula  ',
      'JP': '檀程',
         'KO': 'Arula   ',
      'TH':'Arula ',
      'YH':'Arula '

     },
     commonBanlan={
      'zh-CN': '般蓝',
      'USA': 'Banlan',
      'JP': '般蓝',
      'KO': '',
      'TH':'',
      'YH':''
     },
     buftlanguage1={
      'zh-CN': '休闲放松',
      'USA': ' Unwind  ',
     },
     decslan1={
      'zh-CN': '环境舒适安静，伴您好梦酣眠 <br/>现代化网络设备，享受轻松时光<br/> 品质洗浴设施，尽情放松身心 <br/>',
      'USA': ' Comfortable and quiet for a deep sleep.<br/> Modern and connected for a relaxing time.<br/>Quality amenities for a soothing shower. <br/>  ',
     },
     buftlanguage2={
      'zh-CN': '商务办公',
      'USA': ' Work  ',
     },
     decslan2={
      'zh-CN': '客房配备小型办公区，满足商<br/> 务办公需求<br/>',
      'USA': ' A small office area is here for you <br/> to finish your business preparations ',
     },
     buftlanguage3={
      'zh-CN': '智能连接',
      'USA': ' Connected  ',
     },
     decslan3={
      'zh-CN': ' 无论工作或是娱乐 <br/>智能电视和高速网络让您的入<br/> 住体验更加丰富多彩 <br/>',
      'USA': ' For work or fun, our smart TV and <br/> high-speed internet are here to <br/> enrich guests room experience' ,
     },
     aruati={
      'zh-CN': '客房',
      'USA': ' Room  ',
     },
     commonJtcDes={
       'zh-CN': '高端酒店和度假村品牌',
      'USA': 'Premium Hotels and Resorts  ',
      'JP': '高級ホテルそしてリゾート',
      'KO': '고급 호텔그리고리조트 브랜드',
   'TH':'โรงแรมระดับไฮเอนด์และรีสอร์ท',
   'YH':'Khách sạn cao cấp Và Khu nghỉ dưỡng'
     },
     commonBainaDes={
      'zh-CN': '中端商务酒店',
      'USA': 'Mid-range Business Hotel',
      'JP': 'ビジネスホテル',
      'KO': 'Mid-range Business Hotel',
      'TH':'Mid-range Business Hotel',
      'YH':'Mid-range Business Hotel'
     },
     commonBanlanDes={
      'zh-CN': '隐世设计酒店',
      'USA': 'Hidden World Design Hotel',
      'JP': '隠された世界のホテル',
      'KO': '',
      'TH':'',
      'YH':''
     },
     tanchenDesignType1={
      'zh-CN': '心驰神往 ',
      'USA': 'Inviting  ',
      'JP': ''
     },
     tanchenDesignType2={
      'zh-CN': '怡然自得 ',
      'USA': ' Comfortable ',
      'JP': ''
     },
     tanchenDesignType3={
      'zh-CN': '彬彬有礼 ',
      'USA': 'Courteous  ',
      'JP': ''
     },
     tanchenDesign={
      'zh-CN': '檀程设计理念 ',
      'USA': 'Design Philosophy of Arula Hotels & Resorts  ',
      'JP': ''  
     },
     tanchenBrandIntroductionTitle={
      'zh-CN': '檀程·品牌介绍 ',
      'USA': ' Arula Hotels & Resorts ',
      'JP':'檀程·ブランド紹介'
     },
     tanchenBuildingaboutfbType1={
      'zh-CN': '高端酒店及度假村 ',
      'USA': 'Premium Hotels & Resorts  ',
      'JP':'高級ホテルとリゾート'
     },
     tanchenBrandIntroductionInfo={
      'zh-CN': '高端酒店及度假村品牌檀程，为您提供融合中式热情与国际化标准的待客之道。<br/>每一家檀程都独具特色，对极致服务的追求则如出一辙。优越地段、殷勤款待、佳肴美馔……至于此，沉浸悠闲惬意之旅。<br/>无论是商务或是休闲，在您踏入酒店的第一刻，宾至如归的感受将和关怀备至的员工一起，时时伴您左右。 ',
      'USA': 'Arula is a premium hotels and resorts brand combining international hospitality with a true sense of Chinese welcome. While every Arula hotel is unique, all share the same dedication for high-quality service. Discover excellently located hotels that offer caring attentions, delightful food and drink, and places to relax. Helped by calm and considerate employees, guests find it easy to pursue their own design, whether it is business or pleasure.  ',
      'JP':'高級ホテル＆リゾート檀程は、中国のおもてなしとインターナショナルなサービスを提供します。それぞれの檀程には独自の特徴があり、究極のサービスの追求し、 絶好のロケーション、おもてなし、おいしい料理などビジネスでもレジャーでも、ホテルに足を踏み入れた瞬間は、いつでもあなたのそばにいる思いやりのあるスタッフとくつろげるでしょう。'
     },
     tanchenBuildingaboutfbType3={
      'zh-CN': '檀程，尽享心意之地。 ',
      'USA': 'Our ambition. Help you follow yours.  ',
      'JP': '檀程、あなたの心の旅を楽しんでください'
     },
     acTl1={
      'zh-CN': ' 城中世外桃源',
      'USA': 'Atmosphere Ambition ',
     },


     acDec1={
      'zh-CN': '简约、宁静、中式优雅 ',
      'USA': 'Simple Design &nbsp&nbsp    Quiet Atmosphere &nbsp&nbsp    Chinese Elegance ',
     },
     acDF1={
      'zh-CN': '高贵典雅与静谧宁和交融于此，<br/>温馨与精致渗透于细节之中，<br/>在轻松愉悦中享用美食、放松身心，体验中式殷勤待客之道，这里是现代旅行者停泊的理想港湾。 ',
      'USA': 'Premium and quiet atmosphere, combining, warm and refined materials and sensations, to create effortless places where<br/> gastronomy, well-being, and the spirit of Chinese hospitality are put in perspective to please modern travellers. ',
     },
     acTl2={
      'zh-CN': '美酒佳肴 ',
      'USA': 'Wine & Dine',
     },
     acDF2={
      'zh-CN': '从开启美好一天的早餐，到悠然享用的晚餐，檀程时刻准备着愉悦您的味蕾。您可以在全日餐厅中品尝种类丰富的环球美馔，也可以在中餐厅体验地道中式佳肴与周到服务的双重享受。 ',
      'USA': 'From the most important breakfast to an evening well deserved bite, Arula’s all-day dining welcome guests with a wide array of world delicacies, while the Chinese restaurant is ready to delight taste buds with authentic local cuisine and tailored service.',
     },


     acTl3={
      'zh-CN': '会议 ',
      'USA': 'Meeting',
     },
     acDF3={
      'zh-CN': '无论您是需要召开小型会议还是举办大型会议或庆典，檀程的多功能厅将满足您的各种需求，设计风格现代时尚的会议及宴会厅均配备先进的视听设备。 <br/><br/>专业的会议协调员将全程为您的活动开展提供协助，满足您的所有特定需求。 ',
      'USA': 'Arula Hotels & Resorts offer a choice of facilities ranging from boardroom for executive meeting to ballroom for larger scale events & celebrations, all featuring modern design and state-of-the-art equipment.<br/>A dedicated events coordinator assists you through every planning stage to meet all of your specific needs and requests.',
     },


     joinUs_ad6Des={
      'zh-CN': '成立“旅悦大学”，由酒店行业专家进行授课，统一管理人才输出',
      'USA': '"Lvyue University" was established, which was taught by hotel industry experts and managed talent output in a unified way',
      'JP': '「旅悦大学」を設立し、ホテル業界の専門家による授業を行い、人材輸出を統一的に管理する',
      'KO': '\'여 위 에 대학\' 을 설립 하여 호텔 업계 전문가 가 강 의 를 하고 인 재 를 통일 적 으로 관리 하여 수출 한다.',
      'TH':'การจัดตั้งมหาวิทยาลัยท่องเที่ยวจะสอนโดยผู้เชี่ยวชาญในอุตสาหกรรมโรงแรม',
      'YH':'"trường đại học Lvyuke" được thiết lập bởi các chuyên gia trong ngành khách sạn và quản lý tài năng theo một cách thống nhất'
     },
    joinUs_ad7Title={
         'zh-CN': '一站式采购平台',
         'USA': 'One-stop Purchasing platform',
         'JP': 'ワンストップ仕入れプラットフォーム',
         'KO': '중앙일괄식 구매 플랫폼',
      'TH':'แพลตฟอร์มการจัดซื้อแบบ one-stop',
      'YH':'Nền tảng mua một cửa.'
     },
     joinUs_ad7Des={
      'zh-CN': '全酒店物质供应链统一集采，高效低成本，同时提供专业的民宿设计施工',
      'USA': 'The material supply chain of the whole hotel is unified and centralized, with high efficiency and low cost',
      'JP': '全ホテルの物質供給チェーンは統一的に収集され、高効率で低コストで、同時に専門の民宿設計施工を提供します。',
      'KO': '호텔 전체 물질 공급 체인 을 통일 적 으로 수집 하고 효율 적 이 며 원가 가 낮 으 며 전문 적 인 민 박 설계 시공 도 제공한다.',
      'TH':'ห่วงโซ่อุปทานของวัสดุทั้งหมดของโรงแรมรวมคอลเลกชันที่มีประสิทธิภาพและค่าใช้จ่ายต่ำขณะที่ให้บริการออกแบบและก่อสร้างที่พักมืออาชีพ',
      'YH':'Hệ thống cung cấp vật liệu của cả khách sạn là thống nhất và tập trung, với hiệu quả cao và giá thấp.'
     },
     joinUs_ad8Title={
         'zh-CN': '专业的OTA运营',
         'USA': 'Professional OTA Operations',
         'JP': 'プロなOTA運営',
         'KO': '전문OTA관리 ',
      'TH':'การทำงาน OTA แบบมืออาชีพ',
      'YH':'Hoạt động Đại lý du lịch trực tuyến (OTA) chuyên nghiệp.'
     },
     joinUs_ad8Des={
         'zh-CN': 'OTA精细化运营，一对一服务酒店，从数据分析，竞对模型分析，流量推广，收益排名提升，提供全方位解决方案',
         'USA': 'Providing a full range of revenue-driven solutions for OTA management, including one-to-one service, data and revenue analysis, traffic promotions and ranking improvement assistance.',
         'JP': 'OTAの円滑な運用、１対１のサービスをホテルのデータから分析、競争相手のモデル分析、ネットフロー拡大、収益ランキング向上、全方位的なコンサルティングを提供します',
         'KO': '호텔에대해 데이터분석으로부터 시작한 경쟁사 분석,마켓팅,랭킹관리,솔루션 제공',
      'TH':'การดำเนินงาน OTA อย่างละเอียด บริการโรงแรมแบบตัวต่อตัว ตั้งแต่การวิเคราะห์ข้อมูล การวิเคราะห์รูปแบบจำลองคู่แข่ง การส่งเสริมการขาย การเลื่อนอันดับรายได้ นำเสนอโซลูชั่นแบบครบวงจร',
      'YH':'Hoạt động Đại lý du lịch trực tuyến tốt, khách sạn dịch vụ tương ứng nhau, từ phân tích dữ liệu, bất ngờ đến phân tích mô hình, xúc tiến giao thông, xếp hạng doanh thu, để cung cấp đầy đủ các giải pháp.'
     },
     joinUs_disclaimer={
      'zh-CN': '以上数据来自于已开业门店，每家门店实际情况不一，数据仅作参考。',
      'USA': 'The above data comes from the stores that have opened. The actual situation of each store is different. The data is for reference only.',
      'JP': '以上のデータはすでにオープンした店舗から来ています。店舗ごとに実際の状況が異なります。データは参考にしてください。',
      'KO': '이상 의 데 이 터 는 이미 개업 한 가게 에서 나 온 것 으로 모든 가게 의 실제 상황 이 다 르 기 때문에 데 이 터 는 참고 만 할 수 있 습 니 다. 데이터분석으로부터 시작한 경쟁사 분석,마켓팅,랭킹관리,솔루션 제공',
      'TH':'ข้อมูลข้างต้นมาจากร้านค้าที่เปิดขึ้นสถานการณ์จริงของแต่ละร้านแตกต่างกันข้อมูลใช้สำหรับอ้างอิงเท่านั้น',
      'YH':'Số liệu trên đến từ các cửa hàng đã mở, tình hình thực tế của mỗi cửa hàng là khác nhau, số liệu chỉ mang tính chất tham khảo.'
     },
     joinUs_brandDescFloral={
         'zh-CN': '全球品质民宿酒店',
         'USA': 'International Quality Boutique Hotel Brand',
         'JP': '精美なリゾートブランド',
         'KO': '부티크호텔 리조트',
      'TH':'แบรนด์รีสอร์ทบูติก',
      'YH':'Thương hiệu khu nghỉ dưỡng cỡ nhỏ'
     },
     joinUs_brandDescVyluk={
         'zh-CN': '新一代生活方式酒店品牌',
         'USA': 'Mid-range city hotel',
         'JP': '次世代ライフスタイルシティホテル',
         'KO': '현장사진',
      'TH':'แบรนด์โรงแรมไลฟ์สไตล์ยุคใหม่',
      'YH':'Thương hiệu khách sạn phong cách sống thế hệ mới'
     },
     joinUs_brandDescSuoxing={
         'zh-CN': '轻质连锁酒店品牌',
         'USA': 'Economy Hotel ',
         'JP': '新世代のライフスタイルホテルブランド',
         'KO': '현장사진',
      'TH':'แบรนด์โรงแรมไลฟ์สไตล์ยุคใหม่',
      'YH':'Thương hiệu chuỗi khách sạn hạng nhẹ'
     },
     floralTripTitle1={
             'zh-CN': '花筑旅行APP-酒店预订平台-官网预定折扣-旅悦集团官网',
             'USA': 'Light chain hotel brand',
             'JP': '',
             'KO': '',
      'TH':'',
      'YH':''
         },
      groupmeta={
        'zh-CN': '旅悦(天津)酒店管理有限公司，简称旅悦集团，成立于2016年，是携程集团的战略投资公司，前携程大住宿首席战略官周荣担任集团CEO，是一家集酒店管理、信息技术、采购贸易于一体的旅游产业集团。旅悦集团聚焦于旅游产业链实体的建设与运营，致力于将互联网创新技术应用于传统旅游产业链，实现传统行业建设运营的智能化、科技化发展。',
             'USA': 'Lvyue (Tianjin) Hotel Management Co., Ltd., referred to as Lvyue Group, was founded in 2016. It is a strategic investment company of Ctrip Group. Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group ，served as CEO of the Lvyue Group; Lvyue Group is a tourism industry group integrating hotel management, information technology, procurement and trade. Lvyue Group focuses on the construction and operation of the tourism industry chain, and is committed to applying Internet innovation technology to the traditional tourism industry chain to realize the intelligent, scientific and technological development of the construction and operation of traditional industries.',
      },
      groupkey={
        'zh-CN': '旅悦集团简介,旅悦集团主营业务,酒店管理系统,花筑旅行"',
        'USA': 'Brief introduction of Lvyue Group, main business of Lvyue Group, hotel management system, Floral Trip',
      },
      grouptitle={
        'zh-CN': '关于旅悦-旅悦集团官网',
        'USA': 'About the official website of Lvyue-Lvyue Group ',
      },
      
      teammeta={
        'zh-CN': '旅悦集团CEO周荣，2004年加入携程、2015年加任艺龙首席运营官、2020年2月出任携程大住宿首席战略官，2018年担任携程大住宿事业群首席商务官；2020年，出任旅悦集团CEO，旅悦集团CSO邹正宸 ，2020年出任旅悦集团首席战略官（CSO）；',
        'USA': '旅悦集团CEO周荣，2004年加入携程、2015年加任艺龙首席运营官、2020年2月出任携程大住宿首席战略官，2018年担任携程大住宿事业群首席商务官；2020年，出任旅悦集团CEO，旅悦集团CSO邹正宸 ，2020年出任旅悦集团首席战略官（CSO）；',
      },
      teamkey={
        'zh-CN': '集团领导,旅悦价值观"',
        'USA': 'group leaders, values of Lvyue',
      },
      teamtitle={
        'zh-CN': '集团领导-旅悦集团官网',
        'USA': '  Group Leadership-Lvyue Group Official Website',
      },
      florameta={
        'zh-CN': '花筑是旅悦集团下的首个精品度假酒店品牌，在全球内甄选极致风景，博采众家之长，策集团之力,注意结合当地文化,致力于打造最具文化特质的度假居停空间。',
        'USA': 'Floral is the first boutique resort hotel brand under the Lvyue Group. It selects the best scenic spots in the world, draws on the strengths of various families, makes efforts of the Group, pays attention to the combination of local culture, and devotes itself to creating the most cultural vacation accommodation space.',
      },
      florakey={
        'zh-CN': '花筑酒店,花筑客栈,花筑民宿,花筑设计理念,花筑品牌',
        'USA': 'Floral Hotel, Floral Inn, Floral Residence, Floral Design Concept, Floral Brand',
      },
      floratitle={
        'zh-CN': '花筑酒店、客栈、民宿品牌介绍-旅悦集团官网',
        'USA': 'Brand Introduction of Floral Hotel, Floral Inn and Floral Hostel- Lvyue Group Official Website ',
      },
      suoxingmeta={
        'zh-CN': '索性是旅悦集团下轻质连锁酒店品牌。以“净，如索性”为品牌理念，深度关注用户对于酒店洁净方面的核心诉求，为快节奏的城市客人提供整洁舒适的住宿体验。',
        'USA': 'Suoxing is the light chain hotel brand of Lvyue Group. With the brand concept of "clean, as simple as nature", we pay close attention to users\'core demands for hotel cleanliness and provide clean and comfortable accommodation experience for fast-paced city guests. ',
      },
      suoxingkey={
        'zh-CN': '索性酒店,索性客栈,索性民宿,索性设计理念,索性品牌',
        'USA': 'suoxing hotel, suoxing inn, suoxing accommodation, suoxing design concept, suoxing brand',
      },
      suoxingtitle={
        'zh-CN': '索性酒店、客栈、民宿品牌介绍-旅悦集团官网',
        'USA': 'Brand introduction of suoxing hotel, suoxing Inn and suoxing accommodation -Lvyue Group official website ',
      },
      Vylukmeta={
        'zh-CN': '蔚徕是旅悦集团下主打新一代生活方式的酒店品牌。遴选城市核心地块，“以不凡，见蔚徕”',
        'USA': 'Vyluk is a hotel brand that focuses on the new generation of lifestyle under the Lvyue Group. Selection of urban core plots, " To be extraordinary, to see Weilai ',
      },
      Vylukkey={
        'zh-CN': '蔚徕酒店,蔚徕客栈,蔚徕民宿,蔚徕设计理念,蔚徕品牌',
        'USA': 'Vyluk Hotel, Vyluk Inn, Vyluk Hostel, Vyluk Design Concept, Vyluk Brand',
      },
      Vyluktitle={
        'zh-CN': '蔚徕酒店、客栈、民宿品牌介绍-旅悦集团官网',
        'USA': 'Brand Introduction of Vyluk Hotel, Vyluk Inn and Vyluk Hostel - Lvyue Group Official Website',
      },
      franchmeta={
        'zh-CN': '旅悦集团“携手大数据，拥抱互联网”致力于打造旅游全产业链服务商，提供加盟合作的电话及流程期待您的咨询。如想了解更多酒店加盟信息（加盟政策，汇报投资率等），可拨打加盟热线或留下联系方式，将会有专属加盟顾问为您解答。',
        'USA': 'Lvyue Group" is committed to building a whole tourism industry chain service provider, providing telephone and process of franchise cooperation, looking forward to your consultation. If you want to know more about hotel franchise information (franchise policy, reporting investment rate, etc.), you can call the franchise hotline or leave contact information, there will be exclusive franchise consultants to answer for you.',
      },
      franchkey={
        'zh-CN': '酒店加盟,客栈加盟,民宿加盟,花筑酒店加盟,索性酒店加盟,蔚徕酒店加盟',
        'USA': 'hotel franchise, Inn franchise, residential franchise, Floral Hotel franchise, Suoxing hotel franchise, Vyluk Hotel franchise',
      },
      franchtitle={
        'zh-CN': '酒店加盟优势/政策_热线/电话/流程/咨询-旅悦集团官网',
        'USA': 'Hotel Joining Advantage/Policy/Hotline/Telephone/Process/Consulting-Lvyue Group Official Website',
      },
      floralTripmeta={
        'zh-CN': '花筑旅行APP是旅悦集团旗下酒店官方预订平台，功能包括：酒店预订、会员权益、旅行攻略、旅途社区、主题活动、玩乐门票；更是涵盖旅游攻略、旅行定制、航拍交友等吃、注、行、游、购、娱于一体的真实旅途互动社区。',
        'USA': 'Floral Trip APP" is the official hotel reservation platform of Lvyue Group. Its functions include hotel reservation, membership rights and interests, travel strategy, travel community, theme activities, tickets for fun, and also includes travel strategy, travel customization, aerial photography, friends, food, notes, travel, travel, shopping and entertainment. Real Travel Interactive Community. '
      },
      floralTripkey={
        'zh-CN': '花筑旅行APP,酒店预订APP,花筑旅行APP功能,酒店预订,旅行攻略',
        'USA': ' Floral Trip APP, Hotel Reservation APP, Floral Trip  APP Function, Hotel Reservation, Travel Strategy'
      },
      floralTripTitle={
        'zh-CN': '花筑旅行APP-酒店预订平台-官网预定折扣-旅悦集团官网',
        'USA': 'Floral Trip APP -Hotel Reservation Platform-Official Reservation Discount-Lvyue Group Official Website'
      },
      tanchenmeta={
        'zh-CN': '檀程酒店（ARULA）是旅悦集团旗下的高端酒店及度假村品牌。每一家都独具特色，不仅融合中式热情服务，更与国际化的标准待客之道接轨，带来宾至如归的感受，让每个客人尽享心意之地。',
        'USA':'Arula is a premium hotels and resorts brand of Lvyue Group. Each hotel has its own characteristics, not only the integration of Chinese-style enthusiastic service, but also in line with the international standard way of hospitality, bring a sense of home, so that every guest can enjoy the heart of the place.'
      },
      tanchenkey={
        'zh-CN': '檀程酒店,檀程客栈,檀程民宿,檀程设计理念,檀程品牌',
        'USA':'Arula hotel, Arula Inn, Arula Hostel, Arula design concept, Arula brand'
      },
      tanchentitle={
        'zh-CN': '檀程酒店、客栈、民宿品牌介绍-旅悦集团官网',
        'USA':' Brand Introduction of Arula hotel, Arula Inn, Arula Hostel and Arula brand- Lvyue Group Official Website'
      },

      bainaDesign={
        'zh-CN': '柏纳设计理念',
        'USA':'Design Philosophy of Urba Hotel',
        'JP':''
      },
      bainaDesignType1={
        'zh-CN': '生活平衡',
        'USA':'Balance',
        'JP':''
      },
      bainaDesignType2={
        'zh-CN': '智能空间',
        'USA':'Smart',
        'JP':''
      },
      bainaDesignType3={
        'zh-CN': '周到服务',
        'USA':'Thoughtful',
        'JP':''
      },
      bainaBrandIntroductionTitle={
        'zh-CN': 'Urba 柏纳品牌介绍',
        'USA':'Urba Hotel-Brand Introduction',
        'JP':'柏纳·ブランド紹介'
      },
      bainaBuildingaboutfbType1={
        'zh-CN': '中端商务酒店',
        'USA':'Mid-range Business Hotel',
        'JP':'ビジネスホテル'
      },
      bainaBrandIntroductionInfo={
        'zh-CN': '柏纳酒店聚焦商旅客人对酒店的核心诉求，提供舒适和实用之间的微妙平衡，专注舒适的环境和一流的服务。每一家柏纳酒店都是独一无二的，所有酒店都致力于为客人提共舒适的环境和一流的服务，以满足客人真正需要的高品质标准。',
        'USA':'Urba Hotel focuses on the core demands of business travelers, providing a delicate balance between comfort and practicality, focusing on a comfortable environment and first-class service. Every Urba hotel is unique and all hotels strive to provide guests with a comfortable environment and first-class service to meet the high standards of quality that guests really need.',
        'JP':'柏纳ホテルは、ホテルに対するビジネス旅行者のコアな要求を中心し、快適な環境と一流のサービスに焦点を当て、快適さと実用性なバランスを重視します。 すべての柏纳ホテルはユニークであり、お客様に高水準のサービス品質を提供し、快適な環境と一流のサービスをお客様に提供するよう努めています。'
      },
      bainaBuildingaboutfbType3={
        'zh-CN': 'Urba柏纳酒店—聚焦你的基础需求，毫不复杂，又让人安心。',
        'USA':'Urba Hotel - focus on your basic needs, uncomplicated and reassuring.',
        'JP':'Urba柏纳ホテル-あなたの基本的なニーズに中心、シンプルで安心。'
      },

      bnTl1={
        'zh-CN': '酒店环境',
        'USA':'Hotel Environment'
      },
      bnDF1={
        'zh-CN': '作为一个中端城市酒店<br/>柏纳酒店注重为商务和休闲旅游人群提供简约时尚的设计空间<br/>以便利周到的服务设施',
        'USA':'As a mid-range City Hotel<br/>Urba Hotel focuses on providing a simple and stylish design space for business and leisure travelers with convenient and thoughtful service facilities'
      },
      bnTl2={
        'zh-CN': '房间',
        'USA':'Room'
      },
      bnDF2={
        'zh-CN': '简单的设计<br/>为休息提供优雅的氛围<br/>为工作唤醒清醒的头脑',
        'USA':'simple design<br/>Provides an elegant atmosphere for rest<br/>Awaken a clear mind for work'
      },
      bnTl3={
        'zh-CN': '活力餐厅',
        'USA':'Restaurant'
      },
      bnDF3={
        'zh-CN': '清晨：提供早餐，平衡食物的乐趣<br/>用当地特产开始新的一天<br/>西式早餐可选<br/>健康选择：果汁<br/>早、中、晚客人可自由用来工作<br/>提供简单便宜的茶点<br/>如果提前提需求，餐厅可以被用做会议室（提供简单的茶歇，雇佣临时服务生）<br/>提供屏幕和投影仪',
        'USA':'Early morning: serving breakfast, the joy of balanced food<br/>Start the day with local specialties<br/>Western breakfast optional<br/>Healthy Choice: Juice<br/>Guests are free to work in the morning, noon and evening<br/>Provide simple and cheap refreshments<br/>The restaurant can be used as a meeting room if requested in advance (provide a simple coffee break, hire temporary waiters)<br/>Provide screen and projector'
      },
      bnTl4={
        'zh-CN': '商务中心',
        'USA':'Business center'
      },
      bnDF4={
        'zh-CN': '配有小型商务中心<br/>拥有电脑、打印机等商务设施<br/>满足客人随时随地的工作需求',
        'USA':'Equipped with a small business center<br/>Business facilities such as computers and printers<br/>Meet the needs of customers anytime, anywhere'
      },
      banlanDesign={
        'zh-CN': '般蓝设计理念',
        'USA':'Design Philosophy of Banlan',
        'JP':''
      },
      banlanDesignType1={
        'zh-CN': '隐世设计',
        'USA':'Hidden',
        'JP':''
      },
      banlanDesignType2={
        'zh-CN': '淡泊雅致',
        'USA':'Elegant',
        'JP':''
      },
      banlanDesignType3={
        'zh-CN': '动静交融',
        'USA':'Fusion',
        'JP':''
      },
      banlanBrandIntroductionTitle={
        'zh-CN': '般蓝·品牌介绍',
        'USA':'Banlan-Brand Introduction',
        'JP':'般蓝·ブランド紹介'
      },
      banlanBuildingaboutfbType1={
        'zh-CN': '隐世设计酒店',
        'USA':'Seclusion Design Hotel',
        'JP':'隠された世界のホテル'
      },
      banlanBrandIntroductionInfo1={
        'zh-CN': '盘蓝致力于颠覆人们对于高星酒店的传统认知，在都市核心地段构建出喧闹尘世的逆行空间，营造出世与入世的不同心境。',
        'USA':'Banlan is committed to subverting people\'s traditional perception of high-star hotels, building a retrograded space of noisy world in the core area of the city, and creating a different mood between entering and exiting of the world.',
        'JP':'般蓝は、伝統的な高級ホテルの認識を覆し、街の中心部に華やかなレトログラードスペースを構築し、出世から入世までの様々なムードを作り出すことに取り組んでいます。'
      },
      banlanBrandIntroductionInfo2={
        'zh-CN': '般蓝将东方文化元素与自然之美解构融合，淡泊雅致的美学设计、动静交融的空间规划、全观感观沉浸式氛围营造，把人们从繁忙中短暂抽离，放松身',
        'USA':'Banlan deconstructs and integrates oriental cultural elements and the beauty of nature, with indifferent and elegant aesthetic design, dynamic and static space planning, and full-view immersive atmosphere creation, which temporarily pulls people away from the busyness,',
        'JP':'般蓝は、東洋の文化的な要素と自然の美しさを統合し、エレガントな美的デザイン、動と静な空間計画、没入型の雰囲気を作成し、忙しい日々を引き離し、体と心をリラックスさせ、「心远地自偏」との宿泊体験し、感覚と心を目覚めさせ、別の平行した空間で活躍させます。'
      },
      banlanBrandIntroductionInfo3={
        'zh-CN': '心，充分感受到“心远地自偏”的入住体验，让感观和心灵被唤醒，在别样的平行空间里焕发活力。',
        'USA':'relaxes their body and mind, and fully feels the stay experience of "far from the heart", awakens the senses and mind, and rejuvenates in a different parallel space.',
        'JP':''
      },
      banlanBuildingaboutfbType3={
        'zh-CN': '入则悦心性，出则尽繁华',
        'USA':'Entering is joyful, and exiting is full of prosperity',
        'JP':'入るのは楽しいし、出るのは繁栄に満ちている'
      },
      beuDesign={
        'zh-CN': '',
        'USA':'Design Philosophy of beu',
        'JP':''
      },
      beuDesignType1={
        'zh-CN': '',
        'USA':'Warm',
        'JP':''
      },
      beuDesignType2={
        'zh-CN': '',
        'USA':'Clean',
        'JP':''
      },
      beuDesignType3={
        'zh-CN': '',
        'USA':'Convenient',
        'JP':''
      },
      beuBrandIntroductionTitle={
        'zh-CN': '',
        'USA':'beu-Brand Introduction',
        'JP':'エコノミーホテル'
      },
      beuBuildingaboutfbType1={
        'zh-CN': '',
        'USA':'India Business Chain Hotel',
        'JP':'エコノミーホテル'
      },
      beuBrandIntroductionInfo={
        'zh-CN': '',
        'USA':'A warm welcome, a deep sleep, a power shower, an energising breakfast and tasty meals, creative meeting spaces<br/>Your stay with us is spirited all along the way, Clean and Convenient facilities, a refreshing and inviting atmosphere, enthusiastic and thoughtful attantion, <br/>beu hotels focus on the quality of guests’ indispensables to offer a pleasant experience for both business and leisure travellers.<br/>Sleepy or hungry? Relaxed of busy? Mellow or playful?<br/>Whatever your mood',
        'JP':'エコノミーホテルは特徴がないという意味ではありません！温かいおもてなし、深い眠り、強力なシャワー、春の朝のような朝食、おいしい食事、個性的な会議...ご滞在中は元気が溢れます。清潔で便利な施設、爽やかで居心地の良い雰囲気、熱心で思慮深い声かけ、beuホテルは、ビジネス客と観光客の両方に快適な体験を提供するため、品質に細心の注意を払っています。眠たい？お腹が空いていますか？、リラックス？遊び？勉強ですか？どのようなご要望にもご満足いただけます。あなたの発想は無制限'
      },
      beuBuildingaboutfbType3={
        'zh-CN': '',
        'USA':'Live clean and comfortable',
        'JP':'あなたらしく'
      },
      floralLuxDesign={
        'zh-CN': '花筑奢·设计理念',
        'USA':'Design Philosophy',
        'JP': '花筑奢・ブランド紹介',
      }
      floralLuxDesignType1={
        'zh-CN': '秘境',
        'USA':'Serene Leisure',
        'JP': '秘境',
      }
      floralLuxDesignType2={
        'zh-CN': '隅居',
        'USA':'Oriental Grace',
        'JP': '隅居',
      }
      floralLuxDesignType3={
        'zh-CN': '闲适',
        'USA':'',
        'JP': '闲适',
      }
      floralLuxDesignType4={
        'zh-CN': '风雅',
        'USA':'',
        'JP': '風雅',
      }
      floralLuxBrandIntroductionTitle={
        'zh-CN': '花筑奢·品牌介绍',
        'USA':'Brand Overview',
        'JP': '花筑奢・ブランド紹介',
      }
      floralLuxBuildingaboutfbType1={
        'zh-CN': '2017年初，为进军高端度假民宿领域，花筑高阶品牌系列——「花筑奢」应运而生，致力于打造融合地缘文化与奢华体验的理想空间。',
        'USA':'Floral Lux Hotel, established in 2017, is a luxury resort brand dedicated to redefining premium travel experiences. Combining stunning natural landscapes with refined hospitality, Floral Lux Hotel offers travelers an idyllic retreat that seamlessly blends high-end services with authentic local culture. The brand creates a heartfelt connection between breathtaking scenery and the warmth of human interaction, crafting unforgettable vacation moments.',
        'JP': '2017年初頭、高級リゾート民宿分野への進出を目指し、花筑のハイエンドブランドシリーズ「花筑奢」が誕生しました。地元の文化と豪華な体験を融合させた理想的な空間を創造することを目指しています。',
      }
      floralLuxBrandIntroductionInfo1={
        'zh-CN': '未至之境，宿之大雅。',
        'USA':'',
        'JP': '未至の境、宿の大雅。',
      }
      floralLuxBrandIntroductionInfo2={
        'zh-CN': '凭借绝妙风景与精致体验，花筑奢为旅行者创造了理想的度假生活。通过十七个精心设计的服务触点和细化的服务标准，花筑奢最大限度将高端酒店服务与地方人文体验融会贯通，构筑起风景与人情间的温情链接，打造令人神往的美好度假场景。',
        'USA':'With a portfolio of over 100 boutique resorts across 50 cities in China, Floral Lux Hotel celebrates the unique charm of each location. Every Floral Lux Hotel property is a one-of-a-kind masterpiece, every property is deeply rooted in its local culture, transforming traditional architecture into extraordinary spaces that reflect the essence of their surroundings.',
        'JP': '絶妙な景観と洗練された体験を通じて、花筑奢は旅行者に理想的なリゾートライフを提供します。17の綿密に設計されたサービス接点と詳細なサービス基準を通じて、花筑奢は高級ホテルのサービスと地域の文化体験を最大限に融合し、風景と人情の間に温かい絆を築き、魅力的なリゾートシーンを創造します。',
      }
      floralLuxBrandIntroductionInfo3={
        'zh-CN': '每一处花筑奢，即是独一无二的高颜值精品，也是享受精致卓越体验的现代桃花源。它不仅是旅行者梦中的目的地，更是高端民宿与地方文化的完美交汇。',
        'USA':'',
        'JP': 'それぞれの花筑奢は、唯一無二の高い美しさを持つブティックであり、洗練された卓越した体験を楽しむ現代の桃源郷でもあります。それは旅行者の夢の目的地であるだけでなく、高級民宿と地域文化の完璧な交差点でもあります。',
      }
      floralLuxBuildingaboutfbType3={
        'zh-CN': '花筑奢的愿景，让世界看到中国高端民宿之美。',
        'USA':'The vision of floral Luxury is to showcase the beauty of China’s high-end homestays to the world.',
        'JP': '花筑奢のビジョンは、世界に中国の高級民宿の美しさを見せることです。',
      }

      commonCustomerServiceHotline_china={
        'zh-CN': 'China：400-898-7118',
        'USA': 'China：400-898-7118',
        'JP': '中国：400-898-7118',
        'KO': 'China：400-898-7118 ',
        'TH':'China：400-898-7118',
        'YH':'China：400-898-7118'
      },
      commonCustomerServiceHotline_japan={
        'zh-CN': 'Japan：06-4256-2628',
        'USA': 'Japan：06-4256-2628',
        'JP': '日本：06-4256-2628',
        'KO': 'Japan：06-4256-2628 ',
        'TH':'Japan：06-4256-2628',
        'YH':'Japan：06-4256-2628'
      }





/** WEBPACK FOOTER **
 ** ./src/js/language.js
 **/